<template>
  <!-- ChatGPT-like Main Container -->
  <div class="chatgpt-container" v-if="Status_Error == false">
    <div v-if="mdAndUp" class="custom-fixed-top-area" style="
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
      ">
      <!-- White BG -->
      <div style="
          position: absolute;
          background-color: white;
          width: 100%;
          height: 50px;
          margin-top: -80px;
        "></div>
      <!-- White BG -->
      <span style="font-weight: bold"></span>

      <v-col :cols="!snippet_Status ? '10' : '6'" :style="'margin:0px'" style="
          padding: 0px;
          font-size: 15px;
          display: flex;
          justify-content: flex-end;
        ">
        <div style="
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 20px;
          ">
          <label 
            class="model-label-fade-in"
            style="color: #71717a;display: flex;">
            Model {{ ModelFirst == "" ? "" : ModelFirst }}
            <div style="max-width: 175px; overflow: hidden; text-overflow: ellipsis; margin-left: 5px;">
              {{ TopicName == "" ? "" : TopicName }}
            </div>
          </label>
        </div>
      </v-col>
    </div>

    <div class="main-scrollable-content-area" ref="MainScrollArea">
      <!-- Messages Area (scrollable) -->
      <div class="messages-container" ref="ChatContainerRef" v-show="listMessage.length > 0">
        <div class="messages-wrapper">
          <div id="ChatScreId" class="messages-scroll-area" ref="ChatScreRef">
            <div class="messages-content">
              <v-col cols="12" v-if="Loading_History_Status == true">
                <v-progress-linear indeterminate :color="selectedColor" class="mb-0"></v-progress-linear>
              </v-col>
              <div v-for="(item, index) in listMessage" :id="'ChatId_' + item.id" :key="index" style="
                  font-family: Roboto, sans-serif !important;
                  font-style: normal;
                ">
                <v-row style="margin: 0px" v-if="item.messageUser != null">
                  <v-col col="12">
                    <div class="d-flex align-end justify-end" v-if="
                      item.messageUser != null &&
                      (index > 0
                        ? listMessage[index - 1].messageBot
                        : item.messageBot != null)
                    " :class="xsOnly ? 'flex-row' : ''">
                      <div style="
                          float: right;
                          align-self: center;
                          margin-right: 6px;
                        ">
                        <label style="
                            font-size: 10px;
                            color: rgb(113, 113, 122);
                            margin-bottom: 0px;
                          ">
                          {{ item.requestTime }}
                        </label>
                      </div>
                      <div style="float: right; align-self: center">
                        <label>You</label>
                      </div>
                      <div>
                        <v-btn icon text style="
                            float: right;
                            margin-bottom: 5px;
                            margin-right: 15px;
                            margin-left: 15px;
                            font-size: 16px;
                            font-family: inter, sans-serif;
                            font-style: normal;
                            background: #d96666;
                            color: rgb(255, 255, 255, 1);
                          " disabled fab width="34px" height="34px" :style="'background: #' +
                            (NavbarBtnColorTheme != null ||
                              NavbarBtnColorTheme != undefined
                              ? NavbarBtnColorTheme
                              : 'D96666')
                            ">
                          <div v-if="
                            User_Id_Show != null &&
                            User_Id_Show != '' &&
                            User_Id_Show != undefined
                          " class="text-uppercase" style="
                              font-size: 16px;
                              font-family: inter, sans-serif;
                              font-style: normal;
                              color: rgb(255, 255, 255, 1) !important;
                            " :style="'color: #' +
                              (NavbarTxtColorTheme != null ||
                                NavbarTxtColorTheme != undefined
                                ? NavbarTxtColorTheme
                                : 'FFFFFF') +
                              ' !important'
                              ">
                            {{ User_Id_Show.substring(0, 2) }}
                          </div>
                          <v-icon v-else class="text-uppercase" style="
                              font-size: 16px;
                              font-family: inter, sans-serif;
                              font-style: normal;
                              color: rgb(255, 255, 255, 1) !important;
                            " :style="'color: #' +
                              (NavbarTxtColorTheme != null ||
                                NavbarTxtColorTheme != undefined
                                ? NavbarTxtColorTheme
                                : 'FFFFFF') +
                              ' !important'
                              ">
                            'mdi-account'
                          </v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <div :class="xsOnly ? 'd-flex flex-row justify-end' : ''" style="
                        line-break: anywhere;
                        padding: 0px 4px;
                        border-radius: 16px 3px 16px 16px;
                        font-size: 16px;
                        font-weight: 400;
                        color: #71717a;
                        line-height: 22px;
                        display: flex;
                        width: fit-content;
                        float: right;
                        min-height: 35px;
                      " :style="mdAndUp
                        ? 'max-width: 80%;  margin-top:2px;  margin-right: 6px;  background: rgb(235,235,235);'
                        : xsOnly
                          ? 'max-width: 100%; background: rgb(235,235,235);'
                          : 'max-width: 80%; margin-top:2px;  margin-right: 6px;  background: rgb(235,235,235);'
                        ">
                      <MarkdownIt :content="item.messageUser" style="color: #71717a" />
                      <!-- <vue-markdown id="V_markDown" :anchor-attributes="anchorAttrs" :source="item.messageUser"
                          style="color: #71717A;">
                        </vue-markdown> -->
                      <!-- {{ item.messageUser }} -->
                    </div>
                  </v-col>
                </v-row>
                <v-row style="margin: 0px" v-if="
                  item.status_Process != 'VoiceStart' &&
                  item.status_Process != 'ChatChain' &&
                  item.messageBot != null
                ">
                  <v-col col="12">
                    <div class="d-flex flex-row align-end justify-start" v-if="
                    item.messageBot != null && (index > 0
                        ? listMessage[index - 1].messageUser
                        : item.messageUser != null)"
                        :class="xsOnly ? 'justify-start align-center' : ''">
                      <div style="
                          float: left;
                          height: 35px;
                          width: 35px;
                          border-radius: 50%;
                          text-align: center;
                          background-color: white;
                          margin-top: 10px;
                          margin-right: 15px;
                        ">
                        
                        <div class="rotating-element" v-if="item.status_Process == 'Process'" style="display: flex; justify-content: center; align-items: center; position: relative;margin-top: -5px;scale: .8;">
                            <div class="botloader"></div>
                            <div class="botringloader" style="position: absolute;"></div>
                        </div>
                        <v-icon v-else-if="!isImgIconChat" style="font-size: 30px;margin-top: -5px;" :style="'color:' + selectedColor + ';'">
                          {{
                            ChatbotIcon != null
                              ? ChatbotIcon
                              : "mdi-robot-outline"
                          }}
                        </v-icon>
                        <v-img v-else style="height: 36px; width: 36px; border-radius: 50%" :src="IconChat" />
                      </div>
                      <div style="align-self: center">
                        <!-- add name bot -->
                        <label>{{ ChatbotName }}</label>
                      </div>
                      <div style="margin-left: 6px; align-self: center">
                        <label style="
                            font-size: 10px;
                            color: rgb(113, 113, 122);
                            margin-bottom: 0px;
                          ">
                          {{ item.responseTime }}
                        </label>
                      </div>
                    </div>
                    <div class="d-flex flex-row" :class="xsOnly ? 'justify-start' : ''">
                      <div v-if="item.status_Process == 'Process'" style="
                          font-size: 16px;
                          font-weight: 400;
                          float: left;
                          width: 135px;
                        ">
                        <div v-if="isTextToImageLocal" style="display: flex; justify-content: center; align-items: center; position: relative;height: 180px; margin-left: 90px; margin-bottom: 16px;">
                          <div class="imgloader" style="position: absolute;"></div>
                          <div class="frameloader" style="position: absolute;"></div>
                        </div>
                      </div>

                      <div v-else-if="item.status_Process == 'Send_Message' || item.status_Process == 'END'"
                        style="padding: 0px 15px 10px 15px;border-radius: 8px;font-size: 16px;color: #71717a;line-height: 22px;display: flex;width: fit-content;float: left;max-width: 100%;"
                        @click="botMessageClick(item.messageBot)" :style="xsOnly ? 'max-width: 100%;' : 'max-width: 80%;'
                          ">
                        <!-- <vue-markdown id="V_markDown" :anchor-attributes="anchorAttrs" :source="item.messageBot"
                            style="color: #71717A;">
                          </vue-markdown> -->
                        <MarkdownIt style="padding-top: 5px !important;" :key="rerenderKey" :content="item.messageBot" />
                      </div>

                      <!-- Error -->
                      <div v-else style="line-break: anywhere;padding: 16px 20px;background: rgb(249, 249, 249);border-radius: 8px;font-size: 16px;font-weight: 400;
                        line-height: 22px;white-space: pre-line;width: fit-content;float: left;"
                        :style="xsOnly ? 'max-width: 100%; background: rgb(255,255,255);' : 'max-width: 80%; background: rgb(249,249,249);'">
                        <!-- <vue-markdown id="V_markDown" :anchor-attributes="anchorAttrs" :source="item.messageBot" 
                            style="color: #71717A;">
                          </vue-markdown> -->
                        <MarkdownIt :content="item.messageBot" />
                        <span>...{{ item.status_Process }}</span>
                      </div>
                    </div>
                    <div v-if="item.status_Process == 'END'" style="float: left; margin-top: -25px; margin-left: 20px">
                      <v-btn size="small" variant="text" icon :color="selectedColor" @click="Clipboard(item)">
                        <v-icon size="20px">mdi-content-copy</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="
                      ((!Snippet_Username == false && Snippet_StatusData) ||
                        !Snippet_StatusData) &&
                      item.isFeedback &&
                      item.status_Process == 'END' &&
                      ![
                        ':model',
                        ':userid',
                        ':clearmemory',
                        ':memory',
                        ':help',
                        ':lastmemory',
                      ].some((keyword) =>
                        item.messageUser
                          .toLowerCase()
                          .includes(keyword.toLowerCase())
                      )
                    " style="float: left; margin-top: -25px">
                      <!-- Like , DisLike Button -->
                      <!-- {{ item }} -->
                        
                      <v-btn v-if="item.status == null || item.status == 0" size="small" variant="text" icon
                        :color="selectedColor" @click="ThisFeedBackResponse(item, 1)">
                        <v-icon size="20px">mdi-thumb-up-outline</v-icon>
                      </v-btn>
                      <v-btn v-else-if="item.status == 1" size="small" variant="text" icon :color="selectedColor"
                        @click="
                          item.status = null;
                        closeDialog(item);
                        ">
                        <v-icon size="20px">mdi-thumb-up</v-icon>
                      </v-btn>

                      <v-btn :value="0" v-if="item.status == null || item.status == 1" size="small" variant="text" icon
                        :color="selectedColor" @click="openCommentDialog(item, index)">
                        <v-icon size="20px">mdi-thumb-down-outline</v-icon>
                      </v-btn>

                      <v-btn :value="0" v-else-if="item.status == 0" size="small" variant="text" icon
                        :color="selectedColor" @click="
                          item.status = null;
                        closeDialog(item);
                        ">
                        <v-icon size="20px">mdi-thumb-down</v-icon>
                      </v-btn>
                    </div>
                  </v-col>
                  <v-expand-transition v-show="item.commentDialog">
                    <div style="
                        width: calc(100vi - 24px);
                        position: sticky;
                        bottom: 4px;
                      ">
                      <v-card class="mx-auto" outlined>
                        <v-card-title>
                          Tell us more:
                          <v-spacer></v-spacer>
                          <v-btn @click="
                            item.commentDialog = false;
                          item.status = null;
                          " style="float: right; margin-top: -20px" size="small" icon>
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-subtitle>
                          Provide additional feedback
                        </v-card-subtitle>
                        <v-card-text :class="!item.moreComment ? 'pb-4' : 'pb-0'" class="py-0">
                          <!-- {{item.SelectComment}} -->
                          <v-chip-group column v-model="item.SelectComment">
                            <!-- {{item.SelectComment }} -->
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment =
                              item.comment != `Don't like the style`
                                ? `Don't like the style`
                                : ''
                              ">
                              Don't like the style
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment =
                              item.comment != `Not factually correct`
                                ? `Not factually correct`
                                : ''
                              ">
                              Not factually correct
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment =
                              item.comment !=
                                `Didn't fully follow instructions`
                                ? `Didn't fully follow instructions`
                                : ''
                              ">
                              Didn't fully follow instructions
                            </v-chip>
                            <v-chip filter class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment =
                              item.comment !=
                                `Refused when it shouldn't have`
                                ? `Refused when it shouldn't have`
                                : ''
                              ">
                              Refused when it shouldn't have
                            </v-chip>
                            <v-chip class="ma-1" :color="selectedColor" text-color="white" @click="
                              item.comment = '';
                            item.moreComment = !item.moreComment;
                            ">
                              More...
                            </v-chip>
                          </v-chip-group>
                        </v-card-text>
                        <v-card-text v-show="item.moreComment">
                          <v-textarea @click.stop="" rows="2" auto-grow row-height="5" v-model="item.comment"
                            counter="100" maxlength="100" outlined solo label="More details"></v-textarea>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end">
                          <v-btn dense plain :disabled="item.comment == null || item.comment == ''
                            " rounded :color="selectedColor" class="mb-4 mr-4" @click="ThisFeedBackResponse(item, 0)">
                            Send
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </div>
                  </v-expand-transition>
                </v-row>
              </div>
              <div ref="ChatRef"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Welcome Screen when no messages -->
      <div v-show="!(listMessage.length > 0) && Loading_History_Status == false" class="welcome-screen">
        <div class="welcome-content">
          <h1 class="welcome-title">Welcome to Chat Framework</h1>
          <p class="welcome-subtitle">How can I help you today?</p>
        </div>

        <!-- Shortcut Menu -->
        <div v-if="ShortcutMenu.length > 0">
          <v-container fluid class="d-flex justify-center align-center overflow-x-auto px-12 carousel-container">
            <v-btn icon class="scroll-btn" @click="scrollLeft" v-show="showLeftButton">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <div ref="scrollContainer" class="d-flex overflow-x-auto carousel-track" @scroll="onScroll">
              <div v-for="(item, index) in ShortcutMenu" v-bind:key="index">
                <v-card class="rounded-xl text-center content-button" v-on:click="selectCard(item.command)" flat
                  color="#F0F4F6" width="250px">
                  <v-card-text>
                    <v-avatar class="mx-auto mb-2" size="40">
                      <img v-if="item.imageURL" :alt="'shortcut-comand-img' + index" height="40" :src="item.imageURL"
                        width="40" />
                      <v-icon v-else size="40" color="yellow darken-3 ">
                        mdi-lightbulb-on-outline
                      </v-icon>
                    </v-avatar>
                    <h2 class="text-lg font-semibold">
                      {{ item.nameDisplay }}
                    </h2>
                    <p class="text-gray-600">
                      {{ item.command }}
                    </p>
                  </v-card-text>
                </v-card>
              </div>
            </div>
            <v-btn icon class="scroll-btn" @click="scrollRight" v-show="showRightButton">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-container>
        </div>
      </div>

      <!-- Product Recommendations (now positioned properly) -->
      <div v-show="products && products.length > 0 && !hideProducts" class="product-recommendations-section">
        <div class="product-recommendations" >
          <h3 class="recommendations-title">Recommended Products</h3>
          <div class="product-grid">
            <div v-for="(product, index) in products" :key="index" class="product-card">
              <div class="product-content" @click="showProductDetail(product)">
                <img v-if="product.ProductImg" :src="product.ProductImg" :alt="product.name" class="product-image" />
                <div  v-else class="container-product-image">
                  <img src="../assets/images/product_default.png" :alt="product.name" class="product-default-image-recommendation" />
                </div>
                <div class="product-info">
                  <h4 class="product-name">{{ product.ProductName }}</h4>
                  <p class="product-description">{{ product.description }}</p>
                  <div class="product-price">
                    {{
                      product.ProductPrice
                        ? `฿${product.ProductPrice.toLocaleString()}`
                        : "ติดต่อสอบถาม"
                    }}
                  </div>
                  <v-btn rounded="lg" class="product-button" color="#FB8C00" @click="selectProduct(selectedProductDetail)">
                    สนใจ
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Fixed Bottom Input Area (ChatGPT-style) -->
    <div class="fixed-input-container">
      <div class="scroll-bottom-btn" @click="SetBottom_Page" v-show="showScrollToBottomButton">
        <v-icon color="rgba(0, 0, 0, 0.5)">mdi-arrow-down</v-icon>
      </div>
      <div class="input-wrapper-chatgpt">
        <!-- File Preview Area -->
        <div v-if="fileDataUrl != null || pickedFileType != null" class="file-preview-container">
          <!-- Image Preview -->
          <div v-if="fileDataUrl != null" class="image-preview-wrapper">
            <div class="image-preview-card">
              <img :src="fileDataUrl" alt="img-upload" class="preview-image" />
              <v-progress-circular v-show="loadingImage == true" class="preview-loading" indeterminate color="primary"
                size="24"></v-progress-circular>
              <v-btn v-show="loadingImage == false" icon size="small" class="preview-close-btn" @click="ClearImage()">
                <v-icon size="16">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>

          <!-- File Preview -->
          <div v-if="pickedFileType != null" class="file-preview-wrapper">
            <div class="file-preview-card">
              <div class="file-preview-content">
                <div class="file-icon-section">
                  <img :src="pickedFileType" alt="file-type" class="file-type-icon" />
                  <v-progress-circular v-if="!uploadFileComplete" indeterminate color="primary" size="20" width="2"
                    class="file-loading-overlay"></v-progress-circular>
                </div>
                <div class="file-info-section">
                    <div class="file-name-text">
                    {{ pickedFileName.length > 30 ? pickedFileName.substring(0, 30) + '...' : pickedFileName }}
                    </div>
                  <v-progress-linear v-if="
                    !uploadFileComplete ||
                    (dataAll > 0 && dataUpdate < dataAll)
                  " :value="(dataUpdate / dataAll) * 100" color="primary" background-color="rgba(0,0,0,0.1)"
                    class="file-upload-progress" height="2" rounded></v-progress-linear>
                </div>
              </div>
              <v-btn icon size="small" class="preview-close-btn" @click="ClearUploadedFile()">
                <v-icon size="16">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </div>

        <!-- Main Input Row -->
        <div class="input-row-container">
          <!-- @keydown.enter.shift="Key_Ctrl_Flag = true" -->
          <!-- @keyup.enter="SendOpenAi('Enter'); Key_Ctrl_Flag = false;" -->
          <!-- :disabled="(listMessage.length > 0 && listMessage[listMessage.length - 1].status_Process != 'END' && listMessage[listMessage.length - 1].status_Process != 'Stop' && listMessage[listMessage.length - 1].status_Process != 'Error')" -->
          <!-- @keyup.enter.shift="Shift_Enter_MessageData" -->
          <!-- @keydown.enter.ctrl.exact.prevent="Ctrl_Enter_MessageData" -->
          <!-- Central Textarea -->
          <div class="textarea-container-chatgpt">
            <v-textarea id="D_MessageData2" ref="RefMessageData" v-model="messageData" class="chatgpt-textarea"
              variant="outlined" hide-details rows="1" auto-grow :max-rows="6" placeholder="Ask anything..."
              @paste="onPaste" @click:clear="messageData = ''" :maxlength="maximumChatInput"
              @keydown.enter.exact.prevent="SendOpenAi('Enter')"></v-textarea>
          </div>
        </div>

        <!-- AI Disclaimer -->
        <div class="footer-chatbox-section">
          <!-- Left Action Buttons -->
          <div class="input-actions-left">
            <!-- Model Selection Menu -->
            <div>
              <v-menu v-model="showMenu" location="top start" offset-y rounded="lg" 
              :close-on-content-click="false" style="padding-bottom: 0; margin-bottom: 0;min-width: 220px;max-width:250px">
                <template v-slot:activator="{ props: menuProps }">
                  <v-btn variant="text" icon v-bind="menuProps" :style="ModelQuick.length == 0 ? 'display:none;' : ''" 
                    class="model-selector-btn">
                    <!-- <div id="quickGroup" style="
                        width: 24px;
                        height: 24px;
                        display: flex;
                        justify-content: center;
                      " v-html="svgContent">
                      </div> -->
                      <img src="../assets/images/Model.svg" alt="" 
                        style="width: 24px; height: 24px;">
                  </v-btn>
                </template>
                  <v-card flat class="pa-0 model-card-container">
                    <!-- Compact search bar -->
                    <v-text-field
                      v-model="modelSearchQuery"
                      variant="solo-filled"
                      density="compact"
                      hide-details
                      placeholder="Search models..."
                      class="mx-2 mt-2 modern-model-search"
                      clearable
                      color="primary"
                    >
                      <template #prepend-inner>
                        <v-icon size="16" color="primary">mdi-magnify</v-icon>
                      </template>
                    </v-text-field>
                    
                    <v-divider class="my-1 divider-light"></v-divider>
                    
                    <!-- Streamlined model list -->
                    <div style="min-height: 280px; max-height: 280px; overflow-y: auto;" class="model-list-container pa-0">
                      <div 
                        v-for="(item, index) in filteredModels" 
                        :key="index" 
                        class="model-item d-flex align-center justify-start px-2 py-2"
                        :class="{'model-item-active': isActiveModel(item)}"
                        :style="isActiveModel(item) ? `background-color: ${selectedColor}10 !important` : ''"
                        @click="selectModel(item)"
                      >
                        <div class="model-avatar-wrapper mr-2 my-0">
                          <div 
                            class="model-avatar" 
                            :style="`background-color: ${isActiveModel(item) ? selectedColor+'22' : 'white'}`"
                          >
                            <img 
                              v-if="item.imageBase64 != '' && item.imageBase64 != null" 
                              :src="item.imageBase64" 
                              style="width: 12px; height: 12px;"
                            />
                            <i v-else class="mdi mdi-book-education" :style="`color: ${selectedColor}; font-size: 10px;`"></i>
                          </div>
                        </div>
                        <div class="model-content py-0">
                          <div 
                            class="model-title text-caption text-truncate" 
                            :class="{'font-weight-medium': isActiveModel(item)}"
                            :style="`color: ${isActiveModel(item) ? selectedColor : '#424242'} !important`"
                          >
                            {{ item.modelName }}
                          </div>
                        </div>
                        <div v-if="isActiveModel(item)" class="model-action ma-0 mr-1 my-0">
                          <i class="mdi mdi-check" :style="`color: ${selectedColor}; font-size: 12px;`"></i>
                        </div>
                      </div>
                    </div>
                    
                    <v-divider class="divider-light mb-1"></v-divider>
                    
                    <!-- Compact card actions -->
                    <div class="py-0 px-2 custom-card-actions">
                      <v-checkbox
                        v-if="ModelQuick.length != 0 ? (
                        (ModelQuick.some(i => i.typeModel == 1) && 
                        ModelQuick.some(i => i.typeModel == 2)) ? true : false)
                        : false"
                        v-model="menuGroupModel"
                        :color="selectedColor"
                        dense
                        hide-details
                        class="mt-0 model-view-toggle"
                        @change="handleMenuToggle"
                      >
                        <template v-slot:label>
                          <span class="text-caption">Show all models</span>
                        </template>
                      </v-checkbox>
                      <div style="flex-grow: 1;"></div>
                      <v-btn class="model-close-btn" variant="text" size="small" :color="selectedColor" @click="showMenu = false">Close</v-btn>
                    </div>
                  </v-card>
              </v-menu>
            </div>
            <!-- Attachment Menu -->
            <div class="attachment-button-wrapper" v-if="
              (!Snippet_Username == false && Snippet_StatusData) ||
              (!Snippet_StatusData &&
                fileDataUrl == null &&
                pickedFileType == null)
            ">
              <v-menu transition="slide-y-transition" location="top start" offset="8">
                <template v-slot:activator="{ props: menuProps }">
                  <v-btn icon size="40" v-bind="menuProps" class="input-action-btn" variant="text">
                    <v-icon size="20">mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card class="attachment-menu" elevation="8" rounded="12">
                  <v-list class="attachment-list">
                    <v-list-item v-for="(item, index) in attachItems" :key="index" class="attachment-list-item"
                      @click="handleAttachmentItemClick(item.id)" rounded="8">
                      <template v-slot:prepend>
                        <v-icon :color="selectedColor" size="18">
                          {{ item.icon }}
                        </v-icon>
                      </template>
                      <v-list-item-title class="attachment-item-text">
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
          </div>
          <span class="limit-input-text" style="font-size: 10px; color: #71717a">
            {{ messageData.length }} / {{ maximumChatInput }}
          </span>
          <span class="disclaimer-text">
            AI can make mistakes. Please double-check responses.
          </span>

          <!-- Right Action Buttons -->
          <div class="input-actions-right">
            <!-- ปุ่มแสดงสินค้าแนะนำ -->
            <v-btn v-show="products && products.length > 0" icon style="
                scale: 0.9;
                margin-top: -10px;
                font-size: 20px;
                margin-right: 20px;
                width: 21px;
                height: 18px;
                background-color: transparent;
                box-shadow: none;
              " :style="'color:' + selectedColor + '; cursor: pointer;'" v-on:click="hideProducts = !hideProducts">
              <v-badge :content="products.length" :value="showProductBadge" color="red" overlap>
                <v-icon>mdi-shopping</v-icon>
              </v-badge>
            </v-btn>

            <!-- Voice Controls -->
            <v-btn v-show="((!Snippet_Username == false && Snippet_StatusData) ||
              !Snippet_StatusData) &&
              !(
                listMessage.length > 0 &&
                listMessage[listMessage.length - 1].status_Process ==
                'VoiceStart'
              )
              " icon size="40" class="input-action-btn" variant="text" :disabled="listMessage.length > 0 &&
                listMessage[listMessage.length - 1].status_Process != 'END' &&
                listMessage[listMessage.length - 1].status_Process != 'Stop' &&
                listMessage[listMessage.length - 1].status_Process != 'Error'
                " @click="click_account_voice">
              <v-icon size="20">mdi-microphone</v-icon>
            </v-btn>

            <v-btn v-show="((!Snippet_Username == false && Snippet_StatusData) ||
              !Snippet_StatusData) &&
              listMessage.length > 0 &&
              listMessage[listMessage.length - 1].status_Process ==
              'VoiceStart'
              " icon size="40" class="input-action-btn" variant="text" @click="
                TypeInputAudio = 'M';
              Click_StopVoice();
              ">
              <v-icon color="error" size="20">mdi-stop-circle</v-icon>
            </v-btn>
            <!-- Upload File Audio Button (ปุ่มใหม่) -->
            <v-btn v-show="((!Snippet_Username == false && Snippet_StatusData) ||
              !Snippet_StatusData) &&
              !(
                messageData.trim().length > 0 ||
                fileDataUrl != null ||
                pickedFileType != null
              )
              " icon size="40" class="input-action-btn" variant="text" :disabled="listMessage.length > 0 &&
                listMessage[listMessage.length - 1].status_Process != 'END' &&
                listMessage[listMessage.length - 1].status_Process != 'Stop' &&
                listMessage[listMessage.length - 1].status_Process != 'Error'
                " @click="click_music_box()">
              <v-icon size="20">mdi-folder-music</v-icon>
            </v-btn>

            <!-- Send Button -->
            <v-btn class="send-button-chatgpt" icon size="32" color="primary" v-show="messageData.trim().length > 0 ||
              fileDataUrl != null ||
              pickedFileType != null
              " @click="SendOpenAi('Click')" :disabled="(listMessage.length > 0
                ? !(
                  listMessage[listMessage.length - 1].status_Process ==
                  'Stop' ||
                  listMessage[listMessage.length - 1].status_Process ==
                  'END' ||
                  listMessage[listMessage.length - 1].status_Process ==
                  'Error'
                )
                : false) ||
                (uploadFileComplete == false && pickedFileType != null)
                " elevation="0">
              <v-icon color="white" size="16">mdi-arrow-up</v-icon>
            </v-btn>
            
            <!-- ปุ่ม Stop -->
            <v-btn 
              class="send-button-chatgpt stop-button-variant" 
              icon 
              size="32" 
              v-on:click="StopMessage" 
              v-show="listMessage.length > 0 ?
                listMessage[listMessage.length - 1].status_Process == 'Process' ||
                listMessage[listMessage.length - 1].status_Process == 'Send_Message' ||
                listMessage[listMessage.length - 1].status_Process == 'VoiceStart' : false" 
              :disabled="(listMessage.length > 0 && (
                listMessage[listMessage.length - 1].status_Process == 'Stop' ||
                listMessage[listMessage.length - 1].status_Process == 'END' ||
                listMessage[listMessage.length - 1].status_Process == 'Error'
              )) || (listMessage.length == 0)"
              elevation="0">
              <v-icon color="white" size="16">mdi-stop</v-icon>
            </v-btn>
            <!-- ปุ่ม Skip -->
            <v-btn 
              class="send-button-chatgpt skip-button-variant" 
              icon 
              size="32" 
              v-on:click="SkipTextRendering" 
              v-show="(listMessage.length > 0 && messageRes.length > 0 &&
                      listMessage[listMessage.length - 1].status_Process == 'END'
                      && listMessage[listMessage.length - 1].messageBot != null) && 
                      (listMessage[listMessage.length - 1].messageBot.length < messageRes[messageRes.length - 1].length)" 
              elevation="0">
              <v-icon color="white" size="16">mdi-skip-next</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <!-- Hidden Components (preserve functionality) -->
    <DragDropFile ref="imageDragDrop" v-show="false" style="display: none !important" :dialog="true" :DragDrop="false"
      :ShowListFile="false" :IconBtn="true" :allowType="['image/jpeg', 'image/png', 'image/svg+xml']"
      @filesUploaded="processUploadImage($event)" />
    <DragDropFile ref="fileDragDrop" v-show="false" style="display: none !important" :dialog="true" :DragDrop="false"
      :ShowListFile="false" :IconBtn="true" :allowType="[
        'text/csv',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'text/plain',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      ]" @filesUploaded="processUploadFile($event)" />
    <input id="inputFileVoid" type="file" @change="Chang_InputFileVoid" style="visibility: hidden; display: contents"
      accept="audio/wav,audio/mpeg,audio/x-m4a" />
  </div>

  <!-- Error states -->
  <div v-else-if="Status_Error == null" class="error-container">
    {{ Text_Status }}
  </div>

  <div v-else class="access-denied-container">
    <h1 style="
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -50px;
        margin-left: -100px;
      ">
      Access Denied
    </h1>
  </div>

  <v-dialog ref="form" v-model="Uploaddialog" persistent max-width="500px" class="modern-dialog">
    <v-card class="upload-dialog-card" elevation="24">
      <!-- Header Section -->
      <div class="dialog-header">
        <div class="header-icon">
          <v-icon v-if="TypeInputAudio == 'F'" size="32" color="white">
            mdi-folder-music
          </v-icon>
          <v-icon v-else size="32" color="white">mdi-microphone</v-icon>
        </div>
        <div class="header-content">
          <h3 v-if="TypeInputAudio == 'F'" class="dialog-title">
            {{ $t("StreamPopupFileHeader") }}
          </h3>
          <h3 v-else class="dialog-title">
            {{ $t("StreamPopupVoiceHeader") }}
          </h3>
          <p class="dialog-subtitle">{{ $t("StreamPopuplang") }}</p>
        </div>
      </div>

      <!-- Content Section -->
      <v-card-text class="dialog-content">
        <v-container fluid class="pa-0">
          <v-form ref="form" lazy-validation>
            <div class="form-group">
              <label class="form-label">{{ $t("StreamPopuplang") }}</label>
              <v-autocomplete :items="DDGPTModel" item-title="name" item-value="value" v-model="LangPop"
                variant="outlined" density="comfortable" class="language-selector" :placeholder="$t('StreamPopuplang')"
                hide-details>
                <template v-slot:prepend-inner>
                  <v-icon size="20" color="primary">mdi-translate</v-icon>
                </template>
              </v-autocomplete>
            </div>
          </v-form>
        </v-container>
      </v-card-text>

      <!-- Actions Section -->
      <v-card-actions class="dialog-actions">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" color="grey" class="action-btn secondary-btn" @click="Uploaddialog = false">
          <v-icon left size="18">mdi-close</v-icon>
          {{ $t("close") }}
        </v-btn>

        <v-btn v-if="TypeInputAudio == 'M'" color="primary" class="action-btn primary-btn" @click="
          Click_StartVoice();
        Uploaddialog = false;
        ">
          <v-icon left size="18">mdi-record</v-icon>
          {{ $t("StreamPopupRecord") }}
        </v-btn>

        <v-btn v-else color="primary" class="action-btn primary-btn" @click="
          Click_FileButtonVoid();
        Uploaddialog = false;
        ">
          <v-icon left size="18">mdi-upload</v-icon>
          {{ "Upload" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="showImage" max-width="1000">
    <v-card style="
        height: 85vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: transparent;
        box-shadow: none;
        overflow: hidden;
      ">
      <v-img :src="dialogImage" contain style="
          width: 100%;
          height: 100%;
          object-fit: contain;
        " />
    </v-card>
    <div style="
        position: fixed;
        bottom: 16px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        justify-content: center;
        gap: 8px;
        z-index: 1000;
        opacity: 0;
        animation: fadeUp 0.3s ease forwards 0.3s;
      ">
      <div class="downloadImgBtn" style="background-color:#faa91b;" @click="downloadImage">
        <v-icon color="white">mdi-download</v-icon>
      </div>
      <div class="downloadImgBtn" style="background-color:#FF4444;" fab @click="closeImage">
        <v-icon color="white">mdi-close</v-icon>
      </div>
    </div>
  </v-dialog>

  <!-- Private Memory -->

  <v-dialog ref="form" v-model="PrivateMemoryDialog_ListFile" persistent max-width="1050px" scrollable>
    <v-card>
      <v-card-title>
        <v-row style="padding-top: 5px">
          <v-col cols="12" sm="6" md="6" style="text-align: start; padding-left: 22px">
            <p class="headline" style="color: #1d4f81; margin-bottom: 0px">
              {{ $t("StreamUploadPrivateMemory") }}
            </p>
          </v-col>
          <v-col cols="12" sm="6" md="6" style="text-align: end; padding-right: 22px; padding-top: 0px"
            class="btn_PrivateMemoryDialog_ListFile">
            <v-row>
              <v-col cols="6" sm="6" md="6" style="padding-left: 0px">
                <v-btn class="primary white--text mt-3" style="margin-left: 0em"
                  @click="OpenPopup_Private_Memory(null)">
                  <v-icon size="20" style="padding-right: 5px">
                    mdi-upload
                  </v-icon>
                  <!-- <v-icon size="20" style="padding-right: 5px;">mdi-plus-circle-outline</v-icon> -->
                  Upload
                </v-btn>
              </v-col>
              <v-col cols="6" sm="6" md="6" style="padding-left: 0px">
                <v-btn class="white--text mt-3" style="background: #faa91b"
                  @click="PrivateMemoryDialog_ListFile = false">
                  Close
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text id="PrivateMemory_ListFile">
        <!-- <v-card-text style="padding-left: 5px;    padding-right: 5px;"> -->
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-data-table class="v_data_table_Private_Memory" :items-per-page="itemsPerPage_ListFilePM"
              :server-items-length="searchTotalTable_ListFilePM" v-model:options="options_ListFilePM"
              :items="dataTable_ListFilePM" :headers="headers_ListFilePM" :loading="loadingTable_ListFilePM"
              loading-text="Loading...">
              <template v-slot:item="{ item }">
                <tr>
                  <td style="width: 90px; text-align: center">
                    {{ item.number }}
                  </td>
                  <td>
                    {{ item.fileName }}
                  </td>
                  <td>
                    <v-menu location="bottom">
                      <template v-slot:activator="{ on: menu }">
                        <v-btn icon v-on="{ ...menu }">
                          <v-icon size="22">mdi-dots-horizontal</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="Version(item.fileId)">
                          <v-list-item-title>
                            {{ $t("gpt_model_management_version_history") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                  <td style="text-align: center">
                    <v-btn icon @click="OpenPopup_Private_Memory(item)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <img alt="edit" :src="images.edit" v-bind="attrs" v-on="on" />
                        </template>
                        <span>edit</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn icon @click="Delete_ListFilePM_ById_FullStream(item.fileId)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <img alt="delete" :src="images.delete" v-bind="attrs" v-on="on" />
                        </template>
                        <span>delete</span>
                      </v-tooltip>
                    </v-btn>
                    <v-switch style="
                        display: inline-block;
                        padding-left: 0.5em;
                        padding-top: 0;
                      " @change="PrivateVectorOnOffByFileID(item)" v-model="item.isActive" inset></v-switch>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog ref="form" v-model="PrivateMemoryDialog" persistent max-width="1200px" scrollable>
    <v-card>
      <v-card-title>
        <!-- {{ requestVector }} //  -->
        <p class="headline" style="color: #1d4f81">
          {{ $t("StreamPrivateMemory") }}
          {{
            requestVector.fileId == null || requestVector.fileId == -1
              ? $t("StreamPrivateMemoryAdd")
              : $t("StreamPrivateMemoryEdit")
          }}
        </p>
      </v-card-title>
      <v-card-text id="PrivateMemory">
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <!--Document Name-->
              <v-col cols="12" sm="12" md="2">
                <!-- <v-text-field :label="$t('StreamFileNamePrivateMemory')" v-model="requestVector.fileName" outlined></v-text-field> -->
                <v-text-field @keypress="handleKeypress" :label="$t('StreamFileNamePrivateMemory')"
                  :rules="[checkValidate()]" :disabled="actionEdit" v-model="requestVector.searchVectorDBName2" outlined
                  dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoVectorDatabaseName") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <!--Text Replacement-->
              <v-col cols="12" sm="12" md="3">
                <v-autocomplete :label="'Text Replacement'" :items="DDGroupReplace" item-text="name" item-value="id"
                  multiple chips deletable-chips clearable outlined dense v-model="tempgroupReplaceID">
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoGroupReplaceText") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
              <!--Process type-->
              <v-col cols="12" sm="12" md="2">
                <v-select :label="$t('process_type')" :items="modeType" item-text="name" item-value="value" outlined
                  v-model="requestVector.deleteAll" dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoProcess_type") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <!--Custom Max Character-->
              <v-col cols="12" sm="12" md="2">
                <v-text-field :rules="[rules.required]" @keypress="numericKey" :label="$t('_InfoCustomMaxCharacter')"
                  v-model="requestVector.MaxLimitedCharacter" outlined dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoCustomMaxCharacter") }}</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <!--DetectLanguage-->
              <v-col cols="12" sm="12" md="3">
                <v-switch v-model="requestVector.DetectLanguage" inset :label="`DetectLanguage : ${requestVector.DetectLanguage ? 'auto' : 'not auto'
                  }`">
                  <template v-slot:label>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <label v-bind="attrs" v-on="on">
                          {{
                            `DetectLanguage : ${requestVector.DetectLanguage ? "auto" : "not auto"
                            }`
                          }}
                        </label>
                      </template>
                      <span>{{ $t("_InfoDetectLanguage") }}</span>
                    </v-tooltip>
                  </template>
                </v-switch>
              </v-col>
            </v-row>
            <v-row style="margin-top: -1rem">
              <!--Doctype-->
              <v-col cols="12" sm="12" md="2">
                <v-select :rules="[rules.required]" :label="$t('doctype')" :items="datadoctype" item-text="name"
                  item-value="value" v-model="doctype" outlined dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoDoctype") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <!--Vectortype-->
              <v-col cols="12" sm="12" md="2">
                <v-select :rules="[rules.required]" :label="$t('vectortype')" :items="filterdatavectortype"
                  item-text="name" item-value="value" v-model="vectortype" outlined dense>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfoVectortype") }}</span>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-col>
              <!--Type-->
              <v-col cols="12" sm="12" md="3">
                <v-autocomplete :label="$t('type')" :items="filterDDType" item-text="name" item-value="value" clearable
                  outlined dense :rules="[rules.required]" v-model="requestVector.modelType">
                  <template v-slot:item="data">
                    <template v-if="data.item !== 'object'">
                      <v-list-item-content>{{ data.item }}</v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.name }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-list-item-icon v-on="on">
                            <v-icon>mdi-information</v-icon>
                          </v-list-item-icon>
                        </template>
                        <span>
                          <img :src="data.item.image" width="300" />
                        </span>
                      </v-tooltip>
                    </template>
                  </template>
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t("_InfofillterModelType") }}</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="2" v-show="requestVector.modelType == 3">
                <v-text-field :label="'Custom Character'" v-model="requestVector.customCharacter" outlined
                  :rules="[checkCustomCharacterValidate()]">
                  <template v-slot:append-outer>
                    <v-tooltip top max-width="40vw">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon text x-small style="position: absolute; top: 0px; right: -6px" v-bind="attrs" v-on="on">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        ADD คือกระบวนการเพิ่มข้อมูลลง Vector, Raplace
                        คือกระบวนการแก้ไขคำตอบ
                      </span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-row justify="end">
                <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: end">
                  <v-btn class="primary white--text mt-3" style="margin-left: 1rem" @click="TemplateVectorDialog()">
                    Template
                  </v-btn>
                  <DragDropFile :dialog="true" :DragDrop="false" :ShowListFile="false" :accept="accept" :allowType="[]"
                    @filesUploaded="processUpload($event)" />
                </v-col>
              </v-row>>
            </v-row>
            <v-row style="margin-top: -1rem">
              <v-col cols="12" sm="12" md="4">
                <v-text-field :label="'text_org'" v-model="searchtext_org"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="1">
                <v-btn fab class="primary white--text mt-3" @click="Search()">
                  <v-icon size="30">mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-row justify="end">
                <v-col cols="12" sm="12" md="7" style="display: inline-flex; justify-content: end">
                  <v-btn class="white--text mt-3" style="
                      margin-left: 1rem;
                      border-radius: 25.342px;
                      background: #9747ff;
                      width: 100px;
                    " @click="ReProcess()">
                    REPROCESS
                  </v-btn>
                  <v-btn class="white--text mt-3" style="
                      margin-left: 1rem;
                      border-radius: 25.342px;
                      background: #139fd7;
                    " @click="ReFresh()">
                    {{ dataUpdate }} of {{ dataAll }}
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  <v-btn class="primary white--text mt-3" style="margin-left: 1rem" @click="AddVectorperChunk()">
                    <v-icon size="20" style="padding-right: 5px">
                      mdi-plus-circle-outline
                    </v-icon>
                    {{ $t("add") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-row>
              <v-col cols="12" style="display: inline-flex; justify-content: right">
                <v-checkbox v-model="checkBoxShowAllText" :label="`${$t('_ShowAllText')}: ${checkBoxShowAllText
                  ? $t('_ShowAllTextOn')
                  : $t('_ShowAllTextOff')
                  }`"></v-checkbox>
              </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="2" style="display: inline-flex; justify-content: end"></v-col>

            <!-- {{ showTable }} -->
            <v-data-table v-show="showTable == true" :items-per-page="itemsPerPage"
              :server-items-length="searchTotalTable" v-model:options="options" :items="dataTable" :headers="headers"
              :loading="loadingTable" loading-text="Loading..." fixed-header mobile-breakpoint="300"
              class="elevation-1 responsive-table">
              <template v-slot:item="{ item }">
                <tr>
                  <td style="text-align: center">
                    {{ item.number }}
                  </td>
                  <td>
                    <div class="text-container">
                      <span :class="[
                        item.show ? 'text-content-show' : 'text-content',
                      ]" v-html="formatText(item.textORG)"></span>
                    </div>
                  </td>
                  <td>
                    <div class="text-container">
                      <span :class="[
                        item.show ? 'text-content-show' : 'text-content',
                      ]" v-html="formatText(item.textEN)"></span>
                      <v-btn icon rounded @click="item.show = !item.show">
                        <v-icon style="color: black">
                          {{
                            item.show ? "mdi-chevron-up" : "mdi-chevron-down"
                          }}
                        </v-icon>
                      </v-btn>
                    </div>
                  </td>
                  <td style="text-align: center">
                    <v-btn icon @click="EditVectorperChunk(item)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <img alt="edit" :src="images.edit" v-bind="attrs" v-on="on" />
                        </template>
                        <span>edit</span>
                      </v-tooltip>
                    </v-btn>
                    <v-btn icon @click="DeleteById(item.id)">
                      <v-tooltip top open-delay="500">
                        <template v-slot:activator="{ on, attrs }">
                          <img alt="delete" :src="images.delete" v-bind="attrs" v-on="on" />
                        </template>
                        <span>delete</span>
                      </v-tooltip>
                    </v-btn>
                    <v-switch style="
                        display: inline-block;
                        padding-left: 0.5em;
                        padding-top: 0;
                      " @change="VectorOnOff(item)" v-model="item.activeFlag" inset></v-switch>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-banner>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="error" style="margin-right: 3em; margin-top: 1em"
                      @click="DeleteByName(KeyTopic)" v-if="showTable == true" :disabled="searchTotalTable == 0">
                      {{ $t("deleteAll") }}
                    </v-btn>
                    <v-btn class="white--text mt-3" v-if="showTable == true" style="
                        margin-left: 1em;
                        border-radius: 25.342px;
                        background: #faa91b;
                        width: 120px;
                      " @click="SaveFileName_PrivateMemoryFullStream">
                      Close
                    </v-btn>
                  </v-card-actions>
                </v-banner>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog ref="form" v-model="EditVector" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">Edit Vector</p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <!-- <v-form ref="form" v-model="valid" lazy-validation> -->
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea :label="'text_org'" outlined counter auto-grow rows="15" v-model="Edit.textORG"
                  required></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeUploaddialog">
          {{ $t("close") }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="SaveEdit()">
          {{ $t("save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog ref="form" v-model="AddVector" max-width="800px">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">Add Vector</p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <!-- <v-form ref="form" v-model="valid" lazy-validation> -->
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea :label="'text_org'" outlined counter auto-grow rows="15" v-model="Add.textORG"
                  required></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeUploaddialogAdd">
          {{ $t("close") }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="SaveAdd()">
          {{ $t("save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="TemplateVector" max-width="800px">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">Template Vector</p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table class="v_data_table_Private_Memory" :items="dataTemplate" :headers="headersTemplate"
            loading-text="Loading..." hide-default-footer disable-sort>
            <template v-slot:item="{ item }">
              <tr>
                <td style="width: 81px; text-align: center">
                  {{ item.modeType }}
                  <template v-if="item.modeType == 'CustomSplit'">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-information
                        </v-icon>
                      </template>
                      <span>
                        Template CustomSplit use "||!" Example SplitChunkContent
                      </span>
                    </v-tooltip>
                  </template>
                </td>
                <td style="text-align: center" v-if="
                  item.modeType != 'CustomSplit' && item.modeType != 'Article'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.CSV)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-file</v-icon>
                      </template>
                      <span>{{ item.modeType }} - CSV</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'CustomSplit' && item.modeType != 'Article'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.Excel)" v-if="
                    item.modeType != 'HeaderAllChunk' &&
                    item.modeType != 'HeaderFirstChunk'
                  ">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-file-excel</v-icon>
                      </template>
                      <span>{{ item.modeType }} - Excel</span>
                    </v-tooltip>
                  </v-btn>
                  <v-btn icon @click="linkDownload(item.modeType, item.ExcelMultiColumn)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-excel-box
                        </v-icon>
                      </template>
                      <span>{{ item.modeType }} - Excel (Multiple column)</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'HeaderAllChunk' &&
                  item.modeType != 'HeaderFirstChunk'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.PDF)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-pdf-box
                        </v-icon>
                      </template>
                      <span>{{ item.modeType }} - PDF</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'HeaderAllChunk' &&
                  item.modeType != 'HeaderFirstChunk'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.Word)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">mdi-file-word</v-icon>
                      </template>
                      <span>{{ item.modeType }} - Word</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'HeaderAllChunk' &&
                  item.modeType != 'HeaderFirstChunk'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.PowerPoint)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-powerpoint
                        </v-icon>
                      </template>
                      <span>{{ item.modeType }} - PowerPoint</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
                <td style="text-align: center" v-if="
                  item.modeType != 'HeaderAllChunk' &&
                  item.modeType != 'HeaderFirstChunk'
                ">
                  <v-btn icon @click="linkDownload(item.modeType, item.Text)">
                    <v-tooltip top open-delay="500">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on">
                          mdi-file-document
                        </v-icon>
                      </template>
                      <span>{{ item.modeType }} - Text</span>
                    </v-tooltip>
                  </v-btn>
                </td>
                <td v-else style="text-align: center">-</td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="TemplateVector = false">
          {{ $t("close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialog_version" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">
          {{ $t("gpt_model_management_version_history") }}
        </p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table :items-per-page="itemsPerPage_version" :server-items-length="searchTotalTable_version"
            v-model:options="options_version" :items="menus_version" :headers="headers_version_history"
            :footer-props="{ 'items-per-page-options': [5] }">
            <template v-slot:item="{ item }">
              <tr>
                <td style="text-align: center">{{ item.version }}</td>
                <td style="text-align: center">{{ item.createDate }}</td>
                <td style="text-align: center">
                  <v-menu location="bottom">
                    <template v-slot:activator="{ on: menu }">
                      <v-btn icon v-on="{ ...menu }">
                        <v-icon size="22">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :key="item.id" @click="changeRestoreNewVersion(item.id, item.fileId)">
                        <v-list-item-title>Restore</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="
                        viewVersion(item.id, item.fileId, item.keytopic)
                        ">
                        <v-list-item-title>View</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
                <td style="text-align: center">{{ item.createBy }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog_version = false">
          {{ $t("close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--dialog view private vector version-->
  <v-dialog v-model="dialog_view_private" width="80vw">
    <v-card>
      <v-card-title>
        <p class="headline" style="color: #1d4f81">
          {{ $t("gpt_model_management_version_history_detail") }}
        </p>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-data-table :items-per-page="itemsPerPage" :server-items-length="searchTotalTable_view_private"
            v-model:options="options_view_private" :items="view_private_version" :headers="header_view_private_version"
            class="elevation-1 responsive-table"></v-data-table>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog_view_private = false">
          {{ $t("close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Dialog สำหรับแสดงรายละเอียดสินค้า -->
  <v-dialog v-model="showDetailDialog" max-width="600px" >

    <v-card v-if="selectedProductDetail" class="product-card-header">
      <v-img v-if="selectedProductDetail.ProductImg" :src="selectedProductDetail.ProductImg" height="250px"
        :alt="selectedProductDetail.ProductName"></v-img>
      <img v-else class="product-default-image" height="250px" width="100%" src="../assets/images/product_default.png" :alt="selectedProductDetail.ProductName"></img>
      <v-card-title>{{ selectedProductDetail.ProductName }}</v-card-title>
      <v-card-text>
        <div class="text-h5 primary--text mb-4" color="primary">
          {{
            selectedProductDetail.ProductPrice
              ? `฿${selectedProductDetail.ProductPrice.toLocaleString()}`
              : "ติดต่อสอบถาม"
          }}
        </div>
        <div class="product-full-description">
          {{ selectedProductDetail.ProductDetail }}
        </div>
      </v-card-text>

      <v-card-actions class="product-card-actions">
        <v-spacer></v-spacer>
        <v-btn size="large" class="product-btn-actions"  color="#FB8C00" variant="outlined" @click="showDetailDialog = false">ปิด</v-btn>
        <v-btn
          size="large"
          class="product-btn-actions"
          variant="elevated"
          color="#FB8C00"
          @click="
            selectProduct(selectedProductDetail);
            showDetailDialog = false;
        ">
          สนใจสินค้านี้
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <div v-if="alertDialog" style="
      position: fixed;
      top: 16px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10000;
    " :class="{ 'fade-in': alertDialog, 'fade-out': !alertDialog }">
    <v-alert color="green" type="success" dismissible @click:close="alertDialog = false">
      The image is downloading...
    </v-alert>
  </div>

  <Loading :flagLoading="Loading_History_Status && startLoading == false" />
  <!-- Loading_History_Status -->
  <!-- <v-overlay :value="loading">
        <v-dialog v-model="loading" persistent width="300">
          <v-card color="#1976D2" dark>
            <v-card-text class="white--text">
              Loading Please Wait...
              <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>        </v-dialog>
      </v-overlay> -->

  <!-- </div> -->
</template>

<script>
import { app } from "@microsoft/teams-js";
import { ref } from "vue";
import { useDisplay } from "vuetify";
// import VueMarkdown from 'vue-markdown-v2';
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import Cookies from "js-cookie";
import DragDropFile from "@/components/DragDropFile.vue";
import Loading from "@/components/Loading.vue";
import MarkdownIt from "@/components/MarkedMarkdown.vue";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";

// Import images for DDType
import Group11Svg from "@/assets/images/Group 11.svg";
import Group12Svg from "@/assets/images/Group 12.svg";
import Group13Svg from "@/assets/images/Group 13.svg";

// Import file type images
import csvImg from "@/assets/images/FileTypes/csv.png";
import excelImg from "@/assets/images/FileTypes/excel.png";
import pdfImg from "@/assets/images/FileTypes/pdf.png";
import docImg from "@/assets/images/FileTypes/doc.png";
import plainImg from "@/assets/images/FileTypes/plain.png";
import pptImg from "@/assets/images/FileTypes/ppt.png";
import unknownImg from "@/assets/images/FileTypes/unknown.png";
import modelSVG from "@/assets/images/Model.svg";
export default {
  name: "FullStream",
  provide() {
    return {
      ResetTextToImageFlagF: this.ResetTextToImageFlag
    };
  },
  inject: [
    "Click_History_List",
    "Status_Error",
    "Loading_History_Status",
    "User_Id_Show",
    "User_Id",
    "Log_History_TopicID",
    "TopicName",
    "TopicModelID",
    "KeyTopic",
    "isFeedback",
    "TopicModelID_long",
    "GetModelFirst_Value",
    "Flag_Click_History",
    "IsAllowImage",
    "miniVariant",
    "colorThemeChat",
    "FileUploadLimit",
    "NotificationTokenExpired",
    "Region",
    "SubscriptionKey",
    "IsChainMassage",
    "listTopic",
    "Log_History_ID",
    "Log_History_Take",
    "Time_Delay",
    // "maximumChatInput",
    "ModelFirst",
    "GetModelFirst",
    "flagShowTopic",
    "flagGetAllTopic",
    "StatusKeyRename",
    "auth_token",
    "Snippet_StatusData",
    "Snippet_Username",
    "NavbarBtnColorTheme",
    "NavbarTxtColorTheme",
    "isAllowLLMChange",
    "selectedLLMModelInChat",
    "ChatbotName"
  ],
  components: {
    // VueMarkdown,
    MarkdownIt,
    DragDropFile,
    Loading,
  },
  setup() {
    const { mobile, smAndDown, mdAndUp, xs } = useDisplay();

    return {
      mobile,
      smAndDown,
      mdAndUp,
      xsOnly: xs,
    };
  },
  watch: {
    ModelFirst: {
      handler(newVal) {
          this.CheckCurrentModelTextToImage();
      },
      immediate: true,
    },
    User_Id_Show: function () {
      var self = this;
      if (self.Flag_Start) {
        self.User_Id_Show = self.User_Id_Show == null ? "" : self.User_Id_Show;
        self.User_Id = self.User_Id == null ? "" : self.User_Id;
        if (
          self.User_Id_Show != null &&
          self.User_Id_Show != "" &&
          self.User_Id_Show.replace(/ /g, "") != ""
        ) {
          self.User_Id = self.User_Id_Show;
        } else if (
          self.User_Id_Show.replace(/ /g, "") == "" &&
          self.User_Id.split("-").length == 6
        ) {
          console.log(
            "User_Id_Show : " +
            self.User_Id_Show +
            " ,User_Id-length : " +
            self.User_Id.split("-").length
          );
        } else {
          self.User_Id = self.GetUuidv4_Fun_User_Id_Null();
        }
      } else {
        // self.Flag_Start = true;
      }
    },
    User_Id: function () {
      var self = this;
      if (self.Flag_Start) {
        self.Log_History_TopicID = -1;
        self.TopicName = "";
        self.TopicModelID = "";
        self.KeyTopic = "";
        self.isFeedback = false;
        self.TopicModelID_long = -1;
        self.Chang_History();
        self.GetLogStreamStart_Flag = true;
        self.GetTopicFullStream("Start");

        self.GetModelFirst_Value(null, self.User_Id);
      } else {
        self.Flag_Start = true;
      }
    },
    Flag_Click_History: function () {
      var self = this;
      self.Chang_History();
      if (self.Log_History_TopicID != -1) {
        self.GetTopicFullStream("ChangHistory");
      }
    },
    KeyTopic: function () {
      var self = this;
      self.$nextTick(function () {
        self.ClearValuePrivate_Memory();
      });
    },
    options_ListFilePM: {
      handler() {
        this.GetListFile_PrivateMemoryFullStream("");
      },
      deep: true,
    },
    options: {
      handler() {
        this.GetByVector();
      },
      deep: true,
    },
    options_view_private: {
      handler() {
        this.viewVersion(this.privateID, this.fileID, this.temKeytopic);
      },
      deep: true,
    },
    requestVector: {
      handler(newVal) {
        if (newVal.modelType != 3) {
          this.requestVector.customCharacter = null;
        }
      },
      deep: true,
    },
    doctype: {
      handler(val) {
        let self = this;
        self.vectortype = null;
        self.requestVector.customCharacter = null;
        (self.filterDDType = []), (self.filterdatavectortype = []);
        if (val == 1 || val == 2) {
          self.filterdatavectortype = self.datavectortype.filter(
            (e) => e.value != 2
          );
        } else {
          self.filterdatavectortype = self.datavectortype.filter(
            (e) => e.value != 3
          );
        }
        self.setTypeFile(val);
      },
    },
    vectortype: {
      handler(val) {
        let self = this;
        self.filterDDType = [];
        self.requestVector.customCharacter = null;
        if (val == 2) {
          self.filterDDType = self.DDType.filter((e) => e.value == 4);
        } else if (val == 3 && (self.doctype == 1 || self.doctype == 2)) {
          self.filterDDType = self.DDType.filter(
            (e) => e.value == 5 || e.value == 6
          );
        } else {
          if (self.doctype == 4) {
            self.filterDDType = self.DDType.filter(
              (e) =>
                e.value == 1 || e.value == 2 || e.value == 3 || e.value == 7
            );
          } else if (self.doctype == 3) {
            self.filterDDType = self.DDType.filter(
              (e) =>
                e.value == 1 || e.value == 2 || e.value == 3 || e.value == 8
            );
          } else {
            self.filterDDType = self.DDType.filter(
              (e) => e.value == 1 || e.value == 2 || e.value == 3
            );
          }
        }
        self.requestVector.modelType = null;
      },
    },
    menuGroupModel: {
      handler() {
        this.$nextTick(() => {
          this.showMenu = !this.showMenu;
        });
      },
      deep: true,
    },
    ColorThemeChat(newVal) {
      this.selectedColor = `#${newVal}`;
    },
    // "$root.miniVariant": function (val){
    //   console.log(self.widthNavDrawer)
    //   console.log(val)
    //   self.widthNavDrawer = val ? '256px' : '56px';
    // },
    // "$root.flagGetAllTopic": function () {
    //   var self = this;
    //   self.GetTopicFullStream("GetAllTopic");
    // },
    showMenu() {
      if (
        this.ModelQuick.some((i) => i.typeModel == 1) &&
        this.ModelQuick.some((i) => i.typeModel == 2) &&
        !this.menuGroupModel
      ) {
        this.showModelQuick = this.ModelQuick.filter(
          (item) => item.typeModel === 1
        );
      } else {
        this.showModelQuick = this.ModelQuick;
      }
    },
    checkBoxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
    drawerWidth(newWidth) {
      document.documentElement.style.setProperty(
        "--drawer-width",
        `${newWidth}`
      );
    },
    products(newProducts) {
      if (newProducts && newProducts.length > 0) {
        // เมื่อมีสินค้าใหม่เข้ามา อาจมีการแจ้งเตือนหรือแสดง badge
        this.showProductBadge = true;
        this.hideProducts = false;
      }
    },
  },
  created() {
    document.documentElement.style.setProperty(
      "--drawer-width",
      `${this.widthNavDrawer}`
    );
  },
  computed: {
    filteredModels() {
      return this.showModelQuick.filter(model => {
        // Search filter
        if (this.modelSearchQuery && !model.modelName.toLowerCase().includes(this.modelSearchQuery.toLowerCase())) {
          return false;
        }
        
        return true;
      });
    },
    attachItems() {
      if (!this.IsAllowImage) {
        return this.allAttachItems.filter((item) => item.id === "files");
      }
      return this.allAttachItems;
    },
    drawerWidth() {
      return this.miniVariant ? "256px" : "56px";
    },
    ColorThemeChat() {
      return this.colorThemeChat;
    },
    headers_ListFilePM() {
      return [
        { text: this.$t("no"), align: "center", sortable: false },
        {
          text: this.$t("StreamFileNamePrivateMemory"),
          value: "fileName",
          align: "center",
          sortable: true,
        },
        { text: " ", value: " ", align: "center", sortable: false },
        { text: this.$t("manage"), align: "center", sortable: false },
      ];
    },
    headers() {
      return [
        { text: this.$t("no"), align: "center", sortable: false },
        { text: "text_org", value: "TextORG", align: "center", sortable: true },
        { text: "text_en", value: "TextEN", align: "center", sortable: true },
        { text: this.$t("manage"), align: "center", sortable: false },
      ];
    },
    headersTemplate() {
      return [
        { text: "Type", align: "center", width: "25%" },
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
        { text: "PDF", align: "center" },
        { text: "Word", align: "center" },
        { text: "PowerPoint", align: "center" },
        { text: "Text", align: "center" },
      ];
    },
    headers_version_history() {
      return [
        { text: "Version", align: "center", sortable: false, width: "95px" },
        { text: "Modified", align: "center", sortable: false },
        { text: " ", align: "center", sortable: false },
        { text: "Modified By", align: "center", sortable: false },
      ];
    },
    header_view_private_version() {
      return [
        {
          text: this.$t("no"),
          value: "number",
          align: "center",
          justify: "center",
          sortable: false,
          width: "100px",
        },
        { text: "text_org", value: "textORG", align: "center", sortable: true },
        { text: "text_en", value: "textEN", align: "center", sortable: true },
      ];
    },
  },
  data: () => ({
    urlApi: import.meta.env.VITE_APP_API,
    isTextToImageLocal: false,
    modelSearchQuery: "",
    showScrollToBottomButton: false,
    rerenderKey: 0,
    showProductDialog: false,
    showProductBadge: true,
    hideProducts: false,
    showDetailDialog: false,
    selectedProductDetail: null,
    showImage: false,
    alertDialog: false,
    dialogImage: "",
    // User_Id_Old :"",
    TimeOutText_Run: null,
    // KeyTopic: null,

    Flag_Start: false,
    GetLogStreamStart_Flag: true,
    messageImage: "",
    LastScrollTop: null,

    TimeOutStop: null,

    // 5 s
    TimeoutFirst: 5000,
    //Timeout: 60000,
    // 10 s
    //Timeout: 10000,
    // 7 s
    Timeout: 7000,
    // Timeout: 10000,
    SpeechRecognizer: null,

    TypeInputAudio: "",

    LangPop: "th-TH",
    DDGPTModel: [
      { name: "TH", value: "th-TH" },
      { name: "EN", value: "en-US" },
    ],
    Uploaddialog: false,
    UserPrincipalName: "",
    anchorAttrs: {
      target: "_blank",
      rel: "noopener noreferrer nofollow",
    },
    allAttachItems: [
      { id: "images", title: "Images", icon: "mdi-image" },
      { id: "files", title: "Files", icon: "mdi-paperclip" },
    ],
    point: 0,
    Key_Ctrl_Flag: false,
    Stop_Flag: false,
    StopForChain: false,
    Axios_Controller: [],
    Axios_ControllerAduio: null,
    listMessage: [],
    messageData: "",
    CountScroll: 0,
    MaxCountScroll: 15,
    messageRes: [],
    Count_messageRes: [],
    StatusPro: false,
    messageRun: "",
    Text_Status: "",
    auth_token_local: "",
    parameterURL: [],
    groupModel: "",
    snippet_Status: false,
    username: "",
    ModelQuick: [],
    PrivateMemoryDialog_ListFile: false,
    PrivateMemoryDialog: false,
    PrivateMemory_Disabled_Name: true,
    Axios_VECTOR: null,
    sortBy: [],
    sortDesc: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    AddVector: false,
    flagNew: false,
    Add: {
      id: null,
      textORG: null,
    },
    totalTable: 0,
    loadingTable: false,
    showTable: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
    dataTable: [],
    searchTotalTable: 0,
    itemsPerPage: 10,
    dataUpdate: 0,
    dataAll: 0,
    exceptionFlag: false,
    TemplateVector: false,
    tempgroupReplaceID: null,
    ImageURL: null,
    fileDataUrl: null,
    pickedFileType: null,
    pickedFileName: null,
    uploadFileComplete: false,
    loadingImage: false,
    DDGroupReplace: [],
    DDType: [
      {
        name: "General",
        value: 1,
        image: Group11Svg,
      },
      {
        name: "MaxCharacter",
        value: 2,
        image: Group12Svg,
      },
      {
        name: "CustomSplit",
        value: 3,
        image: Group13Svg,
      },
      {
        name: "Article",
        value: 4,
        image: Group13Svg,
      },
      {
        name: "HeaderAllChunk",
        value: 5,
        image: Group11Svg,
      },
      {
        name: "HeaderFirstChunk",
        value: 6,
        image: Group12Svg,
      },
      {
        name: "WordImage",
        value: 7,
        image: Group12Svg,
      },
      {
        name: "PDFImage",
        value: 8,
        image: Group12Svg,
      },
    ],
    datadoctype: [
      { name: "CSV", value: 1 },
      { name: "Excel", value: 2 },
      { name: "PDF", value: 3 },
      { name: "Word", value: 4 },
      { name: "Text", value: 5 },
      { name: "PowerPoint", value: 6 },
    ],
    datavectortype: [
      { name: "General", value: 1 },
      { name: "Article", value: 2 },
      { name: "PriceList", value: 3 },
    ],
    dataTemplate: [
      {
        modeType: "General",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "MaxCharacter",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "CustomSplit",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "Article",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "HeaderAllChunk",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
      {
        modeType: "HeaderFirstChunk",
        CSV: "CSV",
        Excel: "Excel",
        ExcelMultiColumn: "ExcelMultiColumn",
        PDF: "PDF",
        Word: "Word",
        Text: "Text",
        PowerPoint: "PowerPoint",
      },
    ],
    rules: {
      required: (value) => !!value || "Required.",
      // required2 : this.vectornameDuplicate || 'dup'
    },
    MaxLimitedCharacter: null,
    doctype: null,
    vectortype: null,
    filterdatavectortype: [],
    filterDDType: [],
    accept: "",
    VectorDBNameDuplicate: "",
    searchtext_org: null,
    showAllText: false,
    checkBoxShowAllText: false,
    requestVector: {
      modelType: null,
      modelId: null,
      vectordbName: null,
      entity: null,
      deleteAll: false,
      groupReplaceID: null,
      customCharacter: null,
      DetectLanguage: true,
      USER_CHANNEL: null,
      TopicID: null,
      // topVDB: null,
      topVDB: 3,
      // cosine: null,
      cosine: -1,
      // fileName: "",
      searchVectorDBName2: "",
      fileId: -1,
      MaxLimitedCharacter: null,
    },
    modeType: [
      {
        name: "Add",
        value: false,
      },
      {
        name: "Replace",
        value: true,
      },
    ],
    EditVector: false,
    Edit: {
      id: null,
      textORG: null,
    },
    requestUpload: {
      entity: null,
      USER_CHANNEL: null,
    },

    isSearch: false,

    products: [],
    productsSelect: [],
    totalTable_ListFilePM: 0,
    isSearch_ListFilePM: false,
    loadingTable_ListFilePM: false,
    sortBy_ListFilePM: [],
    sortDesc_ListFilePM: [],
    options_ListFilePM: {},
    dataTable_ListFilePM: [],
    searchTotalTable_ListFilePM: 0,
    itemsPerPage_ListFilePM: 10,
    selectedColor: "#FFA41E",
    menuGroupModel: false,
    showMenu: false,
    today: null,
    comment: false,
    moreComment: false,
    maximumChatInput: 200000,
    dialog_version: false,
    options_version: {},
    itemsPerPage_version: 5,
    menus_version: [],
    searchTotalTable_version: 0,
    totalTable_version: 0,
    fileID: null,
    loading: false,
    URL_Domain: "",
    modelDisplayID: "",
    userChanel: "",
    tokenParam: "",
    snipet_flag: false,
    svgContent: null,
    SessionID: null,
    loadColor: false,
    showModelQuick: [],
    actionEdit: false,

    //dialog view private
    dialog_view_private: false,
    searchTotalTable_view_private: 0,
    totalTable_view_private: 0,
    options_view_private: { sortBy: [null], sortDesc: [null] },
    view_private_version: [],
    privateID: null,
    temKeytopic: null,
    role: {
      ID: null,
      Name: null,
    },
    isUseForMSTeam: false,
    flagTopHistory: false,
    widthNavDrawer: "56px",
    ShortcutMenu: [],

    showScrollButtons: false,
    showLeftButton: false,
    showRightButton: true,
    startLoading: false,
    msContext: null,
    isMsTeam: true,
    allLLMModel: [],
    activeProviderTab: 0,
    expandedPanel: 0,
    providers: [
      { id: 'azure', name: 'Azure', icon: 'mdi-microsoft' },
      { id: 'google', name: 'Google', icon: 'mdi-google' },
      { id: 'anthropic', name: 'Anthropic', icon: 'mdi-alpha-a-circle' },
      { id: 'others', name: 'Others', icon: 'mdi-dots-horizontal-circle' }
    ],
    showModelDropdown: false,
    personalInfoToken: null,
  }),
  methods: {
    ResetTextToImageFlag() {
      this.isTextToImageLocal = false;
    },
    CheckCurrentModelTextToImage() {
      let tempID = null;
      try {
        tempID = parseInt(this.ModelFirst.split(" ")[0], 10);
      } catch (e) {
        tempID = null;
      }
      try {
        if (tempID && this.ModelQuick.length > 0) {
          const currentModel = this.ModelQuick.find(model => 
            model.modelDisplayID === tempID
          );
          this.isTextToImageLocal = currentModel && currentModel.isTextToImage;
          this.isAllowLLMChange = currentModel ? (currentModel.isAllowLLMChange ? currentModel.isAllowLLMChange : false) : false;
        } else{
          this.isTextToImageLocal = false;
        }
      } catch (e) {
        this.isTextToImageLocal = false;
      }
    },
    checkScrollPosition() {
      var self = this;
      if (!this.$refs.MainScrollArea) return;
      if (
        self.$refs.MainScrollArea.scrollTop <= self.LastScrollTop &&
        self.$refs.MainScrollArea.scrollTop <= 0 &&
        self.Loading_History_Status == false &&
        self.flagTopHistory
      ) {
        if (self.listMessage.length > 0) {
          self.Log_History_ID = self.listMessage[0].id;
          self.GetHistoryFullStream("ScrollUp");
        }
      }
      const container = this.$refs.MainScrollArea;
      const scrollPosition = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;

      // If we're not at the bottom (with a small buffer of 50px), show the button
      this.showScrollToBottomButton =
        scrollPosition < scrollHeight - clientHeight - 100;
    },
  handleMenuToggle() {
      this.showMenu = false;
      // this.FilterShowModel();
      setTimeout(() => {
        this.showMenu = true;
      }, 50);
    },
    FilterShowModel(){
      if (this.ModelQuick.some(i => i.typeModel == 1) && this.ModelQuick.some(i => i.typeModel == 2) && !this.menuGroupModel) {
        this.showModelQuick = this.ModelQuick.filter(item => item.typeModel === 1);
      } else {
        this.showModelQuick = this.ModelQuick;
      }
    },
    isActiveModel(item) {
      return this.TopicModelID === item.modelDisplayID;
    },
    selectModel(item) {
      this.TopicModelID = item.modelDisplayID;
      this.Click_History_List(-1, '...', item.modelDisplayID + ' (' + item.modelName + ')', item.modelID, null);
      this.Time_Delay = item.timeDelay; 
      this.IsAllowImage = item.isAllowImage; 
      this.maximumChatInput = item.maximumChatInput; 
      this.IsChainMassage = item.isChainMassage; 
      this.FileUploadLimit = item.fileUploadLimit;
      this.isAllowLLMChange = item.isAllowLLMChange;
      this.showMenu = false;
    },
    showProductDetail(product) {
      this.selectedProductDetail = product;
      this.showDetailDialog = true;
    },

    selectProduct(product) {
      // ส่งคำถามเฝี่ยวฝับสินค้าที่เลือกไปยัง chatbot
      this.messageData = `ฉันสนใจสินค้า: ${product.ProductName}`;
      this.productsSelect.push(product.ProductID);
      this.SendOpenAi("Click");

      // บันทึกการเลือกสินค้า
      this.logProductSelection(product);
    },

    logProductSelection(product) {
      this.showProductBadge = false;
    },
    handleAttachmentItemClick(itemId) {
      switch (itemId) {
        case "images":
          // Trigger the image DragDropFile component
          if (this.$refs.imageDragDrop) {
            this.$refs.imageDragDrop.$el
              .querySelector('input[type="file"]')
              ?.click();
          }
          break;
        case "files":
          // Trigger the file DragDropFile component
          if (this.$refs.fileDragDrop) {
            this.$refs.fileDragDrop.$el
              .querySelector('input[type="file"]')
              ?.click();
          }
          break;
        default:
          console.warn("Unknown attachment type:", itemId);
      }
    },
    processUploadFile(files) {
      if (files.length === 0) {
        return;
      }
      let fileUploadSizeLimit = 4 * 1024 * 1024; // 4 MB
      if (files[0].size > fileUploadSizeLimit) {
        this.$swal.fire({
          icon: "error",
          title: `ไฟล์มีขนาดใหญ่เกิน 4 MB`,
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      // this.ClearValuePrivate_Memory();
      if (this.KeyTopic == null) {
        this.KeyTopic = this.GetUuidv4_Fun();
      }
      this.requestVector = {
        modelType: null,
        modelId: null,
        vectordbName: null,
        entity: null,
        deleteAll: false,
        groupReplaceID: null,
        customCharacter: null,
        DetectLanguage: true,
        USER_CHANNEL: null,
        TopicID: null,
        // topVDB: null,
        topVDB: 3,
        // cosine: null,
        cosine: -1,
        // fileName: item.fileName,
        fileId: -1,
        MaxLimitedCharacter: null,
      };

      this.requestVector.searchVectorDBName2 = "";
      this.actionEdit = true;
      this.searchtext_org = null;

      // Determine file type based on MIME type
      let documentType = 1; // Default to CSV
      const file = files[0];
      const mimeType = file.type;

      // Map MIME types to document types
      if (mimeType === "text/csv") {
        documentType = 1; // CSV
      } else if (
        mimeType ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        mimeType === "application/vnd.ms-excel"
      ) {
        documentType = 2; // Excel
      } else if (mimeType === "application/pdf") {
        documentType = 3; // PDF
      } else if (
        mimeType ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        mimeType === "application/msword"
      ) {
        documentType = 4; // Word
      } else if (mimeType === "text/plain") {
        documentType = 5; // Text
      } else if (
        mimeType ===
        "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
        mimeType === "application/vnd.ms-powerpoint"
      ) {
        documentType = 6; // PowerPoint
      } else {
        documentType = 7; // Unknown
      }

      this.requestVector.fileId - 1;
      this.requestVector.MaxLimitedCharacter = 5500;
      this.requestVector.doctype = documentType;
      this.requestVector.vectortype = 1;
      this.requestVector.modelType = 1;

      this.files = files;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        const formDataDoc = new FormData();
        formDataDoc.append("entity", this.files[0]);
        this.uploadedFiles = this.files;
        this.requestVector.entity = formDataDoc;
        this.pickedFileName = this.files[0].name;
        this.pickedFileType = this.GetFileTypeImg(documentType);
        this.SaveFile();
      };
    },
    GetFileTypeImg(documentType) {
      switch (documentType) {
        case 1:
          return csvImg;
        case 2:
          return excelImg;
        case 3:
          return pdfImg;
        case 4:
          return docImg;
        case 5:
          return plainImg;
        case 6:
          return pptImg;
        default:
          return unknownImg;
      }
    },
    ClearUploadedFile() {
      let self = this;
      self.pickedFileType = null;
      self.pickedFileName = null;
      self.requestVector.entity = null;
      self.uploadFileComplete = false;
      self.uploadedFiles = [];
      self.files = [];
      self.dataAll = 0;
      self.dataUpdate = 0;
      self.fileID = -1;
    },
    botMessageClick(e) {
      const imageRegex = /!\[.*?\]\((.*?)\)/;
      const match = e.match(imageRegex);
      if (match) {
        this.dialogImage = match[1]; // extracted URL
        this.showImage = true;
      }
    },
    downloadImage() {
      let self = this;
      if (!this.dialogImage) return;
      self.alertDialog = true;
      this.closeDownloadDialog();
      self.$call.DownloadChatImage(
        this.dialogImage,
        self.auth_token_local,
        async (dataResponse) => {
          const blob = new Blob([dataResponse], { type: "image/png" });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            const link = document.createElement("a");
            link.href = reader.result; // ใช้ Data URL
            link.download = "downloaded-image.png";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          };
          self.dialog_version = false;
          self.loading = false;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
        }
      );
    },
    closeImage() {
      this.showImage = false;
      this.dialogImage = "";
    },
    closeDownloadDialog() {
      setTimeout(() => {
        this.alertDialog = false;
      }, 3000);
    },
    selectCard(text) {
      // this.selectedCard = card;
      this.messageData = text;
      // this.SendOpenAi('Click');
      // this.messageData = "";
    },
    PrivateVectorOnOffByFileID(item) {
      let self = this;
      var titleAlert = item.isActive
        ? this.$t("confirmOn")
        : this.$t("confirmOff");
      var textAlert = item.isActive
        ? this.$t("confirmOnVectorName")
        : this.$t("confirmOffVectorName");
      self.$swal
        .fire({
          title: titleAlert,
          text: textAlert,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              fileID: item.fileId,
              activeFlag: item.isActive,
            };
            self.dialog = true;
            try {
              self.$call.PrivateVectorOnOffByFileID_FullStream(
                temp,
                self.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    // self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  item.isActive = !item.isActive;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, "DeleteGroup");
            }
          } else {
            item.isActive = !item.isActive;
          }
        });
    },
    VectorOnOff(item) {
      let self = this;
      var titleAlert = item.activeFlag
        ? this.$t("confirmOn")
        : this.$t("confirmOff");
      var textAlert = item.activeFlag
        ? this.$t("confirmOnVectorName")
        : this.$t("confirmOffVectorName");
      self.$swal
        .fire({
          title: titleAlert,
          text: textAlert,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            let temp = {
              fileID: item.fileId,
              id: item.id,
              activeFlag: item.activeFlag,
            };
            self.dialog = true;
            try {
              self.$call.PrivateVectorOnOff_FullStream(
                temp,
                self.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    // self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  item.activeFlag = !item.activeFlag;
                  console.error(errorResource);
                }
              );
            } catch (error) {
              this.LogTrace(error, "DeleteGroup");
            }
          } else {
            item.activeFlag = !item.activeFlag;
          }
        });
    },
    async changeRestoreNewVersion(id, fileId) {
      let self = this;
      self.loading = true;
      let req = {
        ID: id,
        fileId: fileId,
      };
      self.$call.SaveReStorePrivateVector_FullStream(
        req,
        self.auth_token_local,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.GetListFile_PrivateMemoryFullStream(
              "OpenPopPrivateMemoryDialog_ListFile"
            );
          }
          self.dialog_version = false;
          self.loading = false;
          return null;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          self.dialog_version = false;
          console.error(errorResource);
          return null;
        }
      );
    },
    async Version(fileId) {
      let self = this;
      self.loading = true;
      self.fileID = fileId;

      if (self.dialog_version == false) {
        this.options_version.page = 1;
      }

      self.dialog_version = true;
      // self.menus_modelid_version = modelId;
      // self.menus_modeliddisplay_version = modelIDGroup;

      const { page } = this.options_version;
      let temp = {
        page: page == undefined ? 1 : page,
        perPage: 5,
        fileId: fileId,
      };

      self.$call.GetTablePrivateVectorVersion_FullStream(
        temp,
        self.auth_token_local,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.menus_version = dataResponse.data.data;
            self.searchTotalTable_version = dataResponse.data.total;
            self.totalTable_version = dataResponse.data.total;
          } else {
            self.menus_version = [];
            self.searchTotalTable_version = 0;
            self.totalTable_version = 0;
          }
          self.loading = false;
          // self.isSearch = false;
          // self.isFirst = false;
        },
        (errorResource) => {
          self.loading = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    async viewVersion(id, fileId, keytopic) {
      let self = this;
      self.dialog_view_private = true;
      self.loading = true;
      self.privateID = id;
      self.fileID = fileId;
      self.temKeytopic = keytopic;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === "desc";
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : null,
        id: id,
        FileId: fileId,
        name: keytopic,
        text_org: null,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      await self.$call.ReFreshPrivateVector_FullStream(
        temp,
        self.auth_token_local,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.view_private_version = dataResponse.data.table.data;
            self.searchTotalTable_view_private = dataResponse.data.table.total;
            self.totalTable_view_private = dataResponse.data.table.total;
          } else {
            self.view_private_version = [];
            self.searchTotalTable_view_private = 0;
            self.totalTable_view_private = 0;
          }
          self.isSearch = false;
          self.loading = false;
        },
        (errorResource) => {
          self.loading = true;
          self.dialog_view_private = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    OpenPopup_Private_Memory(item) {
      var self = this;
      self.ClearValuePrivate_Memory();
      if (item == null) {
        self.requestVector = {
          modelType: null,
          modelId: null,
          vectordbName: null,
          entity: null,
          deleteAll: false,
          groupReplaceID: null,
          customCharacter: null,
          DetectLanguage: true,
          USER_CHANNEL: null,
          TopicID: null,
          // topVDB: null,
          topVDB: 3,
          // cosine: null,
          cosine: -1,
          // fileName: "",
          searchVectorDBName2: "",
          fileId: -1,
          MaxLimitedCharacter: null,
        };
        self.requestVector.MaxLimitedCharacter = self.MaxLimitedCharacter;
        self.requestVector.modelType = null;
        self.dataTable = [];
        self.searchTotalTable = 0;
        self.totalTable = 0;
        self.actionEdit = false;
        self.loadingTable = false;
        self.isSearch = false;
        self.isFirst = false;
        self.showTable = true;
        self.searchtext_org = null;
      } else {
        self.requestVector = {
          modelType: null,
          modelId: null,
          vectordbName: null,
          entity: null,
          deleteAll: false,
          groupReplaceID: null,
          customCharacter: null,
          DetectLanguage: true,
          USER_CHANNEL: null,
          TopicID: null,
          // topVDB: null,
          topVDB: 3,
          // cosine: null,
          cosine: -1,
          // fileName: item.fileName,
          fileId: item.fileId,
          MaxLimitedCharacter: null,
        };
        self.requestVector.searchVectorDBName2 = item.fileName;
        self.actionEdit = true;
        self.searchtext_org = null;
        // self.ClearValuePrivate_Memory();
        self.ReFresh();
        self.GetByVector();
      }
      self.PrivateMemoryDialog = true;
    },

    Click_Private_Memory() {
      var self = this;
      if (
        self.listMessage.length > 0 &&
        self.listMessage[self.listMessage.length - 1].status_Process != "END" &&
        self.listMessage[self.listMessage.length - 1].status_Process !=
        "Stop" &&
        self.listMessage[self.listMessage.length - 1].status_Process != "Error"
      ) {
        return;
      } else {
        if (self.KeyTopic == null) {
          self.KeyTopic = self.GetUuidv4_Fun();
        }

        self.GetListFile_PrivateMemoryFullStream(
          "OpenPopPrivateMemoryDialog_ListFile"
        );
      }
    },
    checkCustomCharacterValidate() {
      if (
        this.requestVector.modelType == 3 &&
        (this.requestVector.customCharacter == "" ||
          this.requestVector.customCharacter == null)
      ) {
        return "Required.";
      } else {
        this.customCharacter = null;
      }
      return true;
    },
    formatText(text) {
      // แปลงช่องว่างเป็น &nbsp; เพื่อให้รัฝษาช่องว่างได้
      return text.replace(/ /g, "&nbsp;");
    },
    TemplateVectorDialog() {
      let self = this;
      self.TemplateVector = true;
    },
    linkDownload(modelType, filename) {
      let self = this;
      let req = {
        modelType: modelType,
        filename: filename,
      };
      self.$call.DownloadTemplateVector_FullStream(
        req,
        self.auth_token_local,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            let fileNameshow = `Template_${modelType}_${filename}${self.findTypeName(
              filename
            )}`;
            fileLink.setAttribute("download", fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          self.TemplateVector = false;
        },
        (errorResource) => {
          self.TemplateVector = false;
          console.error(errorResource);
        }
      );
    },
    findTypeName(filename) {
      let type = "";
      switch (filename) {
        case "CSV":
          type = ".csv";
          break;
        case "Excel":
          type = ".xlsx";
          break;
        case "ExcelMultiColumn":
          type = ".xlsx";
          break;
        case "PDF":
          type = ".pdf";
          break;
        case "Word":
          type = ".docx";
          break;
        case "Text":
          type = ".txt";
          break;
        case "PowerPoint":
          type = ".pptx";
          break;
      }
      return type;
    },
    setTypeFile(val) {
      let self = this;
      switch (val) {
        case 1:
          self.accept = ".csv";
          break;
        case 2:
          self.accept =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          break;
        case 3:
          self.accept = "application/pdf";
          break;
        case 4:
          self.accept =
            ".doc, .docx, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          break;
        case 5:
          self.accept = "text/plain";
          break;
        case 6:
          self.accept =
            ".ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation";
          break;
        default:
          self.accept = "";
          break;
      }
    },
    GetDDGroupReplaceDB_FullStream() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDGroupReplaceDB_FullStream(
        self.auth_token_local,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupReplace = dataResponse.data;
          } else {
            self.DDGroupReplace = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    AddVectorperChunk() {
      let self = this;
      self.AddVector = true;
      self.Add.textORG = null;
    },
    EditVectorperChunk(item) {
      let self = this;
      self.EditVector = true;
      self.Edit.id = item.id;
      self.Edit.textORG = item.textORG;
      // self.closeUploaddialog();
    },
    SaveEdit() {
      let self = this;
      if (!self.Edit.textORG) {
        alert("Please Fill All The Fields!");
        return;
      }
      let temp = {
        ID: self.Edit.id,
        Content: self.Edit.textORG,
        MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
        groupReplaceID:
          self.tempgroupReplaceID == null
            ? null
            : JSON.stringify(self.tempgroupReplaceID),
        DetectLanguage: self.requestVector.DetectLanguage,
      };
      self.dialog = true;
      try {
        self.$call.SaveEditVector_FullStream(
          temp,
          self.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });

              self.GetByVector();
              self.closeUploaddialog();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : DeleteGroup");
      }
    },

    closeUploaddialog() {
      let self = this;
      self.EditVector = false;
      self.Edit.id = null;
      self.Edit.textORG = null;
    },

    Delete_ListFilePM_ById_FullStream(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionVector"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.Delete_ListFilePM_ById_FullStream(
                id,
                self._auth_token,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.GetListFile_PrivateMemoryFullStream("");
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : DeleteGroup");
      }
    },
    DeleteById(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionVector"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteVectorDBNameById_FullStream(
                id,
                self.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : DeleteGroup");
      }
    },
    DeleteByName(name_data) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionVectorName"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;

              let DataName_FileId = {
                name: name_data,
                FileId: self.requestVector.fileId,
              };
              self.$call.DeleteVectorDBNameByName_FullStream(
                DataName_FileId,
                self.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.dataUpdate = 0;
                    self.dataAll = 0;
                    self.actionEdit = false;
                    self.requestVector.searchVectorDBName2 = null;
                    // self.Clear();
                    self.GetByVector();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : DeleteGroup");
      }
    },
    onPaste(event) {
      if (!this.IsAllowImage) return;

      const item = event.clipboardData.items[0]; // เอาเฉพาะ index แรฝ

      if (item && item.type.startsWith("image")) {
        const file = item.getAsFile();

        const filesArray = [file];
        this.ValidateImage(filesArray);
        const reader = new FileReader();

        reader.onload = (e) => {
          this.fileDataUrl = e.target.result;
          this.ValidateImage(filesArray);
          this.UploadImage();
        };

        reader.readAsDataURL(file);
        event.preventDefault(); // ป้องฝันการวางค่าอื่น ๆ
      } else {
        console.log(self.products)
        console.log("Not an image or unsupported content");
      }
    },
    UploadImage() {
      let self = this;
      if (!self.requestUpload.entity) {
        alert("Please Fill All The Fields!");
        return;
      }
      self.requestUpload.USER_CHANNEL = self.User_Id;
      self.loadingImage = true;
      try {
        self.$call.UploadImage_FullStream(
          self.requestUpload,
          self.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.ImageURL = dataResponse.data;
              self.requestUpload.entity = null;
              self.uploadedFiles = [];
            } else {
              self.$swal.fire({
                icon: "error",
                title: this.$t("errorUploadImage"),
                showConfirmButton: false,
                timer: 2500,
              });
              self.ClearImage();
            }
            self.loadingImage = false;
          },
          (errorResource) => {
            self.$swal.fire({
              icon: "error",
              title: this.$t("errorUploadImage"),
              showConfirmButton: false,
              timer: 2500,
            });
            self.loadingImage = false;
            self.ImageURL = null;
            self.fileDataUrl = null;
            self.requestUpload.entity = null;
            console.error(errorResource);
          }
        );
      } catch (error) {
        self.GetTopicFullStream("Start");
      }
    },
    ClearImage() {
      let self = this;
      self.ImageURL = null;
      self.fileDataUrl = null;
      self.loadingImage = false;
      self.requestUpload.entity = null;
      self.uploadedFiles = [];
    },
    processUploadImage(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestUpload.entity = null;
        this.uploadedFiles = [];
        return;
      }
      if (
        this.FileUploadLimit != null &&
        this.FileUploadLimit != "" &&
        this.FileUploadLimit != undefined &&
        this.FileUploadLimit != 0
      ) {
        const maxSize = this.FileUploadLimit * 1024; // this.FileUploadLimit KB
        if (this.files[0].size > maxSize) {
          this.$swal.fire({
            icon: "error",
            title: `ไฟล์มีขนาดใหญ่เกิน ${this.FileUploadLimit} KB`,
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      } else {
        const maxSize = 2048 * 1024; // 2048 KB
        if (this.files[0].size > maxSize) {
          this.$swal.fire({
            icon: "error",
            title: `ไฟล์มีขนาดใหญ่เกิน 2048 KB`,
            showConfirmButton: false,
            timer: 1500,
          });
          return;
        }
      }
      const file = e[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.fileDataUrl = e.target.result;
        this.ValidateImage(this.files);
        this.UploadImage();
      };
      reader.readAsDataURL(file);
    },
    ValidateImage(files) {
      const formDataDoc = new FormData();
      formDataDoc.append("entity", files[0]);
      this.uploadedFiles = files;
      this.requestUpload.entity = formDataDoc;
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.requestVector.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]);
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSVVector(text, this.files);
        this.ConfirmProcess();
      };
    },
    ValidateCSVVector(csv, files) {
      const formDataDoc = new FormData();
      formDataDoc.append("entity", files[0]);
      this.uploadedFiles = files;
      this.requestVector.entity = formDataDoc;
    },
    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          icon: "warning",
          title: this.$t("importPrivate_MemoryTitle"),
          // text: "คุณต้องการนำเข้า Vector",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.Save();
          }
        });
    },
    Save() {
      let self = this;
      if (
        !self.requestVector.modelType ||
        !self.KeyTopic ||
        !self.requestVector.entity ||
        !self.requestVector.topVDB
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      if (
        self.requestVector.modelType == 3 &&
        !self.requestVector.customCharacter
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      if (
        self.requestVector.MaxLimitedCharacter == null ||
        self.requestVector.MaxLimitedCharacter == "" ||
        self.requestVector.MaxLimitedCharacter == undefined
      ) {
        alert("Please fill in the Custom Max Character");
        return;
      }
      self.requestVector.searchVectorDBName2 =
        self.requestVector.searchVectorDBName2 == null
          ? ""
          : self.requestVector.searchVectorDBName2;
      if (
        self.requestVector.searchVectorDBName2 == "" ||
        self.requestVector.searchVectorDBName2.replace(/ /g, "") == ""
      ) {
        if (self.uploadedFiles != null && self.uploadedFiles.length > 0) {
          var indexLast_Name_uploadedFiles =
            self.uploadedFiles[0].name.lastIndexOf(".");

          self.requestVector.searchVectorDBName2 =
            self.uploadedFiles[0].name.substring(
              0,
              indexLast_Name_uploadedFiles == -1
                ? self.uploadedFiles[0].name.length
                : indexLast_Name_uploadedFiles
            );
        }
      }

      self.requestVector.vectordbName = self.KeyTopic;

      self.requestVector.USER_CHANNEL = self.User_Id;
      self.requestVector.TopicID = self.Log_History_TopicID;

      self.dialog = true;
      try {
        self.requestVector.groupReplaceID =
          self.tempgroupReplaceID == null
            ? null
            : JSON.stringify(self.tempgroupReplaceID);
        self.$call.UploadCSV2Vector_FullStream(
          self.requestVector,
          self.auth_token_local,
          (dataResponse) => {
            // if(self.Log_History_TopicID == -1){
            // self.GetTopicFullStream("GetAllTopic");
            // }
            // self.GetListFile_PrivateMemory("");
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.KeyTopic = self.requestVector.vectordbName;
              self.requestVector.entity = null;
              self.showTable = true;
              self.actionEdit = true;
              self.flagNew = false;
              self.uploadedFiles = [];
              self.requestVector.fileId = dataResponse.data.fileId;
              self.GetByVector();
            }
            self.dialog = false;
          },
          (errorResource) => {
            // if(self.Log_History_TopicID == -1){
            self.GetTopicFullStream("Start");
            // }
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // if(self.Log_History_TopicID == -1){
        self.GetTopicFullStream("Start");
        // }
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : DeleteGroup");
      }
    },
    SaveFile() {
      let self = this;
      self.requestVector.modelType = 1;
      if (
        self.requestVector.MaxLimitedCharacter == null ||
        self.requestVector.MaxLimitedCharacter == "" ||
        self.requestVector.MaxLimitedCharacter == undefined
      ) {
        alert("Please fill in the Custom Max Character");
        return;
      }
      self.requestVector.fileName = this.GetUuidv4_Fun();
      self.requestVector.searchVectorDBName2 = this.GetUuidv4_Fun();
      self.requestVector.vectordbName = self.KeyTopic;

      self.requestVector.USER_CHANNEL = self.User_Id;
      self.requestVector.TopicID = self.Log_History_TopicID;
      self.dialog = true;
      try {
        self.requestVector.groupReplaceID =
          self.tempgroupReplaceID == null
            ? null
            : JSON.stringify(self.tempgroupReplaceID);
        self.requestVector.fileId = -1;
        self.requestVector.deleteAll = false;
        self.$call.UploadCSV2Vector_FullStream(
          self.requestVector,
          self.auth_token_local,
          (dataResponse) => {
            if (self.Log_History_TopicID == -1) {
              self.GetTopicFullStream("Start");
            }
            if (dataResponse.status == 0) {
              self.KeyTopic = self.requestVector.vectordbName;
              self.requestVector.entity = null;
              self.showTable = true;
              self.actionEdit = true;
              self.flagNew = false;
              self.uploadedFiles = [];
              self.requestVector.fileId = dataResponse.data.fileId;
              self.GetByVector();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        console.log("catch : DeleteGroup");
      }
    },
    ClearValuePrivate_Memory() {
      let self = this;
      self.showTable = false;

      self.requestVector.entity = null;
      self.requestVector.modelId = null;
      self.requestVector.searchVectorDBName2 = null;
      self.tempgroupReplaceID = null;
      self.doctype = null;
      self.vectortype = null;
      self.requestVector.vectordbName = null;
      self.requestVector.customCharacter = null;
      self.requestVector.modelType = null;
      self.requestVector.DetectLanguage = true;

      self.dataTable = [];
      self.searchTotalTable = 0;
      self.totalTable = 0;

      self.dataUpdate = 0;
      self.dataAll = 0;
      self.exceptionFlag = false;

      self.loadingTable = false;
      self.isSearch = false;
      // self.isFirst = false;
      self.showTable = true;
      (self.options = {
        page: 1,
        itemsPerPage: self.itemsPerPage,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false,
      }),
        (self.sortBy = []);
      self.sortDesc = [];
      if (self.Axios_VECTOR != null) {
        self.Axios_VECTOR.abort();
      }
    },

    GetByVector() {
      let self = this;
      self.$nextTick(() => {
        if (
          self.requestVector.fileId == null ||
          self.requestVector.fileId == -1 ||
          self.requestVector.fileId == ""
        ) {
          self.flagNew = true;
          return;
        }
        self.loadingTable = true;
        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }

        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          name: self.KeyTopic,
          fileId: self.requestVector.fileId,
          sortDesc: sortOrder,
          sortBy: sortField,
        };

        self.Axios_VECTOR = new AbortController();

        let Config = {
          signal: self.Axios_VECTOR.signal,
        };

        self.$call.ReFreshVector_FullStream(
          temp,
          Config,
          self.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.dataUpdate = dataResponse.data.dataUpdate;
              self.dataAll = dataResponse.data.dataAll;
              self.exceptionFlag = dataResponse.data.exceptionFlag;
              self.searchTotalTable = dataResponse.data.table.total;
              self.dataTable = dataResponse.data.table.data;
              self.totalTable = dataResponse.data.table.total;
              self.tempgroupReplaceID = dataResponse.data.groupReplaceID;
              // if (this.$route.query.name) {

              // self.requestVector.customCharacter = dataResponse.data.customCharacter;
              //   self.requestVector.modelType = (dataResponse.data.modelType == 0 || dataResponse.data.modelType == null ? 1 : dataResponse.data.modelType);
              //  self.requestVector.DetectLanguage = dataResponse.data.detectLanguage;
              if (this.$route.query.name) {
                self.requestVector.customCharacter =
                  dataResponse.data.customCharacter;
                self.requestVector.modelType = dataResponse.data.modelType;
                self.requestVector.DetectLanguage =
                  dataResponse.data.detectLanguage;
                self.requestVector.MaxLimitedCharacter =
                  dataResponse.data.maxLimitedCharacter;
              }

              // self.requestVector.modelType = 1;
              // self.requestVector.customCharacter = null;
              // self.requestVector.deleteAll = false;
              // self.requestVector.DetectLanguage = true;

              // }

              //   self.requestVector.topVDB = dataResponse.data.topVDB;
              //     self.requestVector.cosine = dataResponse.data.cosine;

              self.AutoRefresh();
            } else {
              self.dataTable = [];
              self.searchTotalTable = 0;
              self.totalTable = 0;
              self.actionEdit = false;
            }
            self.loadingTable = false;
            self.isSearch = false;
            // self.isFirst = false;
            self.showTable = true;
            self.dataTable.forEach((element) => {
              element.show = self.showAllText;
            });
          },
          (errorResource) => {
            self.loadingTable = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      });
    },
    ReProcess() {
      let self = this;
      if (
        self.requestVector.MaxLimitedCharacter == null ||
        self.requestVector.MaxLimitedCharacter == "" ||
        self.requestVector.MaxLimitedCharacter == undefined
      ) {
        alert("Please fill in the Custom Max Character");
        return;
      }
      self.$swal
        .fire({
          icon: "warning",
          title: this.$t("vectorReprocess"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              let data = {
                VectordbName: self.KeyTopic,
                FileId: self.requestVector.fileId,
                MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
                groupReplaceID:
                  self.tempgroupReplaceID == null
                    ? null
                    : JSON.stringify(self.tempgroupReplaceID),
                DetectLanguage: self.requestVector.DetectLanguage,
              };
              self.$call.ReProcessedVector_FullStream(
                data,
                self.auth_token_local,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    //self.ClearValuePrivate_Memory();
                    self.GetByVector();
                  }
                },
                (errorResource) => {
                  console.error(errorResource.message);
                }
              );
            } catch (error) {
              // this.LogTrace(error, 'ReProcess');

              console.log("catch : ReProcess");
            }
          } else {
            return;
          }
        });
    },
    ReFresh() {
      try {
        let self = this;
        if (self.KeyTopic != null && self.KeyTopic != "") {
          let { page, itemsPerPage } = this.options;
          self.sortBy =
            self.options.sortBy.length == 0 ? null : self.options.sortBy[0];
          self.sortDesc =
            self.options.sortDesc.length == 0 ? null : self.options.sortDesc[0];
          let temp = {
            page: self.isSearch ? 1 : page,
            perPage: itemsPerPage != -1 ? itemsPerPage : null,
            name: self.KeyTopic,
            TopicID: self.Log_History_TopicID,
            fileId: self.requestVector.fileId,
            text_org: self.searchtext_org,
            sortDesc: self.sortDesc,
            sortBy: self.sortBy,
          };
          self.Axios_VECTOR = new AbortController();

          let Config = {
            signal: self.Axios_VECTOR.signal,
          };

          self.$call.ReFreshVector_FullStream(
            temp,
            Config,
            self.auth_token_local,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.dataUpdate = dataResponse.data.dataUpdate;
                self.dataAll = dataResponse.data.dataAll;
                self.exceptionFlag = dataResponse.data.exceptionFlag;
                self.searchTotalTable = dataResponse.data.table.total;
                self.dataTable = dataResponse.data.table.data;
                self.totalTable = dataResponse.data.table.total;
                self.modelType = dataResponse.data.modelType;
                self.requestVector.MaxLimitedCharacter =
                  dataResponse.data.maxLimitedCharacter;
                if (self.dataUpdate == self.dataAll) {
                  self.uploadFileComplete = true;
                }
                // self.requestVector.topVDB = dataResponse.data.topVDB;
                // self.requestVector.cosine = dataResponse.data.cosine;
              }
              self.totalTable = self.totalTable + 1;
              self.isSearch = false;
            },
            (errorResource) => {
              self.isSearch = false;
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) {
        // this.LogTrace(error, 'ReFresh');

        console.log("catch : ReFresh");
      }
    },
    async AutoRefresh() {
      let self = this;
      let death_waiting = true;
      do {
        if (self.KeyTopic != null && self.KeyTopic != "") {
          if (self.dataUpdate == self.dataAll || self.exceptionFlag)
            death_waiting = false;
          else self.ReFresh();
          // if (window.location.pathname != '/UploadVector') death_waiting = false;
        }
        // console.log('Wait for 5 seconds!');
        await new Promise((resolve) => setTimeout(resolve, 5000));
      } while (death_waiting);
    },
    closeUploaddialogAdd() {
      let self = this;
      self.AddVector = false;
      self.Add.id = null;
      self.Add.textORG = null;
    },

    SaveAdd() {
      let self = this;

      // if (self.requestVector.topVDB == "" || self.requestVector.topVDB == null) {
      //   self.requestVector.topVDB = (self.requestVector.topVDB == "" ? 3 : 3);

      // }
      // if (!self.Add.textORG || !self.requestVector.modelType || !self.KeyTopic || !self.requestVector.topVDB) {

      //   alert('Please Fill All The Fields!');
      //   return;
      // }
      // if (self.requestVector.modelType == 3 && !self.requestVector.customCharacter) {
      //   alert('Please Fill All The Fields!');
      //   return;
      // }
      self.requestVector.modelType =
        self.requestVector.modelType == null || !self.requestVector.modelType
          ? self.modelType == null
            ? 1
            : self.modelType
          : self.requestVector.modelType;

      if (
        !self.Add.textORG ||
        !self.requestVector.modelType ||
        !self.requestVector.searchVectorDBName2
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      if (
        self.requestVector.modelType == 3 &&
        !self.requestVector.customCharacter
      ) {
        alert("Please Fill All The Fields!");
        return;
      }
      if (
        self.requestVector.MaxLimitedCharacter == null ||
        self.requestVector.MaxLimitedCharacter == "" ||
        self.requestVector.MaxLimitedCharacter == undefined
      ) {
        alert("Please fill in the Custom Max Character");
        return;
      }
      self.requestVector.searchVectorDBName2 =
        self.requestVector.searchVectorDBName2 == null
          ? ""
          : self.requestVector.searchVectorDBName2;
      if (
        self.requestVector.searchVectorDBName2 == "" ||
        self.requestVector.searchVectorDBName2.replace(/ /g, "") == ""
      ) {
        self.requestVector.searchVectorDBName2 =
          self.Add.textORG == null ? "" : self.Add.textORG;
      }
      self.requestVector.vectordbName = self.KeyTopic;

      let temp = {
        vectordbName: self.requestVector.vectordbName,
        modelType: self.requestVector.modelType,
        detectLanguage: self.requestVector.DetectLanguage,
        groupReplaceID:
          self.tempgroupReplaceID == null
            ? null
            : JSON.stringify(self.tempgroupReplaceID),
        Content: self.Add.textORG,
        flagNew: self.flagNew,
        customCharacter: self.requestVector.customCharacter,
        USER_CHANNEL: self.User_Id,
        TopicID: self.Log_History_TopicID,
        topVDB: self.requestVector.topVDB,
        cosine: self.requestVector.cosine,
        fileId: self.requestVector.fileId,
        fileName: self.requestVector.searchVectorDBName2,
        MaxLimitedCharacter: self.requestVector.MaxLimitedCharacter,
      };
      self.dialog = true;

      try {
        self.$call.SaveAddVector_FullStream(
          temp,
          self.auth_token_local,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              // if(self.Log_History_TopicID == -1){
              self.GetTopicFullStream("Start");
              // }
              // self.GetListFile_PrivateMemory("");
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.showTable = true;
              self.actionEdit = true;
              self.flagNew = false;
              self.GetByVector();
              self.closeUploaddialogAdd();

              self.requestVector.fileId = dataResponse.data.fileId;
            } else {
              // if(self.Log_History_TopicID == -1){
              self.GetTopicFullStream("Start");
              // }
              self.VectorDBNameDuplicate = self.KeyTopic;
              // self.searchVectorDBName2 = null;
              self.$swal.fire({
                icon: "error",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 2500,
              });
            }
            self.dialog = false;
          },
          (errorResource) => {
            // if(self.Log_History_TopicID == -1){
            self.GetTopicFullStream("Start");
            // }
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // if(self.Log_History_TopicID == -1){
        self.GetTopicFullStream("Start");
        // }
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : DeleteGroup");
      }
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.ReFresh();
    },
    ShowAll() {
      let self = this;
      self.showAllText = !self.showAllText;
      self.dataTable.forEach((element) => {
        element.show = self.showAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.showAllText = !self.showAllText;
      self.dataTable.forEach((element) => {
        element.show = self.showAllText;
      });
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkValidate() {
      let self = this;
      // if (this.requestVector.topVDB == '' || this.requestVector.topVDB == null) {
      //   return "Required.";
      // } else if (parseInt(this.requestVector.topVDB) == 0) {
      //   return "Required.";
      // }
      if (
        self.requestVector.searchVectorDBName2 == "" ||
        self.requestVector.searchVectorDBName2 == null
      ) {
        return "Required.";
      } else if (
        self.VectorDBNameDuplicate == self.requestVector.searchVectorDBName2
      ) {
        return "Duplicate.";
      }
      return true;
    },

    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleKeypress(evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      const validCharactersRegex = /^[a-zA-Z0-9\u0E00-\u0E7F]+$/;

      if (!validCharactersRegex.test(String.fromCharCode(charCode))) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    GetMaxLimitedCharacter() {
      let self = this;
      self.dialog = true;
      self.$call.GetMaxLimitedCharacter_FullStream(
        self.auth_token_local,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.MaxLimitedCharacter = dataResponse.data;
          } else {
            self.MaxLimitedCharacter = self.requestVector.MaxLimitedCharacter;
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    SaveCosine_TopVDB() {
      var self = this;

      try {
        let _Data = {
          TopicName: "Private Memory",
          KeyTopic: self.KeyTopic,
          TopicID: self.Log_History_TopicID,
          topVDB: self.requestVector.topVDB,
          cosine: self.requestVector.cosine,
          USER_CHANNEL: self.User_Id,
        };

        self.$call.SaveCosine_TopVDBFullStream(
          _Data,
          self.auth_token_local,
          (Response) => {
            if (Response.status == 0 && Response.data != null) {
              self.GetTopicFullStream("Start");
            }
            self.PrivateMemoryDialog = false;
          },
          () => {
            console.log("catch");
            self.PrivateMemoryDialog = false;
          }
        );
      } catch {
        console.log("catch");
        self.PrivateMemoryDialog = false;
      }
    },
    SaveFileName_PrivateMemoryFullStream() {
      var self = this;

      try {
        let _Data = {
          FileId: self.requestVector.fileId,
          USER_CHANNEL: self.User_Id,
          FileName: self.requestVector.searchVectorDBName2,
        };
        self.$call.SaveFileName_PrivateMemoryFullStream(
          _Data,
          self.auth_token_local,
          (Response) => {
            if (Response.status == 0 && Response.data != null) {
              self.GetListFile_PrivateMemoryFullStream("");
            }
            self.PrivateMemoryDialog = false;
          },
          () => {
            console.log("catch");
            self.PrivateMemoryDialog = false;
          }
        );
      } catch {
        console.log("catch");
        self.PrivateMemoryDialog = false;
      }
    },

    CloseFileName_PrivateMemory() {
      var self = this;
      self.GetListFile_PrivateMemoryFullStream("");
      self.PrivateMemoryDialog = false;
    },

    GetListFile_PrivateMemoryFullStream(StatusText) {
      try {
        let self = this;
        if (self.KeyTopic != null && self.KeyTopic != "") {
          let { page, itemsPerPage } = this.options_ListFilePM;
          let temp = {
            page: self.isSearch_ListFilePM ? 1 : page,
            perPage:
              itemsPerPage != -1 ? itemsPerPage : self.totalTable_ListFilePM,
            KeyTopic: self.KeyTopic,
            USER_CHANNEL: self.User_Id,
          };
          self.$call.GetListFile_PrivateMemoryFullStream(
            temp,
            self.auth_token_local,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.searchTotalTable_ListFilePM =
                  dataResponse.data.table.total;
                self.dataTable_ListFilePM = dataResponse.data.table.data;
                self.totalTable_ListFilePM = dataResponse.data.table.total;

                if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {
                  self.PrivateMemoryDialog_ListFile = true;
                }
              } else {
                self.NotificationTokenExpired();
              }
            },
            (errorResource) => {
              if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {
                self.PrivateMemoryDialog_ListFile = true;
              }
              console.error(errorResource.message);
            }
          );
        }
      } catch (error) {
        // this.LogTrace(error, 'GetListFile_PrivateMemory');

        if (StatusText == "OpenPopPrivateMemoryDialog_ListFile") {
          self.PrivateMemoryDialog_ListFile = true;
        }
        console.log("catch : GetListFile_PrivateMemoryFullStream");
      }
    },

    click_account_voice() {
      let self = this;
      if (
        self.listMessage.length > 0 &&
        self.listMessage[self.listMessage.length - 1].status_Process != "END" &&
        self.listMessage[self.listMessage.length - 1].status_Process !=
        "Stop" &&
        self.listMessage[self.listMessage.length - 1].status_Process != "Error"
      ) {
        return;
      } else {
        self.TypeInputAudio = "M";
        self.Uploaddialog = true;
      }
    },

    click_music_box() {
      var self = this;
      if (
        self.listMessage.length > 0 &&
        self.listMessage[self.listMessage.length - 1].status_Process != "END" &&
        self.listMessage[self.listMessage.length - 1].status_Process !=
        "Stop" &&
        self.listMessage[self.listMessage.length - 1].status_Process != "Error"
      ) {
        return;
      } else {
        self.TypeInputAudio = "F";
        self.Uploaddialog = true;
      }
    },

    SetTimeout(time) {
      let self = this;
      return setTimeout(() => {
        self.Click_StopVoice();
      }, time);
    },
    async checkMicrophonePermission() {
      try {
        // ตรวจสอบว่าเบราว์เซอร์รองรับ permissions API หรือไม่
        if (navigator.permissions) {
          const permission = await navigator.permissions.query({ name: 'microphone' });
          return permission.state === 'granted';
        }
        
        // หาฝไม่รองรับ permissions API ให้ลองเข้าถึงโดยตรง
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop());
        return true;
      } catch (error) {
        console.log('Microphone permission denied or not available:', error);
        return false;
      }
    },

    async requestMicrophonePermission() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(track => track.stop());
        return true;
      } catch (error) {
        console.log('Failed to get microphone permission:', error);
        return false;
      }
    },

    async Click_StartVoice() {
      /* eslint-disable */

      let self = this;
      // ตรวจสอบ permission ฝ่อนเริ่ม
      const hasPermission = await self.checkMicrophonePermission();
      if (!hasPermission) {
        const granted = await self.requestMicrophonePermission();
        if (!granted) {
          self.listMessage.push({
            messageUser: "พูด...",
            messageBot: "ไม่สามารถเข้าถึงไมโครโฟนได้ กรุณาอนุญาตการใช้งานไมโครโฟน",
            status_Process: "END",
          });
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            self.ChatRef_ScrollIntoView();
          }, 5);
          return;
        }
      }

      self.messageData = "";

      let _SpeechSDK = SpeechSDK;
      const audioConfig = _SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      const speechConfig = _SpeechSDK.SpeechConfig.fromSubscription(
        self.SubscriptionKey,
        self.Region
      );
      speechConfig.setProperty(
        _SpeechSDK.PropertyId[
        _SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs
        ],
        "1500"
      );
      speechConfig.setProperty(
        _SpeechSDK.PropertyId[
        _SpeechSDK.PropertyId.SpeechServiceConnection_LanguageIdMode
        ],
        "Continuous"
      );
      let autoDetectSourceLanguageConfig =
        _SpeechSDK.AutoDetectSourceLanguageConfig.fromLanguages([self.LangPop]);
      self.SpeechRecognizer = _SpeechSDK.SpeechRecognizer.FromConfig(
        speechConfig,
        autoDetectSourceLanguageConfig,
        audioConfig
      );
      setTimeout(() => {
        self.CountScroll = self.MaxCountScroll;
        self.ChatRef_ScrollIntoView();
      }, 5);
      let _temp_text = "";
      let _temp_textOld = "";
      self.SpeechRecognizer.recognizing = (s, e) => {
        if (self.TimeOutStop != null) {
          clearTimeout(self.TimeOutStop);
          self.TimeOutStop = null;
        }
        if (self.listMessage.length > 0) {
          if (self.listMessage[self.listMessage.length - 1].messageBot == "-") {
            self.listMessage[self.listMessage.length - 1].messageBot = "*";
            self.listMessage[self.listMessage.length - 1].messageUser = "";
          }
          self.listMessage[self.listMessage.length - 1].messageUser =
            _temp_textOld + (_temp_textOld == "" ? "" : " ") + e.result.text;
        }
      };
      self.SpeechRecognizer.recognized = (s, e) => {
        if (e.result.reason == _SpeechSDK.ResultReason.RecognizedSpeech) {
          if (self.listMessage.length > 0) {
            if (
              self.listMessage[self.listMessage.length - 1].messageBot == "-"
            ) {
              self.listMessage[self.listMessage.length - 1].messageBot = "*";
              self.listMessage[self.listMessage.length - 1].messageUser = "";
            }
            self.listMessage[self.listMessage.length - 1].messageUser =
              _temp_text + (_temp_text == "" ? "" : "") + e.result.text;
            _temp_text += (_temp_text == "" ? "" : "") + e.result.text;
            _temp_textOld =
              self.listMessage[self.listMessage.length - 1].messageUser;
          }
        } else if (e.result.reason == _SpeechSDK.ResultReason.NoMatch) {
          console.log("NOMATCH: Speech could not be translated.");
        } else {
          console.log("ss " + e.result.reason);
        }
      };
      self.SpeechRecognizer.canceled = (s, e) => {
        console.log("canceled.");
        if (self.TimeOutStop != null) {
          clearTimeout(self.TimeOutStop);
          self.TimeOutStop = null;
        }
      };
      self.SpeechRecognizer.sessionStarted = (s, e) => {
        console.log("sessionStarted.");
        if (self.TimeOutStop != null) {
          clearTimeout(self.TimeOutStop);
          self.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON());
        self.TimeOutStop = self.SetTimeout(self.TimeoutFirst);
      };
      self.SpeechRecognizer.sessionStopped = (s, e) => {
        if (self.TimeOutStop != null) {
          clearTimeout(self.TimeOutStop);
          self.TimeOutStop = null;
        }
        console.log("sessionStopped.");
        if (
          self.listMessage.length > 0 &&
          self.listMessage[self.listMessage.length - 1].messageBot == "*"
        ) {
          self.messageData =
            self.listMessage[self.listMessage.length - 1].messageUser;
          if (
            self.listMessage.length > 0 &&
            self.listMessage[self.listMessage.length - 1].status_Process ==
            "VoiceStart"
          ) {
            self.listMessage.pop();
          }
          self.SendOpenAi("Click");
        } else if (self.listMessage.length > 0) {
          if (
            self.listMessage.length > 0 &&
            self.listMessage[self.listMessage.length - 1].status_Process ==
            "VoiceStart"
          ) {
            self.listMessage.pop();
          }
        }
      };
      self.SpeechRecognizer.speechStartDetected = (s, e) => {
        console.log("(StartDetected) SessionId: " + e.sessionId);
        if (self.TimeOutStop != null) {
          clearTimeout(self.TimeOutStop);
        }
      };
      self.SpeechRecognizer.speechEndDetected = (s, e) => {
        console.log("(EndDetected) SessionId: " + e.sessionId);
        if (self.TimeOutStop != null) {
          clearTimeout(self.TimeOutStop);
          self.TimeOutStop = null;
        }
        console.log("Start : " + new Date().toJSON());
        self.TimeOutStop = self.SetTimeout(self.Timeout);
      };
      self.SpeechRecognizer.startContinuousRecognitionAsync(
        (e) => { },
        (error) => {
          if (
            self.listMessage.length > 0 &&
            self.listMessage[self.listMessage.length - 1].status_Process ==
            "VoiceStart" &&
            error ==
            "Error occurred during microphone initialization: NotAllowedError: Permission denied"
          ) {
            self.listMessage[self.listMessage.length - 1].status_Process =
              "END";
            self.listMessage[self.listMessage.length - 1].messageBot =
              "ไม่มีสิทธ์เข้าถึงไมค์";
          } else if (
            self.listMessage.length > 0 &&
            self.listMessage[self.listMessage.length - 1].status_Process ==
            "VoiceStart"
          ) {
            self.listMessage[self.listMessage.length - 1].status_Process =
              "END";
            self.listMessage[self.listMessage.length - 1].messageBot =
              "เกิดข้อผิดพลาด";
          } else {
            self.listMessage.push({
              messageUser: "พูด...",
              messageBot: "เกิดข้อผิดพลาด",
              status_Process: "END",
            });
          }
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            self.ChatRef_ScrollIntoView();
          }, 5);
        }
      );
      if (
        self.listMessage.length > 0 &&
        self.listMessage[self.listMessage.length - 1].status_Process == "END" &&
        self.messageRes.length > 0
      ) {
        if (
          self.listMessage[self.listMessage.length - 1].messageBot.length <
          self.messageRes[self.messageRes.length - 1].length
        ) {
          self.Count_messageRes[self.listMessage.length - 1] = 0;
          self.StatusPro = true;
          self.messageRun = "";
          self.listMessage[self.listMessage.length - 1].messageBot =
            self.messageRes[self.messageRes.length - 1];
          self.messageRes[self.messageRes.length - 1] = "";
        }
      }
      self.listMessage.push({
        messageUser: "พูด...",
        messageBot: "-",
        status_Process: "VoiceStart",
      });
    },
    Click_StopVoice() {
      let self = this;
      if (self.TimeOutStop != null) {
        clearTimeout(self.TimeOutStop);
        self.TimeOutStop = null;
      }
      if (self.SpeechRecognizer != null) {
        self.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
    },
    Convest_Speech_To_Text(Ob_DataFile) {
      let self = this;
      let formData = new FormData();
      let OB_DF = Ob_DataFile;
      if (
        self.listMessage.length > 0 &&
        self.listMessage[self.listMessage.length - 1].status_Process == "END" &&
        self.messageRes.length > 0
      ) {
        if (
          self.listMessage[self.listMessage.length - 1].messageBot.length <
          self.messageRes[self.messageRes.length - 1].length
        ) {
          self.Count_messageRes[self.listMessage.length - 1] = 0;
          self.StatusPro = true;
          self.messageRun = "";
          self.listMessage[self.listMessage.length - 1].messageBot =
            self.messageRes[self.messageRes.length - 1];
          self.messageRes[self.messageRes.length - 1] = "";
        }
      }
      if (OB_DF.Status == false) {
        self.listMessage.push({
          messageUser: "ไฟล์เสียง",
          messageBot: OB_DF.manualContent,
          status_Process: "END",
        });
        setTimeout(() => {
          self.CountScroll = self.MaxCountScroll;
          self.ChatRef_ScrollIntoView();
        }, 5);
        return;
      } else {
        self.listMessage.push({
          messageUser: "ไฟล์เสียง " + OB_DF.NameFile,
          messageBot: "",
          status_Process: "Process",
        });
        setTimeout(() => {
          self.CountScroll = self.MaxCountScroll;
          self.ChatRef_ScrollIntoView();
        }, 5);
      }
      self.Axios_ControllerAduio = new AbortController();
      let Config = {
        signal: self.Axios_ControllerAduio.signal,
      };
      formData.append("FileSoeech", OB_DF.DataFile);
      formData.append("LangPop", self.LangPop);
      self.$call.GetConvest_Speech_To_Text(
        formData,
        Config,
        (response) => {
          if (response.status == 0 && response.data.status == true) {
            self.listMessage.pop();
            if (response.data.data != "") {
              self.messageData = response.data.data;
              self.SendOpenAi("Click");
            } else {
              self.listMessage.push({
                messageUser: "ไม่พบข้อมูลเสียงในไฟล์",
                messageBot: "",
                status_Process: "END",
              });
            }
          } else {
            if (self.listMessage.length > 0) {
              self.listMessage[self.listMessage.length - 1].messageBot =
                response.data.textError;
              self.listMessage[self.listMessage.length - 1].status_Process =
                "END";
              if (
                self.listMessage[self.listMessage.length - 1].messageBot
                  .length > 0 &&
                self.listMessage[
                  self.listMessage.length - 1
                ].messageBot.substring(
                  self.listMessage[self.listMessage.length - 1].messageBot
                    .length - 47,
                  self.listMessage[self.listMessage.length - 1].messageBot
                    .length
                ) == '<span class="blinking-cursor" style="">|</span>'
              ) {
                self.listMessage[self.listMessage.length - 1].messageBot =
                  self.listMessage[
                    self.listMessage.length - 1
                  ].messageBot.substring(
                    0,
                    self.listMessage[self.listMessage.length - 1].messageBot
                      .length - 47
                  );
              }
            }
          }
        },
        () => {
          if (self.listMessage.length > 0) {
            self.listMessage[self.listMessage.length - 1].messageBot =
              "แปลงไฟล์เสียงไม่ได้";
            self.listMessage[self.listMessage.length - 1].status_Process =
              "END";
            if (
              self.listMessage[self.listMessage.length - 1].messageBot.length >
              0 &&
              self.listMessage[
                self.listMessage.length - 1
              ].messageBot.substring(
                self.listMessage[self.listMessage.length - 1].messageBot
                  .length - 47,
                self.listMessage[self.listMessage.length - 1].messageBot.length
              ) == '<span class="blinking-cursor" style="">|</span>'
            ) {
              self.listMessage[self.listMessage.length - 1].messageBot =
                self.listMessage[
                  self.listMessage.length - 1
                ].messageBot.substring(
                  0,
                  self.listMessage[self.listMessage.length - 1].messageBot
                    .length - 47
                );
            }
          }
        }
      );
    },
    Click_FileButtonVoid() {
      var self = this;
      if (
        self.listMessage.length > 0 &&
        self.listMessage[self.listMessage.length - 1].status_Process != "END" &&
        self.listMessage[self.listMessage.length - 1].status_Process != "Stop"
      ) {
        return;
      }

      document.getElementById("inputFileVoid").click();
    },
    Chang_InputFileVoid(e) {
      let self = this;
      const files = e.target.files;

      if (files[0] == undefined) {
        return;
      }
      if (
        files[0] !== undefined &&
        (files[0].type == "audio/wav" ||
          files[0].type == "audio/mpeg" ||
          files[0].type == "audio/x-m4a")
      ) {
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          let Output = {
            Status: true,
            NameFile: files[0].name,
            DataFile: files[0],
            manualContent: files[0].type,
          };
          document.getElementById("inputFileVoid").value = "";
          self.Convest_Speech_To_Text(Output);
        });
      } else {
        let Output = {
          Status: false,
          NameFile: null,
          DataFile: null,
          manualContent: "รองรับไฟล์ MP3, WAV และ M4A เท่านั้น",
        };
        document.getElementById("inputFileVoid").value = "";

        self.Convest_Speech_To_Text(Output);
      }
    },

    GetUuidAll() {
      let self = this;
      if (
        self.parameterURL.userid == null ||
        self.parameterURL.userid == undefined ||
        self.parameterURL.userid == ""
      ) {
        //self.GetUuidv4();
        if (self.role.ID == "5") {
          self.GetMSTeam();
        }
        else {
          this.GetUuidv4();
          this.GetModelQuickGroupInModelGroup();
        }
        self.Flag_Start = false;
      } else {
        
          self.Flag_Start = true;
          self.User_Id = self.parameterURL.userid;
          self.User_Id_Show = self.parameterURL.userid;
          self.GetModelQuickGroupInModelGroup();
        
      }
    },

    GetUuidv4_BK() {
      let self = this;
      if (
        self.User_Id == null ||
        self.User_Id == undefined ||
        self.User_Id == ""
      ) {
        let Uuid = "10000000-1000-4000-8000-100000000000".replace(
          /[018]/g,
          (c) =>
            (
              c ^
              (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
            ).toString(16)
        );
        self.User_Id = Uuid;
        self.User_Id_Show = Uuid;
      }
    },

    GetUuidv4() {
      let self = this;
      if (
        self.User_Id == null ||
        self.User_Id == undefined ||
        self.User_Id == ""
      ) {
        let Uuid = self.GetUuidv4_Fun();
        self.User_Id = Uuid;
        self.User_Id_Show = Uuid;
        self.GetTopicFullStream("Start");
      }
    },
    GetUuidv4_Fun() {
      let self = this;
      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
      return Uuid;
    },

    GetUuidv4_Fun_User_Id_Null() {
      let self = this;
      let Uuid = "10000000-1000-4000-8000-100000000000-9000".replace(
        /[018]/g,
        (c) =>
          (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
          ).toString(16)
      );

      return Uuid;
    },
    async GetMSTeam() {
      // var start = performance.now();
    const isInIframe = window.self !== window.top;
    
    const initMSTeams = async () => {
    const timeoutPromise = new Promise((_, reject) => {
      setTimeout(() => reject(new Error('MS Teams timeout')), 5000);
    });

    const msTeamPromise = async () => {
      try {
        await app.initialize();
        self.msContext = await app.getContext();
        
        // ขอ permission สำหรับ microphone โดยตรวจสอบว่าอยู่ใน iframe หรือไม่
        if (!isInIframe) {
          try {
            await app.requestPermission(['microphone']);
          } catch (permissionError) {
            console.log('Permission request failed:', permissionError);
          }
        } else {
          // หาฝอยู่ใน iframe ให้ส่งข้อความไปยัง parent window เพื่อขอ permission
          try {
            window.parent.postMessage({
              type: 'REQUEST_MICROPHONE_PERMISSION'
            }, '*');
          } catch (e) {
            console.log('Cannot request permission from iframe:', e);
          }
        }
        
        self.isMsTeam = true;
        const context = self.msContext;
        const userPrincipalName = context.user.userPrincipalName;
        this.User_Id = userPrincipalName;
        this.User_Id_Show = userPrincipalName;
        this.isUseForMSTeam = true;
        this.GetModelQuickGroupInModelGroup();
        this.GetTopicFullStream("Start");
        return true;
      } catch (e) {
        console.error('MS Teams initialization failed:', e);
        self.isMsTeam = false;
        throw e;
      }
    };

    try {
        await Promise.race([msTeamPromise(), timeoutPromise]);
      } catch (error) {
        console.log('MS Teams initialization timeout or failed:', error.message);
        self.isMsTeam = false;
      }
    };

    // เรียฝใช้ MS Teams initialization พร้อม timeout
    await initMSTeams();

      // เพิ่ม fallback สำหรับฝรณีที่ไม่ใช่ MS Teams
      if (!self.isMsTeam) {
        if (this.role.ID === "5") {
          this.NotificationMSTeamOnly();
        } else {
          this.GetUuidv4();
          this.GetModelQuickGroupInModelGroup();
        }
      }
    },

    // GetMSTeam() {
    //   let self = this;
    //   try {
    //     app.initialize().then(function () {

    //       app.getContext().then(function (context) {
    //         let UserPrincipalName = context.user.userPrincipalName;
    //         self.$root.User_Id = UserPrincipalName;

    //         self.$root.User_Id_Show = UserPrincipalName;
    //         self.isUseForMSTeam = true;
    //         self.GetModelQuickGroupInModelGroup();
    //         self.GetTopicFullStream("Start");
    //       }).catch(function () {
    //         self.GetUuidv4();
    //         self.GetModelQuickGroupInModelGroup();
    //       });
    //     }).catch(function (ex) {
    //       console.log(ex);
    //       if (self.role.ID == "5") {
    //         self.NotificationMSTeamOnly();
    //       }
    //       else {
    //         self.GetUuidv4();
    //         self.GetModelQuickGroupInModelGroup();
    //       }
    //     });
    //   }
    //   catch {
    //     self.GetUuidv4();
    //     self.GetModelQuickGroupInModelGroup();
    //   }
    // },

    Shift_Enter_MessageData() {
      let self = this;

      self.point = self.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = self.$refs.RefMessageData.$refs.input.selectionStart - 1;

      self.$nextTick(() => {
        self.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        self.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;

        if (
          self.$refs.RefMessageData.$refs.input &&
          self.$refs.RefMessageData.$refs.input.selectionStart >=
          self.messageData.length
        ) {
          const height = self.$refs.RefMessageData.$refs.input.scrollHeight;
          // This has to be done ASAP, waiting for Vue
          // to update the DOM causes ugly layout jumping
          self.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      });
    },
    Ctrl_Enter_MessageData() {
      let self = this;
      self.point = self.$refs.RefMessageData.$refs.input.selectionStart;
      let _point = self.$refs.RefMessageData.$refs.input.selectionStart - 1;
      if (self.messageData.length > 0) {
        self.messageData =
          self.messageData.slice(0, _point + 1) +
          "\n" +
          self.messageData.slice(_point + 1);
      } else {
        self.messageData += "\n";
      }
      self.$nextTick(() => {
        self.$refs.RefMessageData.$refs.input.selectionStart = _point + 2;
        self.$refs.RefMessageData.$refs.input.selectionEnd = _point + 2;
        if (
          self.$refs.RefMessageData.$refs.input &&
          self.$refs.RefMessageData.$refs.input.selectionStart >=
          self.messageData.length
        ) {
          const height = self.$refs.RefMessageData.$refs.input.scrollHeight;
          self.$refs.RefMessageData.$refs.input.scrollTop = height;
        }
      });
    },
    Chang_History() {
      let self = this;
      // stop voice
      if (self.TimeOutStop != null) {
        clearTimeout(self.TimeOutStop);
        self.TimeOutStop = null;
      }
      if (self.SpeechRecognizer != null) {
        self.listMessage.pop();
        self.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (self.Axios_ControllerAduio != null) {
        self.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (self.Axios_Controller.length != 0) {
        self.Axios_Controller[
          self.listMessage.length > 0 ? self.listMessage.length - 1 : 0
        ].abort();
      }
      self.Stop_Flag = true;
      self.CountScroll = self.MaxCountScroll;
      self.messageData = "";
      self.messageRes = [];
      self.listMessage = [];
      self.Axios_Controller = [];
      self.Count_messageRes = [];
      self.StatusPro = false;
      self.flagTopHistory = true;
    },
    StopMessage() {
      let self = this;
      var IndexMessage =
        self.listMessage.length == 0 ? 0 : self.listMessage.length - 1;
      var IndexMessageRes =
        self.messageRes.length == 0 ? 0 : self.messageRes.length - 1;
      if (self.listMessage.length == 0) {
        return;
      }
      if (
        self.listMessage.length > 0 &&
        (self.listMessage[IndexMessage].status_Process == "Stop" ||
          self.listMessage[IndexMessage].status_Process == "END" ||
          self.listMessage[IndexMessage].status_Process == "Error")
      ) {
        if (
          self.listMessage[IndexMessage].messageBot.length > 0 &&
          self.listMessage[IndexMessage].messageBot.substring(
            self.listMessage[IndexMessage].messageBot.length - 47,
            self.listMessage[IndexMessage].messageBot.length
          ) == '<span class="blinking-cursor" style="">|</span>'
        ) {
          self.listMessage[IndexMessage].messageBot = self.listMessage[
            IndexMessage
          ].messageBot.substring(
            0,
            self.listMessage[IndexMessage].messageBot.length - 47
          );
        }
        return;
      }
      // stop Text_Run
      if (self.TimeOutText_Run != null) {
        clearTimeout(self.TimeOutText_Run);
        self.TimeOutText_Run = null;
      }
      // stop voice
      if (self.TimeOutStop != null) {
        clearTimeout(self.TimeOutStop);
        self.TimeOutStop = null;
      }
      if (self.SpeechRecognizer != null) {
        self.listMessage.pop();
        self.SpeechRecognizer.stopContinuousRecognitionAsync();
      }
      // stop File
      if (self.Axios_ControllerAduio != null) {
        self.Axios_ControllerAduio.abort();
      }
      // strp Open ai
      if (self.Axios_Controller.length != 0) {
        self.Axios_Controller[IndexMessage].abort();
      }
      self.Stop_Flag = true;
      if (self.listMessage.length > 0 && self.messageRes.length > 0) {
        if (
          self.listMessage[IndexMessage].messageBot.length <
          self.messageRes[IndexMessageRes].length
        ) {
          self.listMessage[IndexMessage].messageBot =
            self.messageRes[IndexMessageRes];
        }
      }
      if (
        self.listMessage.length > 0 &&
        self.listMessage[IndexMessage].status_Process == "END" &&
        self.listMessage[IndexMessage].messageBot != null &&
        self.messageRes.length > 0
      ) {
        if (
          self.listMessage[IndexMessage].messageBot.length <
          self.messageRes[IndexMessageRes].length
        ) {
          self.Count_messageRes[IndexMessage] = 0;
          self.StatusPro = true;
          self.messageRun = "";
          self.listMessage[IndexMessage].messageBot =
            self.messageRes[IndexMessageRes];
          self.messageRes[IndexMessageRes] = "";
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            self.ChatRef_ScrollIntoView();
          }, 5);
          return;
        }
      }
      if (self.listMessage.length > 0) {
        self.listMessage[IndexMessage].status_Process = "Stop";
      }
      self.listMessage[IndexMessage].messageBot = self.listMessage[
        IndexMessage
      ].messageBot.replace(
        '<span class="blinking-cursor" style="">|</span>',
        ""
      );
      self.messageData = "";
      if (self.messageRes.length > 0) {
        self.messageRes[IndexMessageRes] = "";
      } else {
        self.messageRes[0] = "";
      }
      self.Count_messageRes[IndexMessage] = 0;
      self.StatusPro = false;
    },
    StopMessageByIndex(IndexMessage) {
      let self = this;

      if (
        self.listMessage.length == 0 ||
        (self.listMessage.length > 0 &&
          (self.listMessage[IndexMessage].status_Process == "Stop" ||
            self.listMessage[IndexMessage].status_Process == "END" ||
            self.listMessage[IndexMessage].status_Process == "Error"))
      ) {
        return;
      }

      // stop Text_Run
      if (self.TimeOutText_Run != null) {
        clearTimeout(self.TimeOutText_Run);
        self.TimeOutText_Run = null;
      }

      // strp Open ai
      if (self.Axios_Controller.length != 0) {
        self.Axios_Controller[IndexMessage].abort();
      }
      // self.Stop_Flag = true;
      if (
        self.listMessage.length > 0 &&
        self.listMessage[IndexMessage].messageBot.length <
        self.messageRes[IndexMessage].length
      ) {
        self.listMessage[IndexMessage].messageBot =
          self.messageRes[IndexMessage];
      }
      if (
        self.listMessage.length > 0 &&
        self.listMessage[IndexMessage].status_Process == "END" &&
        self.listMessage[IndexMessage].messageBot != null &&
        self.listMessage[IndexMessage].messageBot.length <
        self.messageRes[IndexMessage].length
      ) {
        self.Count_messageRes[self.listMessage.length - 1] = 0;
        self.StatusPro = true;
        self.loading = true;
        self.messageRun = "";
        self.listMessage[IndexMessage].messageBot =
          self.messageRes[IndexMessage];
        self.messageRes[IndexMessage] = "";
        setTimeout(() => {
          self.CountScroll = self.MaxCountScroll;
          self.ChatRef_ScrollIntoView();
        }, 5);
        return;
      }
      if (self.listMessage.length > 0) {
        self.listMessage[IndexMessage].status_Process = "ChatChain";
      }

      self.listMessage[IndexMessage].messageBot = self.listMessage[
        IndexMessage
      ].messageBot.replace(
        '<span class="blinking-cursor" style="">|</span>',
        ""
      );
    },
    Clear_listMessage() {
      var self = this;
      if (
        self.listMessage.length == 0 ||
        (self.listMessage.length > 0 &&
          (self.listMessage[self.listMessage.length - 1].status_Process ==
            "Process" ||
            self.listMessage[self.listMessage.length - 1].status_Process ==
            "Send_Message" ||
            self.listMessage[self.listMessage.length - 1].status_Process ==
            "VoiceStart"))
      ) {
        return;
      }
      self.flagTopHistory = true;
      let dataPost = {
        events: [
          {
            replyToken: "dummyToken",
            type: "message",
            timestamp: 1462629479859,
            fullStream: true,
            stream: false,
            SessionID: self.SessionID,
            source: {
              type: "user",
              userId: self.User_Id,
            },
            message: {
              id: "325708",
              type: "text",
              topicModelID: self.TopicModelID_long,
              topicID: self.Log_History_TopicID,
              keyTopic: self.KeyTopic,
              text: ":clearhistory",
            },
          },
        ],
      };
      let Config = {
        onUploadProgress: () => {
          console.log("onUploadProgress");
        },
        onDownloadProgress: () => {
          console.log("onDownloadProgress");
        },

        maxRedirects: 0, // avoid buffering the entire stream
      };
      //#region Send data to backend
      // if (self.snippet_Status != true) {
      //   self.$call.GptFullStreamPOST(dataPost, Config, () => {
      //     self.listMessage = [];
      //     self.messageData = "";
      //     self.messageRes[IndexMessage] = "";
      //     self.Count_messageRes = [];
      //     self.StatusPro = false;
      //   },
      //     () => {
      //     });
      // }
      // else {
      self.$call.GptFullStreamPostToken(
        dataPost,
        Config,
        self.auth_token_local,
        () => {
          self.listMessage = [];
          self.messageData = "";
          self.messageRes[IndexMessage] = "";
          self.Count_messageRes = [];
          self.StatusPro = false;
        },
        () => { }
      );
      // }
      //#endregion
    },

    Keydown_Enter_MessageData() { },
    ChatRef_ScrollIntoView() {
      let self = this;
      const chatScreen = self.$refs.ChatScreRef;
      const chatContentEnd = self.$refs.ChatContainerRef;
      if (chatScreen && chatContentEnd) {
        const scrollThreshold = 10; // กำหนด threshold สำหรับการตรวจสอบว่าอยู่ใฝล้ด้านล่างหรือไม่ (หน่วยเป็น pixel)
        // ตรวจสอบว่าผู้ใช้ได้ scroll ไปใฝล้ด้านล่างสุดของ chat container หรือไม่
        const isScrolledEffectivelyToBottom =
          chatScreen.scrollHeight -
          chatScreen.scrollTop -
          chatScreen.clientHeight <
          scrollThreshold;

        let shouldScroll = false;
        if (self.CountScroll >= self.MaxCountScroll) {
          // ฝรณีที่ CountScroll ถึงกำหนด (เช่น หลังจากการส่งข้อความ หรือ สิ้นสุด stream)
          shouldScroll = true;
        } else if (isScrolledEffectivelyToBottom) {
          // ฝรณีที่ผู้ใช้อยู่ใฝล้ด้านล่างสุด (สำหรับระหว่างที่ AI กำลัง stream ข้อความ)
          shouldScroll = true;
        }

        if (shouldScroll) {
          // ใช้ $nextTick เพื่อให้แน่ใจว่า DOM ได้ update ฝ่อนที่จะทำการ scroll
          self.$nextTick(() => {
            chatContentEnd.scrollIntoView({
              behavior: "auto", // หาฝ 'smooth' ยังมีปัฝหา ลองเปลี่ยนเป็น 'auto'
              block: "end",
              inline: "start",
            });
          });
          self.CountScroll = 0; // Reset counter เมื่อมีการ scroll เกิดขึ้น
        }
      }
      self.CountScroll++; // เพิ่มค่า CountScroll ทุฝครั้งที่เรียฝ
    },
    SkipTextRendering() {
      let self = this;
      let IndexMessage = self.listMessage.length - 1;
      let IndexMessageRes = self.messageRes.length - 1;
      
      // ตรวจสอบว่าสามารถ skip ได้หรือไม่
      if (self.listMessage.length > 0 && 
          self.messageRes.length > 0 &&
          self.listMessage[IndexMessage].status_Process == 'END' &&
          self.listMessage[IndexMessage].messageBot != null &&
          self.listMessage[IndexMessage].messageBot.length < self.messageRes[IndexMessageRes].length) {
        
        // Skip text rendering โดยให้แสดงข้อความเต็มทันที
        self.Count_messageRes[IndexMessage] = 0;
        self.StatusPro = true;
        self.messageRun = "";
        self.listMessage[IndexMessage].messageBot = self.messageRes[IndexMessageRes];
        self.messageRes[IndexMessageRes] = "";
        
        // Scroll to bottom
        setTimeout(() => {
          self.CountScroll = self.MaxCountScroll;
          self.ChatRef_ScrollIntoView();
        }, 5);
        
        // Update render key
        self.rerenderKey++;
      }
    },
    SendOpenAi(K_in) {
      this.CheckCurrentModelTextToImage();
      let self = this;
      if (self.uploadFileComplete == false && self.pickedFileType != null) {
        if (K_in == "Enter") {
          let _point = self.$refs.RefMessageData.$refs.input.selectionStart - 1;

          if (self.messageData.length > 0 && self.messageData[_point] == "\n") {
            self.messageData =
              self.messageData.slice(0, _point) +
              self.messageData.slice(_point + 1);
          }
        }
        return;
      }
      
      if (self.listMessage.length > 0 && self.messageRes.length > 0 &&
        self.listMessage[self.listMessage.length - 1].status_Process == 'END'
        && self.listMessage[self.listMessage.length - 1].messageBot != null) {
        if (self.listMessage[self.listMessage.length - 1].messageBot.length < self.messageRes[self.messageRes.length - 1].length) {
          self.Count_messageRes[self.listMessage.length - 1] = 0;
          self.StatusPro = true;
          self.messageRun = "";
          self.listMessage[self.listMessage.length - 1].messageBot = self.messageRes[self.messageRes.length - 1];
          self.messageRes[self.messageRes.length - 1] = "";
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            self.ChatRef_ScrollIntoView();
          }, 5);
          if (self.messageData == "") {
            return;
          }
        }
      }

      if (self.messageData == "" || K_in == "Skip") return;
      self.GetDateTime();
      if (
        (self.messageData == "" && self.fileDataUrl == null) ||
        (self.listMessage.length > 0 &&
          self.listMessage[self.listMessage.length - 1].status_Process !=
          "END" &&
          self.listMessage[self.listMessage.length - 1].status_Process !=
          "Error" &&
          self.listMessage[self.listMessage.length - 1].status_Process !=
          "Stop" &&
          !self.IsChainMassage)
      ) {
        return;
      }
      let _messageData = self.messageData;
      let _messageImage = "";
      let _messagePickedFile = "";
      self.messageData = "";
      let IndexMessageOld = self.listMessage.length - 1;
      if (self.ImageURL != "" && self.ImageURL != null) {
        _messageImage = `![image](${self.ImageURL})\n`;
      }
      if (self.pickedFileType != null && self.uploadFileComplete) {
        _messagePickedFile = `<img src="${self.GetFileTypeImg(
          self.requestVector.doctype
        )}" width="16" height="16" style="vertical-align: middle;"> <small>${self.pickedFileName
          }</small>\n`;
      }
      if (
        self.listMessage[IndexMessageOld] != undefined &&
        self.IsChainMassage
      ) {
        if (self.listMessage[IndexMessageOld].status_Process != "END") {
          self.StopMessageByIndex(IndexMessageOld);
          self.StopForChain = true;
        }
      }
      self.listMessage.push({
        messageUser: _messagePickedFile + _messageImage + _messageData,
        messageBot: "",
        status_Process: "Process",
        requestTime: self.today,
        responseTime: null,
        status: null,
        comment: "",
        commentDialog: false,
        moreComment: false,
        isFeedback: self.isFeedback,
      });
      let IndexMessage = self.listMessage.length - 1;
      setTimeout(() => {
        self.CountScroll = self.MaxCountScroll;
        self.ChatRef_ScrollIntoView();
      }, 5);
      if (
        self.KeyTopic == null ||
        self.KeyTopic == "" ||
        self.Log_History_TopicID == -1
      ) {
        self.KeyTopic = self.GetUuidv4_Fun();
      }
      if (self.listTopic.length > 0 && self.listTopic[0].topicID == -1) {
        self.listTopic[0].topicName = _messageData;
        self.listTopic[0].keyTopic = self.KeyTopic;
      }
      let tempModelID = parseInt(self.modelDisplayID) || null;
      let dataPost = {
        events: [
          {
            replyToken: "dummyToken",
            type: "message",
            timestamp: 1462629479859,
            fullStream: true,
            stream: false,
            snippet: self.snipet_flag ?? false,
            SessionID: self.SessionID,
            source: {
              type: "users",
              userId: self.User_Id,
              groupModel: self.parameterURL.groupmodel,
              domainName: self.URL_Domain,
              modelDisplayID: tempModelID,
              tokenParam: self.tokenParam,
              selectedLLM: self.selectedLLMModelInChat ? self.selectedLLMModelInChat.id : null,
            },

            message: {
              id: "325708",
              type: "text",
              ImageURL:
                self.ImageURL == "" || self.IsAllowImage == false
                  ? null
                  : self.ImageURL,
              topicModelID: self.TopicModelID_long,
              topicID: self.Log_History_TopicID,
              keyTopic: self.KeyTopic,
              text:
                (self.pickedFileType != null ? _messagePickedFile : "") +
                _messageData,
              productSelect: self.productsSelect,
            },
            PersonalInfoToken: self.personalInfoToken,
          },
        ],
      };

      this.hideProducts = true;
      self.Stop_Flag = false;
      self.messageRes[IndexMessage] = "";
      self.Count_messageRes[IndexMessage] = 0;
      self.StatusPro = true;
      self.messageRun = "";
      self.Axios_Controller[IndexMessage] = new AbortController();
      self.ClearImage();
      self.ClearUploadedFile();
      let Config = {
        signal: self.Axios_Controller[IndexMessage].signal,
        onUploadProgress: () => {
          self.Text_Run(IndexMessage);
          if (self.listMessage[IndexMessage].messageBot == "") {
            try {
            } catch { }
          }
        },
        onDownloadProgress: (progressEvent) => {
          const xhr =
            progressEvent.target == undefined
              ? progressEvent.event.target
              : progressEvent.target;
          try {
            if (
              self.listMessage[IndexMessage].messageBot == "" ||
              self.listMessage[IndexMessage].messageBot ==
              '<span class="blinking-cursor" style="">|</span>'
            ) {
              try {
                // self.GetModelFirst_Value(null);
                self.GetTopicFullStream("Steam");
              } catch { }
            }
            self.GetDateTime();
            const { responseText } = xhr;
            self.listMessage[IndexMessage].status_Process = "Send_Message";
            self.listMessage[IndexMessage].responseTime = self.today;
            self.listMessage[IndexMessage].isFeedback = self.isFeedback;

            let _responseText = responseText.replaceAll("data: [DONE]", "");
            _responseText = _responseText.replaceAll("|ContactAgent|true", "");
            if (_responseText.indexOf("|Products|[") != -1) {
              var tempJson = _responseText.split("|Products|");
              _responseText = tempJson[0];
              self.products = JSON.parse(tempJson[1]);
              this.hideProducts = false;
            }
            else if(_responseText.indexOf("|logID|") != -1){
              var tempJson = _responseText.split("|logID|");
              _responseText = tempJson[0];
            }

            /* eslint-disable */

            _responseText = _responseText.replace(
              /(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g,
              "\n"
            );

            _responseText = _responseText.replace(
              /(?:      \n|     \n|    \n|   \n|  \n| \n)/g,
              "\n"
            );
            _responseText = _responseText.replace(
              /(?:\n      ```|\n     ```|\n    ```|\n   ```|\n  ```|\n ```)/g,
              "\n```"
            );

            _responseText = _responseText.replace(
              /(?:\n```\n```\n\n)/g,
              "\n<||End||>\n<||EndMarkdown||>\n\n"
            );
            _responseText = _responseText.replace(
              /(?:\n```\n\n)/g,
              "\n<||End||>\n\n"
            );

            _responseText = _responseText.replace(
              /(?:\n```\n```python|\n   ```\n   ```python)/g,
              "\n<||StarMarkdown||>\n<||StarPython||>"
            );
            _responseText = _responseText.replace(
              /(?:\n```\n```javascript|\n   ```\n   ```javascript)/g,
              "\n<||StarMarkdown||>\n<||StarJavascript||>"
            );

            _responseText = _responseText.replace(
              /(?:\n```\n)/g,
              "\n<||StarAll||>\n"
            );
            _responseText = _responseText.replace(
              /(?:\n```python)/g,
              "\n<||StarPython||>"
            );
            _responseText = _responseText.replace(
              /(?:\n```javascript)/g,
              "\n<||StarJavascript||>"
            );
            _responseText = _responseText.replace(
              /(?:\n```markdown)/g,
              "\n<||StarMarkdown||>"
            );

            let Sp_RT = _responseText.split("<||");

            for (let I_Sp_RT = 0; I_Sp_RT < Sp_RT.length; I_Sp_RT++) {
              let Sp_Value = Sp_RT[I_Sp_RT].split("||>");
              if (I_Sp_RT >= 1 && Sp_Value.length > 1) {
                let Sp_Value_Old = Sp_RT[I_Sp_RT - 1].split("||>");
                if (Sp_Value[0].indexOf("End") != -1) {
                  for (let II_Sp_RT = I_Sp_RT - 1; II_Sp_RT > 0; II_Sp_RT--) {
                    try {
                      let Sp_Value_Old_Loop = Sp_RT[II_Sp_RT].split("||>");
                      if (
                        Sp_Value_Old.length > 1 &&
                        Sp_Value_Old_Loop.length > 1
                      ) {
                        let x = 0;

                        if (
                          Sp_Value[0].indexOf("End") != -1 &&
                          Sp_Value_Old[0].indexOf("Star") != -1
                        ) {
                          let re_SVO = Sp_Value_Old[0].replace("Star", "End");
                          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace(
                            "End||>",
                            re_SVO + "||>"
                          );
                          break;
                        } else if (
                          Sp_Value[0].indexOf("End") != -1 &&
                          Sp_Value_Old[0].indexOf("End") != -1 &&
                          Sp_Value_Old_Loop[0].indexOf("Star") != -1 &&
                          Sp_Value_Old_Loop[0].indexOf(
                            Sp_Value_Old[0].replace("End", "Star")
                          ) == -1
                        ) {
                          let re_SVO = Sp_Value_Old_Loop[0].replace(
                            "Star",
                            "End"
                          );
                          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace(
                            "End||>",
                            re_SVO + "||>"
                          );
                          break;
                        } else {
                          let dd = 0;
                        }
                      }
                    } catch (e) {
                      // let ddd = 0;
                    }
                  }
                } else if (
                  I_Sp_RT + 1 < Sp_RT.length &&
                  Sp_Value[0].indexOf("StarAll") != -1
                ) {
                  let Sp_Value_New = Sp_RT[I_Sp_RT + 1].split("||>");
                  if (
                    Sp_Value_Old[0].indexOf("Star") != -1 &&
                    Sp_Value_New.length > 1 &&
                    Sp_Value_New[0].indexOf("Star") != -1
                  ) {
                    let re_SVO = Sp_Value_Old[0].replace("Star", "End");
                    Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace(
                      "StarAll||>",
                      re_SVO + "||>"
                    );
                  }
                }
              }
              if (I_Sp_RT == Sp_RT.length - 1) {
                for (let Iii_Sp_RT = 0; Iii_Sp_RT < Sp_RT.length; Iii_Sp_RT++) {
                  if (Sp_RT[Iii_Sp_RT].indexOf("||>") != -1) {
                    Sp_RT[Iii_Sp_RT] = "<||" + Sp_RT[Iii_Sp_RT];
                  }
                }
                _responseText = Sp_RT.join("");
              }
              _responseText = _responseText.replaceAll(
                "<||StarMarkdown||>",
                "\n`````\n"
              );
              _responseText = _responseText.replaceAll(
                "<||EndMarkdown||>",
                "`````\n"
              );

              _responseText = _responseText.replaceAll("<||StarAll||>", "```");
              _responseText = _responseText.replaceAll("<||EndAll||>", "```");

              _responseText = _responseText.replaceAll(
                "<||StarJavascript||>",
                "```javascript"
              );
              _responseText = _responseText.replaceAll(
                "<||EndJavascript||>",
                "```"
              );
              _responseText = _responseText.replaceAll(
                "<||StarPython||>",
                "```python"
              );
              _responseText = _responseText.replaceAll(
                "<||EndPython||>",
                "```"
              );

              _responseText = _responseText.replaceAll("<||Star||>", "```");
              _responseText = _responseText.replaceAll("<||End||>", "```");
            }

            _responseText = _responseText.replace(/(?:\\n\\n|\n\n)/g, "\n");
            // _responseText = _responseText.replace(/(?:\\\```|\\```)/g, "\\```");
            _responseText = _responseText.replace(
              /(?:\\\```|\\```|\```)/g,
              "<||TextMarkdown||>"
            );

            _responseText = _responseText.replace(/(?:\\\`|\\`)/g, "\\`");

            _responseText = _responseText.replaceAll(
              "<||TextMarkdown||>",
              "```"
            );

            // _responseText = _responseText.replaceAll(" '", " '");

            _responseText = _responseText.replaceAll("(```", "(\\```");
            _responseText = _responseText.replaceAll("(``", "(\\``");
            _responseText = _responseText.replaceAll("(`", "(\\`");
            _responseText = _responseText.replaceAll("` ` `", "`` ` ``");

            if (
              _responseText.indexOf("<!DOCTYPE html>") == 0 &&
              _responseText.indexOf("```html\n<!DOCTYPE html>") == -1 &&
              _responseText.indexOf("```\n<!DOCTYPE html>") == -1 &&
              _responseText.indexOf("<style>" != -1)
            ) {
              let Sp_responseTextStart = _responseText.split("<style>");
              let Sp_responseTextEnd =
                Sp_responseTextStart[1].split("</style>");

              if (Sp_responseTextEnd.length > 0) {
                Sp_responseTextEnd[0] = Sp_responseTextEnd[0].replaceAll(
                  "}\n",
                  "}\n  #V_markDown "
                );
              }

              _responseText =
                Sp_responseTextStart[0] +
                "<style> #V_markDown " +
                Sp_responseTextEnd[0] +
                (Sp_responseTextEnd.length > 1
                  ? " </style> " + Sp_responseTextEnd[1]
                  : "");
            }
            if (_responseText.indexOf("|Text|*Streaming:true*|") != -1) {
              _responseText = _responseText.replaceAll(
                "|Text|*Streaming:true*|",
                ""
              );
              self.listMessage[self.listMessage.length - 1].messageBot =
                _responseText;
              self.messageRes[IndexMessage] = _responseText;
              self.messageRes[IndexMessage] = "";
              self.Count_messageRes[IndexMessage] = 0;
              self.StatusPro = false;
            } else if (
              _responseText.indexOf("|Text|*Streaming:false*|") != -1
            ) {
              _responseText = _responseText.replaceAll(
                "|Text|*Streaming:false*|",
                ""
              );
              self.listMessage[self.listMessage.length - 1].messageBot =
                _responseText;
              self.messageRes[IndexMessage] = _responseText;
              self.messageRes[IndexMessage] = "";
              self.Count_messageRes[IndexMessage] = 0;
              self.StatusPro = false;
            } else {
              self.messageRes[IndexMessage] = _responseText;
              self.StatusPro = true;
            }
          } catch (e) {
            console.log("e");
          }
        },
        maxRedirects: 0, // avoid buffering the entire stream
      };

      //#region Send data to backend
      //self.$call.ChackPersonalInfo(
      //    async (dataResponse) => {
      //      if (dataResponse.status == 0) {
      //        if(dataResponse.data != null)
      //        {
      //          var temp = dataResponse.data;
      //          console.log("ChackPersonalInfo: ", temp);
      //          alert("ChackPersonalInfo: " + temp.firstName + " | " + temp.lastName + " | " + temp.email);
      //        }
      //      }
      //    },
      //    (errorResource) => {
      //      console.error(errorResource);
      //    }
      //);

      self.$call.GptFullStreamPostToken(dataPost,Config,self.auth_token_local, () => {
        
        if(self.listMessage[IndexMessage].messageBot == "**#Personal Information**") //self.personalInfoToken 
        {
          self.listMessage[IndexMessage].status_Process = "Process";

          //#region Personal Information
          window.open(`${self.urlApi}api/v0/SSO/SignInPersonalInfo`, "Popup", "width=850,height=750");

          const handleMessage = async function (event) {
            try {
              // ตรวจสอบข้อมูลจาก popup
              if (!event.data || !event.data.message) return;

              const data = event.data;
              self.personalInfoToken = data.message;
              // clearInterval(checkPopupData);

              let dataPost = {
                "events": [
                  {
                    "replyToken": "dummyToken",
                    "type": "message",
                    "timestamp": 1462629479859,
                    "fullStream": true,
                    "stream": false,
                    "snippet": self.snipet_flag ?? false,
                    "SessionID": self.SessionID,
                    "source": {
                      "type": "users",
                      "userId": self.User_Id,
                      "groupModel": self.parameterURL.groupmodel,
                      "domainName": self.URL_Domain,
                      "modelDisplayID": tempModelID,
                      "tokenParam": self.tokenParam,
                    },

                    "message": {
                      "id": "325708",
                      "type": "text",
                      "ImageURL": self.ImageURL == "" || self.$root.IsAllowImage == false ? null : self.ImageURL,
                      "topicModelID": self.TopicModelID_long,
                      "topicID": self.Log_History_TopicID,
                      "keyTopic": self.KeyTopic,
                      "text": (self.pickedFileType != null ? _messagePickedFile : "") + _messageData,
                      "productSelect": self.productsSelect,
                    },
                    "PersonalInfoToken": self.personalInfoToken,
                  }
                ]
              };

              self.$call.GptFullStreamPostToken(dataPost, Config, self.auth_token_local, () => {
                self.StatusPro = false;
                self.StopForChain = false;
                self.successalert = true;
                self.productsSelect = [];

                // self.listMessage[self.listMessage.length - 1].status_Process = "END";

                let _User_Id = {
                  TopicID: self.Log_History_TopicID,
                  USER_CHANNEL: self.$root.User_Id,
                  ID: self.Log_History_ID,
                  Take: self.Log_History_Take
                };
                self.$call.GetLastLogID(_User_Id, self.auth_token_local, (response) => {
                  if (response.status == 0) {
                    let response_data = response.data
                    if(self.messageRes[IndexMessage] != "" && self.messageRes[IndexMessage] != null && self.messageRes[IndexMessage] != undefined) {
                      self.listMessage[IndexMessage].messageBot = self.messageRes[IndexMessage];
                    }
                    self.listMessage[IndexMessage].status_Process = "END";
                    self.listMessage[IndexMessage].id = response_data.id;
                    self.listMessage[IndexMessage].modelDisplayID = response_data.modelDisplayID;
                    self.listMessage[IndexMessage].isFeedback = self.isFeedback;
                    if (self.listMessage[IndexMessage].messageBot.length > 0 && self.listMessage[IndexMessage].messageBot.substring(self.listMessage[IndexMessage].messageBot.length - 47, self.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
                      self.listMessage[IndexMessage].messageBot = self.listMessage[IndexMessage].messageBot.substring(0, self.listMessage[IndexMessage].messageBot.length - 47);
                    }
                  } else if (response.status == 1) {
                    if(self.messageRes[IndexMessage] != "" && self.messageRes[IndexMessage] != null && self.messageRes[IndexMessage] != undefined) {
                      self.listMessage[IndexMessage].messageBot = self.messageRes[IndexMessage];
                    }
                    self.listMessage[IndexMessage].status_Process = "END";
                    // self.listMessage[IndexMessage].id = response_data.id;
                    // self.listMessage[IndexMessage].modelDisplayID = response_data.modelDisplayID;
                    self.listMessage[IndexMessage].isFeedback = self.isFeedback;
                    if (self.listMessage[IndexMessage].messageBot.length > 0 && self.listMessage[IndexMessage].messageBot.substring(self.listMessage[IndexMessage].messageBot.length - 47, self.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
                      self.listMessage[IndexMessage].messageBot = self.listMessage[IndexMessage].messageBot.substring(0, self.listMessage[IndexMessage].messageBot.length - 47);
                    }
                    self.Loading_History_Status = false;
                  }
                }, () => {
                    if(self.messageRes[IndexMessage] != "" && self.messageRes[IndexMessage] != null && self.messageRes[IndexMessage] != undefined) {
                      self.listMessage[IndexMessage].messageBot = self.messageRes[IndexMessage];
                    }
                  self.listMessage[IndexMessage].status_Process = "END";
                  // self.listMessage[IndexMessage].id = response_data.id;
                  // self.listMessage[IndexMessage].modelDisplayID = response_data.modelDisplayID;
                  self.listMessage[IndexMessage].isFeedback = self.isFeedback;
                  if (self.listMessage[IndexMessage].messageBot.length > 0 && self.listMessage[IndexMessage].messageBot.substring(self.listMessage[IndexMessage].messageBot.length - 47, self.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
                    self.listMessage[IndexMessage].messageBot = self.listMessage[IndexMessage].messageBot.substring(0, self.listMessage[IndexMessage].messageBot.length - 47);
                  }
                }
                )
                setTimeout(() => {
                  self.CountScroll = self.MaxCountScroll;
                  self.ChatRef_ScrollIntoView();
                }, 5);
              },
              (_response) => {
                console.log("catch");
                self.erroralert = true;
                if (self.listMessage.length == 0) {
                }
                else if (self.Stop_Flag == true && self.listMessage.length > 0) {
                  self.listMessage[IndexMessage].status_Process = "Stop";
                }
                else {
                  self.StatusPro = self.StopForChain;
                  self.Count_messageRes[IndexMessage] = 0;
                  self.messageData = "";
                  if (self.listMessage.length > 0 && self.listMessage[IndexMessage].messageBot.length < self.messageRes[IndexMessage].length && self.listMessage[IndexMessage].status_Process != "ChatChain" && !self.StopForChain) {
                    self.listMessage[IndexMessage].messageBot = (self.messageRes[IndexMessage] + "<br />Error something went wrong ...");
                  }
                  else if (!self.StopForChain && self.listMessage[IndexMessage].status_Process != "Stop") {
                    self.listMessage[IndexMessage].messageBot += "Error something went wrong ...";
                  }
                  self.messageRes[IndexMessage] = "";
                  if (self.listMessage[IndexMessage].status_Process != "Stop") {
                    self.listMessage[IndexMessage].status_Process = self.StopForChain ? "ChatChain" : "Error";
                  }
                }
                self.Stop_Flag = false;
                setTimeout(() => {
                  self.CountScroll = self.MaxCountScroll;
                  self.ChatRef_ScrollIntoView();
                }, 5);
              });

            } catch (error) {
              console.log("🝞 ใน handleMessage:", error);
            } finally {
              console.log("🛑 EventListener message");
              window.removeEventListener('message', handleMessage);
            }
          };

          window.addEventListener('message', handleMessage);

          let checkTokenInterval = setInterval(() => {
            const token = localStorage.getItem("personalInfoToken");
            if (token) {
              try {
                self.personalInfoToken = token;
                let dataPost = {
                "events": [
                  {
                    "replyToken": "dummyToken",
                    "type": "message",
                    "timestamp": 1462629479859,
                    "fullStream": true,
                    "stream": false,
                    "snippet": self.snipet_flag ?? false,
                    "SessionID": self.SessionID,
                    "source": {
                      "type": "users",
                      "userId": self.User_Id,
                      "groupModel": self.parameterURL.groupmodel,
                      "domainName": self.URL_Domain,
                      "modelDisplayID": tempModelID,
                      "tokenParam": self.tokenParam,
                    },

                    "message": {
                      "id": "325708",
                      "type": "text",
                      "ImageURL": self.ImageURL == "" || self.IsAllowImage == false ? null : self.ImageURL,
                      "topicModelID": self.TopicModelID_long,
                      "topicID": self.Log_History_TopicID,
                      "keyTopic": self.KeyTopic,
                      "text": (self.pickedFileType != null ? _messagePickedFile : "") + _messageData,
                      "productSelect": self.productsSelect,
                    },
                    "PersonalInfoToken": self.personalInfoToken,
                  }
                ]
              };

              self.$call.GptFullStreamPostToken(dataPost, Config, self.auth_token_local, () => {
                self.StatusPro = false;
                self.StopForChain = false;
                self.successalert = true;
                self.productsSelect = [];

                // self.listMessage[self.listMessage.length - 1].status_Process = "END";

                let _User_Id = {
                  TopicID: self.Log_History_TopicID,
                  USER_CHANNEL: self.$root.User_Id,
                  ID: self.Log_History_ID,
                  Take: self.Log_History_Take
                };
                self.$call.GetLastLogID(_User_Id, self.auth_token_local, (response) => {
                  if (response.status == 0) {
                    let response_data = response.data
                    self.listMessage[IndexMessage].messageBot = self.messageRes[IndexMessage];
                    self.listMessage[IndexMessage].status_Process = "END";
                    self.listMessage[IndexMessage].id = response_data.id;
                    self.listMessage[IndexMessage].modelDisplayID = response_data.modelDisplayID;
                    self.listMessage[IndexMessage].isFeedback = self.isFeedback;
                    if (self.listMessage[IndexMessage].messageBot.length > 0 && self.listMessage[IndexMessage].messageBot.substring(self.listMessage[IndexMessage].messageBot.length - 47, self.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
                      self.listMessage[IndexMessage].messageBot = self.listMessage[IndexMessage].messageBot.substring(0, self.listMessage[IndexMessage].messageBot.length - 47);
                    }
                  } else if (response.status == 1) {
                    self.listMessage[IndexMessage].messageBot = self.messageRes[IndexMessage];
                    self.listMessage[IndexMessage].status_Process = "END";
                    // self.listMessage[IndexMessage].id = response_data.id;
                    // self.listMessage[IndexMessage].modelDisplayID = response_data.modelDisplayID;
                    self.listMessage[IndexMessage].isFeedback = self.isFeedback;
                    if (self.listMessage[IndexMessage].messageBot.length > 0 && self.listMessage[IndexMessage].messageBot.substring(self.listMessage[IndexMessage].messageBot.length - 47, self.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
                      self.listMessage[IndexMessage].messageBot = self.listMessage[IndexMessage].messageBot.substring(0, self.listMessage[IndexMessage].messageBot.length - 47);
                    }
                    self.Loading_History_Status = false;
                  }
                }, () => {
                  self.listMessage[IndexMessage].messageBot = self.messageRes[IndexMessage];
                  self.listMessage[IndexMessage].status_Process = "END";
                  // self.listMessage[IndexMessage].id = response_data.id;
                  // self.listMessage[IndexMessage].modelDisplayID = response_data.modelDisplayID;
                  self.listMessage[IndexMessage].isFeedback = self.isFeedback;
                  if (self.listMessage[IndexMessage].messageBot.length > 0 && self.listMessage[IndexMessage].messageBot.substring(self.listMessage[IndexMessage].messageBot.length - 47, self.listMessage[IndexMessage].messageBot.length) == '<span class="blinking-cursor" style="">|</span>') {
                    self.listMessage[IndexMessage].messageBot = self.listMessage[IndexMessage].messageBot.substring(0, self.listMessage[IndexMessage].messageBot.length - 47);
                  }
                  self.Loading_History_Status = false;
                }
                )
                setTimeout(() => {
                  self.CountScroll = self.MaxCountScroll;
                  self.ChatRef_ScrollIntoView();
                }, 5);
              },
              (_response) => {
                console.log("catch");
                self.erroralert = true;
                if (self.listMessage.length == 0) {
                }
                else if (self.Stop_Flag == true && self.listMessage.length > 0) {
                  self.listMessage[IndexMessage].status_Process = "Stop";
                }
                else {
                  self.StatusPro = self.StopForChain;
                  self.Count_messageRes[IndexMessage] = 0;
                  self.messageData = "";
                  if (self.listMessage.length > 0 && self.listMessage[IndexMessage].messageBot.length < self.messageRes[IndexMessage].length && self.listMessage[IndexMessage].status_Process != "ChatChain" && !self.StopForChain) {
                    self.listMessage[IndexMessage].messageBot = (self.messageRes[IndexMessage] + "<br />Error something went wrong ...");
                  }
                  else if (!self.StopForChain && self.listMessage[IndexMessage].status_Process != "Stop") {
                    self.listMessage[IndexMessage].messageBot += "Error something went wrong ...";
                  }
                  self.messageRes[IndexMessage] = "";
                  if (self.listMessage[IndexMessage].status_Process != "Stop") {
                    self.listMessage[IndexMessage].status_Process = self.StopForChain ? "ChatChain" : "Error";
                  }
                }
                self.Stop_Flag = false;
                setTimeout(() => {
                  self.CountScroll = self.MaxCountScroll;
                  self.ChatRef_ScrollIntoView();
                }, 5);
              });
              } catch (e) {
                console.error("❌ Error parsing token:", e);
              }
              clearInterval(checkTokenInterval);
            }
          }, 500);
          
          // #endregion Personal Information
        }
        else {
          if(_messageData.trim() == ":clearhistory")
            {
              self.Clear_listMessage();
              self.listMessage = [];
              self.messageData = "";
              if (self.messageRes.length > 0) {
                self.messageRes[self.messageRes.length - 1] = "";
              } else {
                self.messageRes[0] = "";
              }
              self.Count_messageRes[self.listMessage.length - 1] = 0;
              self.StatusPro = false;
              return;
            }

          self.StatusPro = false;
          self.StopForChain = false;
          self.successalert = true;
          self.productsSelect = [];

          // self.listMessage[self.listMessage.length - 1].status_Process = "END";

          let _User_Id = {
            TopicID: self.Log_History_TopicID,
            USER_CHANNEL: self.User_Id,
            ID: self.Log_History_ID,
            Take: self.Log_History_Take,
          };
          self.$call.GetLastLogID(
            _User_Id,
            self.auth_token_local,
            (response) => {
              if (response.status == 0) {
                let response_data = response.data;
                self.listMessage[IndexMessage].status_Process = "END";
                self.listMessage[IndexMessage].id = response_data.id;
                self.listMessage[IndexMessage].modelDisplayID =
                  response_data.modelDisplayID;
                self.listMessage[IndexMessage].isFeedback = self.isFeedback;                
                if (
                  self.listMessage[IndexMessage].messageBot.length > 0 &&
                  self.listMessage[IndexMessage].messageBot.substring(
                    self.listMessage[IndexMessage].messageBot.length - 47,
                    self.listMessage[IndexMessage].messageBot.length
                  ) == '<span class="blinking-cursor" style="">|</span>'
                ) {
                  self.listMessage[IndexMessage].messageBot = self.listMessage[
                    IndexMessage
                  ].messageBot.substring(
                    0,
                    self.listMessage[IndexMessage].messageBot.length - 47
                  );
                }
              } else if (response.status == 1) {
                self.listMessage[IndexMessage].status_Process = "END";
                // self.listMessage[IndexMessage].id = response_data.id;
                // self.listMessage[IndexMessage].modelDisplayID = response_data.modelDisplayID;
                self.listMessage[IndexMessage].isFeedback = self.isFeedback;
                if (
                  self.listMessage[IndexMessage].messageBot.length > 0 &&
                  self.listMessage[IndexMessage].messageBot.substring(
                    self.listMessage[IndexMessage].messageBot.length - 47,
                    self.listMessage[IndexMessage].messageBot.length
                  ) == '<span class="blinking-cursor" style="">|</span>'
                ) {
                  self.listMessage[IndexMessage].messageBot = self.listMessage[
                    IndexMessage
                  ].messageBot.substring(
                    0,
                    self.listMessage[IndexMessage].messageBot.length - 47
                  );
                }
                self.Loading_History_Status = false;
              }
            },
            () => {
              self.listMessage[IndexMessage].status_Process = "END";
              // self.listMessage[IndexMessage].id = response_data.id;
              // self.listMessage[IndexMessage].modelDisplayID = response_data.modelDisplayID;
              self.listMessage[IndexMessage].isFeedback = self.isFeedback;
              if (
                self.listMessage[IndexMessage].messageBot.length > 0 &&
                self.listMessage[IndexMessage].messageBot.substring(
                  self.listMessage[IndexMessage].messageBot.length - 47,
                  self.listMessage[IndexMessage].messageBot.length
                ) == '<span class="blinking-cursor" style="">|</span>'
              ) {
                self.listMessage[IndexMessage].messageBot = self.listMessage[
                  IndexMessage
                ].messageBot.substring(
                  0,
                  self.listMessage[IndexMessage].messageBot.length - 47
                );
              }
              self.Loading_History_Status = false;
            }
          );
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            self.ChatRef_ScrollIntoView();
          }, 5);
          }
        },
        (_response) => {
          self.erroralert = true;
          if (self.listMessage.length == 0) {
          } else if (self.Stop_Flag == true && self.listMessage.length > 0) {
            self.listMessage[IndexMessage].status_Process = "Stop";
          } else {
            self.StatusPro = self.StopForChain;
            self.Count_messageRes[IndexMessage] = 0;
            self.messageData = "";
            if (
              self.listMessage.length > 0 &&
              self.listMessage[IndexMessage].messageBot.length <
              self.messageRes[IndexMessage].length &&
              self.listMessage[IndexMessage].status_Process != "ChatChain" &&
              !self.StopForChain
            ) {
              self.listMessage[IndexMessage].messageBot =
                self.messageRes[IndexMessage] +
                "<br />Error something went wrong ...";
            } else if (
              !self.StopForChain &&
              self.listMessage[IndexMessage].status_Process != "Stop"
            ) {
              self.listMessage[IndexMessage].messageBot +=
                "Error something went wrong ...";
            }
            self.messageRes[IndexMessage] = "";
            if (self.listMessage[IndexMessage].status_Process != "Stop") {
              self.listMessage[IndexMessage].status_Process = self.StopForChain
                ? "ChatChain"
                : "Error";
            }
          }
          self.Stop_Flag = false;
          console.log("Error : " + _response);
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            self.ChatRef_ScrollIntoView();
          }, 5);
        }
      );
      // }
      //#endregion
    },

    Text_Run(IndexMessage) {
      let self = this;

      self.TimeOutText_Run = setTimeout(() => {
        if (self.listMessage.length == 0) {
          self.StopMessage();
          return;
        }
        if (
          (self.Count_messageRes >= self.messageRes[IndexMessage].length &&
            self.StatusPro == false) ||
          self.listMessage[IndexMessage].status_Process == "ChatChain"
        ) {
          setTimeout(() => {
            self.CountScroll = self.MaxCountScroll;
            // self.ChatRef_ScrollIntoView();
          }, 5);

          self.rerenderKey++;
        }
        if (
          (self.Count_messageRes[IndexMessage] <
            self.messageRes[IndexMessage].length ||
            self.StatusPro == true) &&
          self.listMessage[IndexMessage].status_Process != "ChatChain"
        ) {
          if (
            self.listMessage[IndexMessage].messageBot.length > 0 &&
            self.listMessage[IndexMessage].messageBot.substring(
              self.listMessage[IndexMessage].messageBot.length - 47,
              self.listMessage[IndexMessage].messageBot.length
            ) == '<span class="blinking-cursor" style="">|</span>'
          ) {
            self.listMessage[IndexMessage].messageBot = self.listMessage[
              IndexMessage
            ].messageBot.substring(
              0,
              self.listMessage[IndexMessage].messageBot.length - 47
            );
          }
          if (
            self.Count_messageRes[IndexMessage] <
            self.messageRes[IndexMessage].length
          ) {
            // self.messageRun += self.messageRes[self.Count_messageRes];

            if (
              self.messageRes[IndexMessage].length >
              self.Count_messageRes[IndexMessage] + 5 &&
              self.messageRes[IndexMessage][self.Count_messageRes] == "<"
            ) {
              if (
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage]
                ] +
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage] + 1
                ] +
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage] + 2
                ] +
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage] + 3
                ] +
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage] + 4
                ] +
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage] + 5
                ] ==
                "<br />"
              ) {
                self.listMessage[IndexMessage].messageBot += "<br />";
                self.Count_messageRes[IndexMessage] += 5;
              } else if (
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage]
                ] == "<"
              ) {
                self.listMessage[IndexMessage].messageBot +=
                  self.messageRes[IndexMessage][
                  self.Count_messageRes[IndexMessage]
                  ];
              } else {
                self.listMessage[IndexMessage].messageBot +=
                  self.messageRes[IndexMessage][
                  self.Count_messageRes[IndexMessage]
                  ];
              }
            } else if (
              self.messageRes[IndexMessage][
              self.Count_messageRes[IndexMessage]
              ] +
              self.messageRes[IndexMessage][
              self.Count_messageRes[IndexMessage] + 1
              ] +
              self.messageRes[IndexMessage][
              self.Count_messageRes[IndexMessage] + 2
              ] +
              self.messageRes[IndexMessage][
              self.Count_messageRes[IndexMessage] + 3
              ] +
              self.messageRes[IndexMessage][
              self.Count_messageRes[IndexMessage] + 4
              ] +
              self.messageRes[IndexMessage][
              self.Count_messageRes[IndexMessage] + 5
              ] +
              self.messageRes[IndexMessage][
              self.Count_messageRes[IndexMessage] + 6
              ] +
              self.messageRes[IndexMessage][
              self.Count_messageRes[IndexMessage] + 7
              ] ==
              "![Image]" ||
              self.messageImage != ""
            ) {
              let count = 0;
              for (
                let index = self.Count_messageRes[IndexMessage];
                index < self.messageRes[IndexMessage].length;
                index++
              ) {
                const element = self.messageRes[IndexMessage][index];
                self.messageImage += element;
                count++;
                if (element == ")") {
                  break;
                }
              }
              if (
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage] + (count - 1)
                ] == ")"
              ) {
                self.listMessage[IndexMessage].messageBot += self.messageImage;
                self.messageImage = "";
              }
              self.Count_messageRes[IndexMessage] += count - 1;
            } else {
              self.listMessage[IndexMessage].messageBot +=
                self.messageRes[IndexMessage][
                self.Count_messageRes[IndexMessage]
                ];
              self.messageImage = "";
            }
            self.Count_messageRes[IndexMessage]++;
            // self.ChatRef_ScrollIntoView();
          }

          // self.listMessage[IndexMessage].messageBot += `<span class="blinking-cursor" style="">|</span>`;

          if (
            self.Count_messageRes[IndexMessage] ==
            self.messageRes[IndexMessage].length &&
            self.listMessage[IndexMessage].status_Process == "END"
          ) {
            //  self.listMessage[self.listMessage.length - 1].status_Process = "END";

            if (
              self.listMessage[IndexMessage].messageBot.length > 0 &&
              self.listMessage[IndexMessage].messageBot.substring(
                self.listMessage[IndexMessage].messageBot.length - 47,
                self.listMessage[IndexMessage].messageBot.length
              ) == '<span class="blinking-cursor" style="">|</span>'
            ) {
              self.listMessage[IndexMessage].messageBot = self.listMessage[
                IndexMessage
              ].messageBot.substring(
                0,
                self.listMessage[IndexMessage].messageBot.length - 47
              );
            }
            self.listMessage[IndexMessage].messageBot = self.listMessage[
              IndexMessage
            ].messageBot.replace(
              '<span class="blinking-cursor" style="">|</span>',
              ""
            );
            return;
          }

          self.Text_Run(IndexMessage);
        }
      }, self.Time_Delay);
    },

    async CHK_Auth_Token() {
      let self = this;
      try {
        let _auth_token = { auth_token: self.auth_token_local };
        // self.auth_token_local = "";
        // เปลี่ยนการใช้ callback เป็น Promise
        let response = await new Promise((resolve, reject) => {
          self.$call.ChkTokenFullStream(
            _auth_token,
            (response) => {
              if (response.status == 0 && response.data.chk) {
                resolve(response);
              } else {
                self.$swal.fire({
                  icon: "error",
                  title: "Authorization token is missing or has expired.",
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  allowEnterKey: false,
                  showConfirmButton: false,
                  width: '600px',
                  customClass: {
                  popup: 'swal-modern-popup',
                  title: 'swal-modern-title',
                  content: 'swal-modern-content',
                  }
                });
                reject(new Error("ไม่พบ Auth"));
              }
            },
            () => {
              reject(new Error("ไม่พบ Auth"));
            }
          );
        });
        // ดำเนินการต่อเมื่อ Promise สำเร็จ
        self.Time_Delay = response.data.timeDelay;
        self.role.ID = response.data.roleId;
        self.role.Name = response.data.roleName;
        self.Status_Error = false;
        
        self.GetUuidAll();
      } catch (error) {
        self.Status_Error = true;
        self.Text_Status = error.message;
      }
    },

    GetHistoryFullStream(Status) {
      var self = this;
      if (self.Loading_History_Status == true && self.startLoading == true) {
        return;
      }
      try {
        if (Status == "Start") {
          self.Log_History_ID = 0;
        }
        let _User_Id = {
          TopicID: self.Log_History_TopicID,
          USER_CHANNEL: self.User_Id,
          ID: self.Log_History_ID,
          Take: self.Log_History_Take,
        };

        self.Loading_History_Status = true;
        self.$call.GetHistoryFullStream(
          _User_Id,
          self.auth_token_local,
          (response) => {
            self.startLoading = true;
            if (response.status == 0) {
              let response_data = response.data;
              const thisData = response_data.map((v) => ({
                ...v,
                comment: "",
                commentDialog: false,
                moreComment: false,
                feedback: null,
                status: null,
              }));
              if (Status == "Start") {
                self.listMessage = thisData;
                self.$nextTick(() => {
                  self.SetBottom_Page();
                });
              } else if (Status == "ScrollUp") {
                if (!(self.listMessage.length > 0 && self.listMessage[0].id == undefined)) {
                  const mergedMessages = thisData.concat(self.listMessage);
                  self.listMessage = mergedMessages.filter((msg, index, arr) =>
                    index === arr.findIndex(m => m.id === msg.id)
                  );
                } else {
                  self.flagTopHistory = false;
                }

                if (self.flagTopHistory) {
                  setTimeout(() => {
                    var element1 = document.getElementById(
                      "ChatId_" + self.Log_History_ID
                    );
                    if (element1 != undefined && element1 != null) {
                      self.$refs.ChatScreRef.scrollTop =
                        element1.offsetTop - 20;
                    }
                    self.Loading_History_Status = false;
                  }, 1);
                }
              }
              thisData.map(() => {
                self.messageRes.push("");
              });
            }
            self.Loading_History_Status = false;
          },
          () => {
            self.Loading_History_Status = false;
          }
        );
      } catch {
        // self.listMessage = [];
      }
    },

    GetTopicFullStream(status) {
      var self = this;
      try {
        try {
          if (status === "ChangHistory" || status === "Start") {
            self.Loading_History_Status = true;
            self.startLoading = false;
            self.GetShortcutMenu();
          }
        } catch { }

        let _User_Id = {
          USER_CHANNEL: self.User_Id,
          status: status,
        };
        self.$call.GetTopicStreamToken(
          _User_Id,
          self.auth_token_local,
          (response) => {
            if (response.status == 0 && _User_Id.USER_CHANNEL == self.User_Id) {
              let response_data = response.data;
              self.listTopic = response_data;
              self.$nextTick(() => {
                if (self.listMessage.length > 0) {
                  if (
                    [":model"].some((keyword) =>
                      self.listMessage[self.listMessage.length - 1].messageUser
                        .toLowerCase()
                        .includes(keyword.toLowerCase())
                    )
                  ) {
                    if (self.Log_History_TopicID != -1) {
                      self.Time_Delay = response_data.find(
                        (e) => e.topicID == self.Log_History_TopicID
                      ).timeDelay;
                      self.maximumChatInput = response_data.find(
                        (e) => e.topicID == self.Log_History_TopicID
                      ).maximumChatInput;
                      self.IsAllowImage = response_data.find(
                        (e) => e.topicID == self.Log_History_TopicID
                      ).isAllowImage;
                      self.FileUploadLimit = response_data.find(
                        (e) => e.topicID == self.Log_History_TopicID
                      ).fileUploadLimit;
                      self.IsChainMassage = response_data.find(
                        (e) => e.topicID == self.Log_History_TopicID
                      ).isChainMassage;
                      self.isAllowLLMChange = response_data.find(e => e.topicID == self.Log_History_TopicID).isAllowLLMChange;
                    } else {
                      self.Time_Delay = response_data[0].timeDelay;
                      self.maximumChatInput = response_data[0].maximumChatInput;
                      self.IsAllowImage = response_data[0].isAllowImage;
                      self.FileUploadLimit = response_data[0].fileUploadLimit;
                      self.IsChainMassage = response_data[0].isChainMassage;
                      self.isAllowLLMChange = response_data[0].isAllowLLMChange;
                    }
                  }
                } else {
                  if (response_data.length > 0) {
                    if (self.Log_History_TopicID != -1) {
                      self.Time_Delay = response_data.find((e) => e.topicID == self.Log_History_TopicID).timeDelay;
                      self.maximumChatInput = response_data.find((e) => e.topicID == self.Log_History_TopicID).maximumChatInput;
                      self.IsAllowImage = response_data.find((e) => e.topicID == self.Log_History_TopicID).isAllowImage;
                      self.FileUploadLimit = response_data.find((e) => e.topicID == self.Log_History_TopicID).fileUploadLimit;
                      self.IsChainMassage = response_data.find((e) => e.topicID == self.Log_History_TopicID).isChainMassage;
                      self.isAllowLLMChange = response_data.find(e => e.topicID == self.Log_History_TopicID).isAllowLLMChange;
                    } else {
                      self.Time_Delay = response_data[0].timeDelay;
                      self.maximumChatInput = response_data[0].maximumChatInput;
                      self.IsAllowImage = response_data[0].isAllowImage;
                      self.FileUploadLimit = response_data[0].fileUploadLimit;
                      self.IsChainMassage = response_data[0].isChainMassage;
                      self.isAllowLLMChange = response_data[0].isAllowLLMChange;
                    }
                  }
                }
              });
              if (status != "Steam") {
                if (status == "Start") {
                  if (response_data.length > 0) {
                    self.Log_History_TopicID = response_data[0].topicID;
                    self.TopicName = response_data[0].topicName;
                    self.TopicModelID = response_data[0].topicModelID;
                    self.isFeedback = response_data[0].isFeedback;
                    if (response_data[0].topicModelID_long != null) {
                      self.TopicModelID_long =
                        response_data[0].topicModelID_long;
                    }

                    if (
                      response_data[0].keyTopic != null &&
                      response_data[0].keyTopic != undefined
                    ) {
                      self.KeyTopic = response_data[0].keyTopic;
                    }
                    self.ModelFirst = response_data[0].topicModelID;
                    if (self.GetLogStreamStart_Flag == true) {
                      self.GetLogStreamStart_Flag = false;
                    }
                  } else {
                    self.GetModelFirst(self.parameterURL.groupmodel, self.User_Id);
                  }
                }

                self.GetHistoryFullStream("Start");
              } else {
                if (response_data.length > 0) {
                  self.Log_History_TopicID = response_data[0].topicID;
                  self.TopicName = response_data[0].topicName;

                  self.TopicModelID = response_data[0].topicModelID;
                  self.isFeedback = response_data[0].isFeedback;
                  if (response_data[0].topicModelID_long != null) {
                    self.TopicModelID_long = response_data[0].topicModelID_long;
                  }

                  if (
                    response_data[0].keyTopic != null &&
                    response_data[0].keyTopic != undefined
                  ) {
                    self.KeyTopic = response_data[0].keyTopic;
                  }
                  self.ModelFirst = response_data[0].topicModelID;
                } else {
                  self.GetModelFirst(null, self.User_Id);
                }
              }
            } else {
              self.listTopic = [];

              self.GetModelFirst(null, self.User_Id);
            }
            self.flagShowTopic = false;
          },
          () => {
            self.GetModelFirst(null, self.User_Id);
            self.listTopic = [];
            self.flagShowTopic = false;
          }
        );
      } catch {
        self.GetModelFirst(self.parameterURL.groupmodel, self.User_Id);
        self.listTopic = [];
        self.flagShowTopic = false;
      }
    },
    SetBottom_Page() {
      var self = this;
      let attempts = 0;
      const maxAttempts = 1;
      const intervalTime = 200;

      function tryScrollToBottom() {
        attempts++;
        // const bottomMarker = self.$refs.ChatRef; // ยังคงเช็คเพื่อให้แน่ใจว่ามีเนื้อหา
        const actualScrollContainer = self.$refs.MainScrollArea; // ใช้ ref ใหม่

        if (actualScrollContainer) {
          actualScrollContainer.scrollTo({
            top: actualScrollContainer.scrollHeight,
            behavior: "smooth",
          });
        }

        if (attempts < maxAttempts) {
          setTimeout(tryScrollToBottom, intervalTime);
        }
      }
      setTimeout(tryScrollToBottom, 100);
    },

    GetTopicIDStream(_messageData) {
      var self = this;
      try {
        let _User_Id = {
          USER_CHANNEL: self.User_Id,
          messageData: _messageData,
          KeyTopic: self.KeyTopic,
        };

        self.$call.GetTopicIDStream(
          _User_Id,
          (response) => {
            if (response.status == 0 && response.data.status == true) {
              let DataLog_Data = response.data.data;
              self.flagTopHistory = true;
              try {
                if (DataLog_Data != null) {
                  self.Log_History_TopicID = DataLog_Data.topicID;
                  self.KeyTopic = DataLog_Data.keyTopic;
                  self.TopicName = DataLog_Data.topicName;

                  self.TopicModelID = DataLog_Data.topicModelID;

                  self.TopicModelID_long = DataLog_Data.topicModelID_long;
                }
              } catch {
                console.log("replymsg E");
              }
            } else {
              console.log("GetTopicIDStream : else");
            }
          },
          () => {
            console.log("GetTopicIDStream : false");
          }
        );
      } catch {
        console.log("GetTopicIDStream : GG");
      }
    },

    GetShortcutMenu() {
      var self = this;
      try {
        if (!self.parameterURL.groupmodel) {
          return;
        }
        let _groupmodel = {
          groupModel: self.parameterURL.groupmodel,
        };
        self.$call.GetShortcutMenu(
          _groupmodel,
          self.auth_token_local,
          (response) => {
            if (response.status == 0) {
              let responseData = response.data;
              if (responseData) {
                self.ShortcutMenu = responseData;
              }
            }
          },
          () => {
            console.log("GetShortcutMenu : false");
          }
        );
      } catch (ex) {
        console.log(ex);
      }
    },

    GetModelQuickGroupInModelGroup() {
      var self = this;
      try {
        let _groupmodel = {
          groupmodel: self.parameterURL.groupmodel,
          USER_CHANNEL: self.User_Id,
          snippet: self.snipet_flag,
          domainName: self.URL_Domain,
        };
        self.$call.GetModelQuickGroupInModelGroup(
          _groupmodel,
          self.auth_token_local,
          (response) => {
            if (response.status == 0) {
              let DataLog_Data = response.data;
              try {
                self.ModelQuick = DataLog_Data;
              } catch {
                console.log("replymsg E");
              }
            } else {
              console.log("GetTopicIDStream : else");
            }
          },
          () => {
            console.log("GetTopicIDStream : false");
          }
        );
      } catch {
        console.log("GetTopicIDStream : GG");
      }
    },

    GetModelQuickGroupInModelGroupPostToken() {
      var self = this;
      try {
        let _groupmodel = {
          groupmodel: self.parameterURL.groupmodel,
          USER_CHANNEL: self.User_Id,
          snippet: self.snipet_flag,
          domainName: self.URL_Domain,
        };
        self.$call.GetModelQuickGroupInModelGroupPostToken(
          _groupmodel,
          self.auth_token_local,
          (response) => {
            if (response.status == 0) {
              let DataLog_Data = response.data;
              try {
                self.ModelQuick = DataLog_Data;
                self.showModelQuick = DataLog_Data.filter(
                  (item) => item.typeModel === 1
                );
              } catch {
                console.log("replymsg E");
              }
            } else {
              console.log("GetTopicIDStream : else");
            }
          },
          () => {
            console.log("GetTopicIDStream : false");
          }
        );
      } catch {
        console.log("GetTopicIDStream : GG");
      }
    },

    Themecolor() {
      this.selectedColor =
        this.colorThemeChat != null ? `#${this.colorThemeChat}` : "#FFA41E";
    },
    async loadSvg() {
      try {
        await fetch(modelSVG).then(async (response) => {
          if (response.ok) {
            const svgText = await response.text();
            this.svgContent = svgText;
            //  await this.$nextTick(async () => {
            if (
              this.colorThemeChat != null ||
              this.colorThemeChat != undefined
            ) {
              await this.changeStrokeColor(`#${this.colorThemeChat}`); // à¹€à¸›à¸¥à¸µà¹ˆà¸¢à¸™à¸ªà¸µ stroke
            } else {
              -(await this.changeStrokeColor(`#FFA41E`)); // à¹€à¸›à¸¥à¸µà¹ˆà¸¢à¸™à¸ªà¸µ stroke
            }
            // });
          } else {
            this.loadColor = true;
          }
        });
        // const response = await fetch(require('@/assets/images/Model.svg'));
        // console.log(response);
        // if (!response.ok) {
        //   throw new Error('Network response was not ok');
        // }
        // const svgText = await response.text();
        // this.svgContent = svgText;
        // this.$nextTick(() => {
        //   this.changeStrokeColor('#FF0000'); // à¹€à¸›à¸¥à¸µà¹ˆà¸¢à¸™à¸ªà¸µ stroke
        // });
      } catch (error) {
        console.error("Error loading SVG:", error);
      }
    },
    async changeStrokeColor(color) {
      const svgElement = await document.querySelector("div#quickGroup svg");
      if (svgElement) {
        const btnElement = await document.querySelector("div#quickGroup");
        btnElement.style.justifyContent = "center";
        let check = 0;
        svgElement.querySelectorAll("*").forEach((el, index, arr) => {
          el.setAttribute("stroke", color);
          el.setAttribute("stroke-width", 2);
          svgElement.style.width = "24px";
          svgElement.style.height = "24px";
          check++;
          if (check === arr.length) {
            this.loadColor = true;
          }
        });
      }
    },
    GetDateTime() {
      let month_names_short = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ];
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth(); //January is 0!

      // let yyyy = today1.getFullYear();

      let hh = today1.getHours();
      let m = today1.getMinutes();

      if (dd < 10) {
        dd = "0" + dd;
      }
      this.today = dd + " " + month_names_short[mm] + " " + hh + ":" + m;
    },
    ThisFeedBackResponse(item, status) {
      let self = this;

      this.listMessage = this.listMessage.map((v) => ({
        ...v,
        status: item.id == v.id ? status : v.status,
        commentDialog: false,
        comment: item.comment,
      }));
      let temp = {
        data: {
          LogID: item.id,
          Comment: item.comment,
          Score: status,
          CreateBy: self.User_Id,
          ModelDisplayID: item.modelDisplayID,
        },
        token: self.auth_token_local,
      };
      self.$call.FeedbackFromClient(
        temp,
        (response) => {
          if (response.status == 0) {
            this.listMessage = this.listMessage.map((v) => ({
              ...v,
              commentDialog: false,
              SelectComment: null,
              comment: null,
            }));
          }
          self.closeDialog(item);
        },
        () => {
          this.listMessage = this.listMessage.map((v) => ({
            ...v,
            commentDialog: false,
            SelectComment: null,
            comment: null,
          }));
        }
      );
    },
    openCommentDialog(item, index) {
      this.listMessage = this.listMessage.map((v, _index) => ({
        ...v,
        status: index == _index ? 0 : v.status,
        commentDialog: index == _index ? true : false,
      }));

      item.status = 0;
      item.commentDialog = true;
    },
    closeDialog(item) {
      item.commentDialog = false;
      item.SelectComment = null;
      item.comment = null;
    },
    Clipboard(item) {
      let text = document.createElement("textarea");
      text.value = this.listMessage.find((v) => item.id == v.id).messageBot;
      if (
        text.value.substring(text.value.length - 47, text.value.length) ==
        '<span class="blinking-cursor" style="">|</span>'
      ) {
        text.value = text.value.substring(0, text.value.length - 47);
      }
      text.focus();
      document.body.appendChild(text);
      text.select();

      document.execCommand("copy");
      text.parentNode.removeChild(text);
    },
    NotificationMSTeamOnly() {
      let self = this;
      self.$swal.fire({
        icon: "error",
        title: "Please use in MS Team only.",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      });
    },
    // ตรวจสอบว่ามี overflow ในแนวนอนหรือไม่
    checkOverflow() {
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer;
        if (!el) return;
        // ถ้า scrollWidth > clientWidth แปลว่ามีส่วนเกินต้องเลื่อน
        this.showScrollButtons = el.scrollWidth > el.clientWidth;
      });
    },
    onScroll() {
      const el = this.$refs.scrollContainer;
      if (!el) return;
      // เช็คว่าถึงซ้ายสุดหรือยัง
      this.showLeftButton =
        this.ShortcutMenu.length > 0 &&
        el.scrollLeft > 0 &&
        el.scrollWidth > el.clientWidth;
      // เช็คว่าถึงขวาสุดหรือยัง
      this.showRightButton =
        this.ShortcutMenu.length > 0 &&
        el.scrollLeft + el.clientWidth < el.scrollWidth &&
        el.scrollWidth > el.clientWidth;
    },
    scrollLeft() {
      // เลื่อน container ไปทางซ้าย 250px
      this.$refs.scrollContainer.scrollLeft -= 250 + 24;
    },
    scrollRight() {
      // เลื่อน container ไปทางขวา 250px
      this.$refs.scrollContainer.scrollLeft += 250 + 24;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkOverflow);
    if (this.$refs.MainScrollArea) {
      this.$refs.MainScrollArea.removeEventListener(
        "scroll",
        this.checkScrollPosition
      );
    }
  },
  async mounted() {
    let self = this;
    
    // self.AutoRefresh();
    self.GetDDGroupReplaceDB_FullStream();
    self.onScroll();
    self.Loading_History_Status = true;
    self.flagGetAllTopic = false;
    // ตรวจสอบทันทีที่ mount (เผื่อหน้าต่างเล็ฝ/ใหญ่)
    this.checkOverflow();
    // ลองฟัง event resize เพื่อเช็คเมื่อหน้าต่างย่อ/ขยาย
    window.addEventListener("resize", this.checkOverflow);
    self.SessionID = self.GetUuidv4_Fun();
    if (
      sessionStorage.getItem("Domain") != undefined &&
      sessionStorage.getItem("Domain") != null &&
      sessionStorage.getItem("Domain") != "null"
    ) {
      self.URL_Domain = sessionStorage.getItem("Domain");
    }
    if (
      sessionStorage.getItem("snippet") != undefined &&
      sessionStorage.getItem("snippet") != null
    ) {
      self.snipet_flag = sessionStorage.getItem("snippet");
    }
    if (
      sessionStorage.getItem("modelID") != undefined &&
      sessionStorage.getItem("modelID") != null &&
      sessionStorage.getItem("modelID") != "null"
    ) {
      self.modelDisplayID = sessionStorage.getItem("modelID");
    }
    if (
      sessionStorage.getItem("userChanel") != undefined &&
      sessionStorage.getItem("userChanel") != null &&
      sessionStorage.getItem("userChanel") != "null"
    ) {
      self.userChanel = sessionStorage.getItem("userChanel");
    }
    if (
      sessionStorage.getItem("tokenParam") != undefined &&
      sessionStorage.getItem("tokenParam") != null &&
      sessionStorage.getItem("tokenParam") != "null"
    ) {
      self.tokenParam = sessionStorage.getItem("tokenParam");
    }

    self.$nextTick(async function () {
      self.Log_History_Take = 5;
      self.Log_History_ID = null;
      self.KeyTopic = null;
      self.TopicModelID_long = -1;
      self.StatusKeyRename = false;
      self.ModelFirst = "-";

      self.TopicName = "";
      self.TopicModelID = "";
      self.Log_History_TopicID = -1;
      for (let key in self.$route.query) {
        self.parameterURL[key.toLowerCase()] = self.$route.query[key];
      }
      if (self.parameterURL.snippet != "true") {
        if (
          self.parameterURL.auth_token == null ||
          self.parameterURL.auth_token == undefined ||
          self.parameterURL.auth_token == ""
        ) {
          self.Status_Error = true;
          self.Text_Status = "à¹„à¸¡à¹ˆà¸žà¸š token";
          return;
        } else {
          self.auth_token_local = self.parameterURL.auth_token;
          self.auth_token = self.parameterURL.auth_token;
          await self.CHK_Auth_Token();
          
        }
      } else {
        // if (Cookies.get("token") != null) {
        if (self.parameterURL.snippet != undefined) {
          let snippet_temp = self.parameterURL.snippet;
          self.snipet_flag = String(snippet_temp).toLowerCase() === "true";
          sessionStorage.setItem("snippet", snippet_temp);
        } else if (
          sessionStorage.getItem("snippet") != undefined &&
          sessionStorage.getItem("snippet") != null
        ) {
          self.snipet_flag = sessionStorage.getItem("snippet");
        } else {
          sessionStorage.setItem("snippet", false);
        }

        if (self.parameterURL.domainname != undefined) {
          let Domain = self.parameterURL.domainname;
          self.URL_Domain = Domain;
          sessionStorage.setItem("Domain", Domain);
        } else if (
          sessionStorage.getItem("Domain") != undefined &&
          sessionStorage.getItem("Domain") != null
        ) {
          self.URL_Domain = sessionStorage.getItem("Domain");
        }

        if (self.parameterURL.modelid != undefined) {
          let modelDisplayID = self.parameterURL.modelid;
          self.modelDisplayID = modelDisplayID;
          sessionStorage.setItem("modelID", modelDisplayID);
        } else if (
          sessionStorage.getItem("modelID") != undefined &&
          sessionStorage.getItem("modelID") != null &&
          sessionStorage.getItem("modelID") != ""
        ) {
          self.modelDisplayID = sessionStorage.getItem("modelID");
        }

        if (
          self.parameterURL.user_ch != undefined &&
          self.parameterURL.user_ch != null &&
          self.parameterURL.user_ch != "null" &&
          self.parameterURL.user_ch != ""
        ) {
          let userChanel = self.parameterURL.user_ch;
          self.userChanel = userChanel;
          sessionStorage.setItem("userChanel", userChanel);
          self.User_Id_Show = userChanel;
        } else if (
          sessionStorage.getItem("userChanel") != undefined &&
          sessionStorage.getItem("userChanel") != null &&
          sessionStorage.getItem("userChanel") != "" &&
          sessionStorage.getItem("userChanel") != "null"
        ) {
          self.userChanel = sessionStorage.getItem("userChanel");
          self.User_Id_Show = sessionStorage.getItem("userChanel");
        }

        if (self.parameterURL.chk_token != undefined) {
          let tokenParam = self.parameterURL.chk_token;
          self.tokenParam = tokenParam;
          sessionStorage.setItem("tokenParam", tokenParam);
        } else if (
          sessionStorage.getItem("tokenParam") != undefined &&
          sessionStorage.getItem("tokenParam") != null &&
          sessionStorage.getItem("tokenParam") != ""
        ) {
          self.tokenParam = sessionStorage.getItem("tokenParam");
        }

        if (
          sessionStorage.getItem("token_Snippet") != null ||
          localStorage.getItem("token_Snippet") != null ||
          Cookies.get("token_Snippet") != null
        ) {
          if (sessionStorage.getItem("token_Snippet") != null) {
            self.auth_token_local = sessionStorage.getItem("token_Snippet");
            self.User_Id = sessionStorage.getItem("email_Snippet");
            self.username = sessionStorage.getItem("username_Snippet");
            self.auth_token = self.auth_token_local;
          } else if (Cookies.get("token_Snippet") != null) {
            self.auth_token_local = Cookies.get("token_Snippet");
            self.User_Id = Cookies.get("email_Snippet");
            self.username = Cookies.get("username_Snippet");
            self.auth_token = self.auth_token_local;
          } else if (localStorage.getItem("token_Snippet") != null) {
            self.auth_token_local = localStorage.getItem("token_Snippet");
            self.User_Id = localStorage.getItem("email_Snippet");
            self.username = localStorage.getItem("username_Snippet");
            self.auth_token = self.auth_token_local;
          }

          self.GetModelQuickGroupInModelGroupPostToken();
          self.GetTopicFullStream("Start");
        } else {
          if (
            sessionStorage.getItem("userChanel") != undefined &&
            sessionStorage.getItem("userChanel") != null &&
            sessionStorage.getItem("userChanel") != "" &&
            sessionStorage.getItem("userChanel") != "null"
          ) {
            self.userChanel = sessionStorage.getItem("userChanel");
            self.User_Id_Show = sessionStorage.getItem("userChanel");
            self.User_Id = sessionStorage.getItem("userChanel");
          }
          self.GetUuidv4();
        }
        self.Status_Error = false;
        self.snippet_Status = true;
      }
      this.$nextTick(() => {
        if (this.$refs.MainScrollArea) {
          this.$refs.MainScrollArea.addEventListener(
            "scroll",
            this.checkScrollPosition
          );
          // Initial check
          this.checkScrollPosition();
        }
      });
    });
    if (self.$route.query.name) {
      self.requestVector.searchVectorDBName2 = self.$route.query.name;
      self.showTable = true;
      self.actionEdit = true;
      self.flagNew = false;
    } else {
      self.dataUpdate = 0;
      self.GetMaxLimitedCharacter();
    }
    if (self.requestVector.MaxLimitedCharacter == null) {
      self.ReFresh();
    }
  },
  beforeUpdate() {
    let self = this;
    if (self.loadColor != true) {
      self.Themecolor();
      self.loadSvg();
    }
  },
};
</script>

<style scoped>
.custom-footer {
  position: sticky;
  bottom: 0 !important;
  width: 100%;
  height: auto !important;
}

@-webkit-keyframes blinker {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes blinker {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

/* .blink-cursor{ */
.blinking-cursor {
  text-decoration: blink;
  -webkit-animation-name: blinker;
  -webkit-animation-duration: 0.6s;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-direction: alternate;
  animation-name: blinker;
  animation-duration: 0.6s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
}

.btn_PrivateMemoryDialog_ListFile .col-6 button {
  width: 100%;
}

@media (min-width: 600px) {

  .btn_PrivateMemoryDialog_ListFile .col-sm-6 button,
  .btn_PrivateMemoryDialog_ListFile .col-md-6 button {
    width: 120px;
  }

  .btn_PrivateMemoryDialog_ListFile .row {
    display: inline-flex;
  }
}

.v_data_table_Private_Memory .v-data-table__empty-wrapper td {
  text-align: center;
}

.Cls_Text_field_TopicName {
  /* width: 192px; */
  /* width: 100%;  */
  padding-top: 0px;
  height: 32px;
  z-index: 99999;
  display: flex;
  /* color: white !important; */
}

.Cls_Text_field_TopicName .v-input__slot {
  /* border-color: white !important; */

  background-color: white !important;
  min-height: 32px !important;
}

.Cls_Text_field_TopicName input {
  /* color: white !important; */
  font-size: 15px;
}

.FullStream_Status_Margin {
  position: fixed;
  margin-top: calc(60px);
}

.FullStream_Status_Margin2 {
  /* margin-top: calc(60px + 22px) !important; */
  height: calc(100dvh - 112px);
}

.Snippet_StatusData_Margin {
  /* margin-top: 55px !important; */
  height: 100% !important;
}

.Snippet_StatusData_Margin #Col_Snippet {
  margin-bottom: 0px !important;
}

.Snippet_StatusData_Margin #D_MessageData {
  /* max-height: 83px !important;
  height: 45px !important; */
  max-height: 83px !important;
  /* height: 60px !important; */
  font-size: 12px;
  margin-bottom: 12px;
}

#V_markDown {
  /* display: block; */
  display: grid;
}

#V_markDown p {
  margin: 0;
  /* display: contents; */
  display: block;
}

#V_markDown table {
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: gray;
  display: table;
  text-indent: 0;
}

#V_markDown tr {
  border-top: 1px solid #c6cbd1;
  background: #fff;
}

#V_markDown td,
#V_markDown th {
  padding: 6px 13px;
  border: 1px solid #dfe2e5;
}

#V_markDown table tr:nth-child(2n) {
  background: #f6f8fa;
}

#V_markDown li code,
#V_markDown p code {
  background-color: transparent;
  color: blue;
}

#V_markDown code.language-markdown,
#V_markDown pre code {
  display: block;
  background: #2b2b2b;
  color: #f0f8ff;
}

#V_markDown code {
  white-space: pre-wrap;
  background: #2b2b2b;
  color: #f0f8ff;
}

#V_markDown pre code {
  margin: 10px 0px;
}

#V_markDown img {
  max-width: 100%;
  max-height: 320px;
}

#V_markDown ul.contains-task-list li {
  margin-top: -20px;
}

#V_markDown br {
  content: "";
  margin: 0;
  display: block;
  font-size: 24%;
}

#V_markDown li {
  margin-top: -1em;
}

#V_markDown li p {
  margin-top: -22px;
}

#V_markDown li p strong {
  margin-top: 0px;
  display: block;
}

#V_markDown ul {
  margin-bottom: -20px;
}

#V_markDown ol li ul {
  margin-bottom: -40px;
}

/* #V_markDown h1{
  padding-top: 6px;
} */
#V_markDown h1,
#V_markDown h2,
#V_markDown h3,
#V_markDown h4,
#V_markDown h5 {
  /* padding-top: 15px; */

  margin-top: 7.5px;
  margin-bottom: 7.5px;
}

#V_markDown ol {
  margin-bottom: -25px;
}

#V_markDown blockquote {
  margin-top: -35px;
}

#V_markDown .container {
  margin-top: 0px;
}

#ModelQuickId::-webkit-scrollbar,
#Editdialog_ID::-webkit-scrollbar {
  height: 10px;
}

#Editdialog_ID::-webkit-scrollbar,
#PrivateMemory::-webkit-scrollbar,
#PrivateMemory_ListFile::-webkit-scrollbar,
#ChatScreId::-webkit-scrollbar,
#ModelQuickId::-webkit-scrollbar,
#toppic_list_id::-webkit-scrollbar,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar {
  width: 10px;
}

#Editdialog_ID::-webkit-scrollbar-track,
#PrivateMemory::-webkit-scrollbar-track,
#PrivateMemory_ListFile::-webkit-scrollbar-track,
#ChatScreId::-webkit-scrollbar-track,
#ModelQuickId::-webkit-scrollbar-track,
#toppic_list_id::-webkit-scrollbar-track,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar-track {
  background-color: gainsboro;
  border-radius: 5px;
}

#Editdialog_ID::-webkit-scrollbar-thumb,
#PrivateMemory::-webkit-scrollbar-thumb,
#PrivateMemory_ListFile::-webkit-scrollbar-thumb,
#ChatScreId::-webkit-scrollbar-thumb,
#ModelQuickId::-webkit-scrollbar-thumb,
#toppic_list_id::-webkit-scrollbar-thumb,
#NavFullStream .v-navigation-drawer__content::-webkit-scrollbar-thumb {
  /* background-color: rgb(255, 70, 70); */

  background-color: rgb(0, 78, 140);
  /* outline: 1px solid slategrey; */

  border-radius: 5px;
}

@media only screen and (min-width: 1263px) {
  .widthNav {
    /* background-color: red; */
    /* width: calc(100% - 255px) !important; */
    padding: 0px 0px 0px 0px;
    /* width: 80% !important; */
  }
}

.v-navigation-drawer {
  border-radius: 0px 5px 5px 0px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px,
    rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;
}

/* ปรับ v-col ที่เป็น container-chat */
.v-col.container-chat {
  height: 100vh !important;
  max-height: 100vh !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column;
  align-items: center;
}

/* Responsive สำหรับหน้าจอเล็ฝ */
@media (max-width: 768px) {
  .container-chat {
    grid-template-rows: 56px 1fr auto auto;
    /* หน้าจอเล็ฝใช้ 56px */
  }

  v-row[style*="grid-area: header"] {
    height: 56px !important;
    min-height: 56px !important;
    max-height: 56px !important;
  }
}

::-webkit-scrollbar {
  height: 7px !important;
  width: 5px !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 3px !important;
}
</style>

<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.card {
  border-radius: 10px !important;
  height: 90dvh;
  /* overflow: auto; */
  margin: 0 0 2rem 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
  padding-top: 0.5em;
}

.v-text-field .v-input__append-inner {
  align-self: end !important;
}

.textarea-container {
  position: sticky;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* counter text-area */
.icon-container {
  position: absolute;
  /* bottom: 25px; */
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 40%;
  height: 40px;
}

.icon-container-mobile {
  position: absolute;
  bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 40%;
  height: 40px;
}

.v-textarea__slot {
  padding: 10px;
  /* à¸›à¸£à¸±à¸šà¸„à¹ˆà¸²à¸•à¸²à¸¡à¸—à¸µà¹ˆà¸•à¹‰à¸­à¸‡à¸�à¸²à¸£ */
}

.custom-textarea .v-input__slot {
  /* max-height: 7rem; */
  position: relative;
}

textarea.custom-textarea {
  max-height: 7rem;
  /* overflow: auto; */
}

:deep(.custom-textarea .v-input__control .v-input__slot .v-text-field__slot) {
  padding: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
}

/* .custom-textarea .v-text-field__slot{
  margin-bottom: 16px !important;
} */
/* menu text-area */
.custom-icon {
  position: relative;
  /* bottom: 10px; */
  /* bottom: -25px; */
  bottom: 0;
  right: 0;
}

.custom-icon-mobile {
  /* position: absolute; */
  /* bottom: -25px; */
  bottom: 0;
  right: 0;
}

:deep(.custom-textarea .v-input__prepend-outer) {
  margin-top: 10px !important;
}

:deep(.custom-textarea .v-input__append-outer) {
  margin-top: 0px !important;
  /* display:absolute; */
}

:deep(.custom-textarea .v-input__control .v-input__slot textarea) {
  font-size: 16px !important;
}

:deep(.custom-textarea .v-input__control .v-input__slot fieldset) {
  background-color: #f6f8fa !important;
}

:deep(#book) {
  background-color: white !important;
}

.rounded-circle {
  border-radius: 50%;
  width: 35px;
  height: 35px;
}

.image-container {
  transition: 0.5s ease;
  position: absolute;
  top: 28%;
  right: 0.7%;
  width: 35px;
  height: 35px;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 52%;
  left: 52%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.middle-progress {
  transition: 0.5s ease;
  position: absolute;
  top: 0%;
  left: 0%;
  color: rgb(247, 179, 78) !important;
  height: 35px !important;
  width: 35px !important;
}

.image-container:hover .middle {
  opacity: 1;
}

.delete-btn {
  background-color: rgb(247, 179, 78, 0.5) !important;
  color: white;
  font-size: 16px;
  height: 35px !important;
  width: 35px !important;
}

ul[data-checked="true"] {
  background-color: green;
}

.responsive-table td {
  white-space: nowrap;
  /* Prevent line breaks within cells */
  overflow: hidden;
  /* Hide overflowed content */
  text-overflow: ellipsis;
  /* Show ellipsis for overflowed content */
  overflow-wrap: anywhere;
}

.text-container {
  display: flex;
  align-items: flex-start;
}

.text-content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  /* Number of lines to show */
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;

  /* margin-right: 8px; Adjust space between text and button if needed */
}

.text-content-show {
  overflow: hidden;
  /* text-overflow: ellipsis; */
  /* display: -webkit-box; */
  /*-webkit-line-clamp: 2; /* Number of lines to show */
  -webkit-box-orient: vertical;
  white-space: normal;
  flex-grow: 1;
}

/* HTML: <div class="cloader"></div> */
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: bblFadInOut 1.4s infinite ease-in-out;
}

.loader {
  color: #ffd000;
  font-size: 5px;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.1s;
}

.loader:before,
.loader:after {
  content: "";
  position: absolute;
  top: 0;
}

.loader:before {
  left: -3.5em;
  animation-delay: -0.32s;
}

.loader:after {
  left: 3.5em;
}

@keyframes bblFadInOut {

  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }

  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

.content-button {
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Standard syntax */
  /* border: 0px solid rgba(0, 0, 0, 0.555); */
  /* box-shadow: 7px 9px 12px rgba(39, 47, 63, 0.2), -7px -9px 12px rgba(255, 255, 255, 1) !important; */
  /* box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15) !important; */
  transition: box-shadow 0.3s ease;
}

.content-button:hover {
  /* box-shadow: 8px 8px 10px rgba(0, 0, 0, 0.15) !important; */
  box-shadow: 5px 5px 10px -5px rgba(0, 0, 0, 0.15) !important;
}

.content-button.v-card--link:focus::before {
  opacity: 0;
}

.container-chat {
  height: 100vh !important;
  max-height: 100vh !important;
  display: grid !important;
  grid-template-columns: 1fr;
  grid-template-rows: 64px 1fr auto auto;
  /* เพิ่มความสูงของ header เป็น 64px */
  grid-template-areas:
    "header"
    "main"
    "products"
    "footer";
  overflow: hidden;
  margin: 0 !important;
  padding: 0 !important;
}

v-row[style*="grid-area: header"] {
  grid-area: header;
  height: 64px !important;
  /* เพิ่มความสูงเป็น 64px */
  min-height: 64px !important;
  max-height: 64px !important;
  margin: 0 !important;
  padding: 0 !important;
  flex-shrink: 0;
  border-bottom: 1px solid #e0e0e0;
  /* เพิ่มเส้นขอบด้านล่าง */
}

v-row[style*="grid-area: main"] {
  grid-area: main;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  min-height: 0;
}

/* à¸�à¸³à¸«à¸™à¸” container à¸«à¸¥à¸±à¸�à¹ƒà¸«à¹‰ position: relative
   à¹€à¸žà¸·à¹ˆà¸­à¸ˆà¸°à¸§à¸²à¸‡à¸›à¸¸à¹ˆà¸¡ (position: absolute) à¸—à¸±à¸š */
.carousel-container {
  position: relative;
  /* à¹€à¸žà¸·à¹ˆà¸­à¹ƒà¸«à¹‰à¸›à¸¸à¹ˆà¸¡à¸›à¸£à¸²à¸�à¸�à¹€à¸‰à¸žà¸²à¸°à¹€à¸¡à¸·à¹ˆà¸­ hover */
  max-width: calc(300px * 3 + 100px);
}

.carousel-container:hover .scroll-btn {
  opacity: 1;
  /* à¹‚à¸Šà¸§à¹Œà¸›à¸¸à¹ˆà¸¡à¹€à¸¡à¸·à¹ˆà¸­ hover */
}

.carousel-track {
  scroll-behavior: smooth;
  max-width: calc(300px * 3);
  gap: 24px;
}

/* à¸›à¸¸à¹ˆà¸¡à¹€à¸¥à¸·à¹ˆà¸­à¸™à¸‹à¹‰à¸²à¸¢/à¸‚à¸§à¸²à¹€à¸«à¸¡à¸·à¸­à¸™ carousel */
.scroll-btn {
  position: absolute;
  top: 0;
  bottom: 0;
  margin-top: auto;
  /* à¸ˆà¸±à¸”à¹ƒà¸«à¹‰à¸­à¸¢à¸¹à¹ˆà¸�à¸¶à¹ˆà¸‡à¸�à¸¥à¸²à¸‡à¹�à¸™à¸§à¸•à¸±à¹‰à¸‡ */
  margin-bottom: auto;
  /* à¸ˆà¸±à¸”à¹ƒà¸«à¹‰à¸­à¸¢à¸¹à¹ˆà¸�à¸¶à¹ˆà¸‡à¸�à¸¥à¸²à¸‡à¹�à¸™à¸§à¸•à¸±à¹‰à¸‡ */
  width: 48px;
  /* à¸„à¸§à¸²à¸¡à¸�à¸§à¹‰à¸²à¸‡à¸›à¸¸à¹ˆà¸¡ */
  height: 48px;
  /* à¸„à¸§à¸²à¸¡à¸�à¸§à¹‰à¸²à¸‡à¸›à¸¸à¹ˆà¸¡ */
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(0, 0, 0, 0.1);
  color: #fff;
  cursor: pointer;

  /* à¸•à¸±à¹‰à¸‡à¸„à¹ˆà¸²à¹€à¸£à¸´à¹ˆà¸¡à¸•à¹‰à¸™à¹ƒà¸«à¹‰à¸›à¸¸à¹ˆà¸¡à¹€à¸›à¹‡à¸™à¹‚à¸›à¸£à¹ˆà¸‡à¹ƒà¸ª à¹�à¸¥à¹‰à¸§à¸„à¹ˆà¸­à¸¢à¹‚à¸œà¸¥à¹ˆà¸¡à¸²à¹€à¸¡à¸·à¹ˆà¸­ hover */
  opacity: 0;
  transition: opacity 0.3s ease;
}

.scroll-btn:first-of-type {
  left: calc(0%);
}

.scroll-btn:last-of-type {
  right: calc(0%);
}

@keyframes fade-in {
  from {
    opacity: 0;
    transform: translate(-50%, 20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }

  to {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
}

.minimal-fab {
  box-shadow: none !important;
  height: 32px !important;
  width: 32px !important;
  min-width: 32px !important;
  margin-left: 4px;
  border: 0 !important;
  background-color: transparent !important;
}

.minimal-fab .v-icon {
  font-size: 16px;
  color: #71717a;
}

/* product card */

.product-recommendations {
  margin: 16px 0 0 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 12px;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}

.product-title {
  margin: 0;
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
}

.product-title::before {
  content: "";
  width: 4px;
  height: 16px;
  background-color: var(--v-primary-base);
  margin-right: 8px;
  display: inline-block;
  border-radius: 2px;
}

.product-carousel {
  padding: 12px 16px;
}

.product-scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  padding: 5px 0 16px 10px;
}

.product-item {
  flex: 0 0 auto;
  margin-right: 12px;
  width: 250px;
}

.product-card-compact {
  display: flex;
  height: 100px;
  position: relative;
  cursor: pointer;
}

.product-img-container {
  width: 80px;
  height: 80px;
  overflow: hidden;
  margin: 10px;
}

.product-thumbnail {
  border-radius: 4px;
  object-fit: cover;
}

.product-info {
  flex: 1;
  padding: 10px 10px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-name-compact {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.2;
  max-height: 40px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-price {
  color: var(--v-primary-base);
  font-weight: 600;
  font-size: 14px;
}

.product-interest-btn {
  position: absolute;
  bottom: 8px;
  right: 8px;
}

.product-full-description {
  white-space: pre-line;
  line-height: 1.6;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.product-recommendations {
  animation: fadeIn 0.5s ease-out;
}

.container-chat {
  height: calc(-114px + 100dvh);
  display: grid;
  grid-template-columns: 80dvw 10dvw 5dvw;
  grid-template-rows: auto 1fr auto auto;
  grid-template-areas:
    "header header header"
    "main main main"
    "products products products"
    "footer footer footer";
  align-content: space-between;
  justify-content: space-between;
  gap: 0;
  /* Remove any default gap */
}

/* Update product component styles */
.product-recommendations {
  margin: 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Update chat container to allow for proper space */
#ChatScreId {
  width: 100%;
  /* overflow-y: auto; */
  overflow-x: hidden;
  flex-grow: 1;
  display: flex;
  height: 100% !important;
  max-height: 100% !important;
  flex-direction: column;
  background-color: white;
  border-radius: 5px;
  margin-bottom: 0 !important;
  padding-bottom: 16px;
}

/* Adjust row styling to remove margins */
v-row[style*="grid-area: products"] {
  grid-area: products;
  margin: 0 !important;
  padding: 0 !important;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  z-index: 5;
}

/* Fix the textarea container top margin */
v-row[style*="grid-area: footer"] {
  grid-area: footer;
  margin: 0 !important;
  padding: 0 !important;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

/* .scroll-btn:hover {
  opacity: 1; 
} */
:deep(.v-footer) {
  overflow: visible !important;
}

/* Modern chatbox container */
.textarea-container-modern {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: visible;
  position: relative;
  width: 80%;
  max-height: 300px !important;
}

/* Modern chatbox wrapper */
.chatbox-modern-wrapper {
  width: 100%;
  position: relative;
}

/* Modern chatbox styling */
.chatbox-modern {
  border-radius: 20px !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

:deep(.chatbox-modern .v-input__control) {
  min-height: 56px !important;
}

:deep(.chatbox-modern .v-input__slot) {
  border-radius: 20px !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease;
}

:deep(.chatbox-modern .v-input__slot:hover) {
  border-color: rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

:deep(.chatbox-modern.v-input--is-focused .v-input__slot) {
  border-color: var(--v-primary-base) !important;
  box-shadow: 0 0 0 3px rgba(var(--v-primary-base), 0.1),
    0 12px 40px rgba(0, 0, 0, 0.15) !important;
}

:deep(.chatbox-modern .v-text-field__slot) {
  padding: 16px 20px !important;
}

:deep(.chatbox-modern textarea) {
  font-size: 16px !important;
  line-height: 1.5 !important;
  color: #333 !important;
}

/* Input label modern styling */
.input-label-modern {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 8px;
  backdrop-filter: blur(5px);
}

/* Model menu modern styling */
.model-menu-wrapper {
  margin-right: 8px;
}

.model-selector-btn {
  box-shadow: none !important;
}
.model-selector-btn :deep(.v-btn__overlay) {
  background-color: transparent !important;
}

.model-selector-btn:hover {
  transform: translateY(-2px);
  box-shadow: none !important;
  background-color: transparent !important;
}

.model-menu-card {
  border-radius: 16px !important;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.model-item-modern {
  transition: all 0.2s ease;
  border-radius: 12px !important;
}

.model-item-modern:hover {
  background: linear-gradient(135deg,
      var(--v-primary-base),
      var(--v-secondary-base)) !important;
  color: white !important;
  transform: translateX(4px);
}

.model-item-modern:hover .model-name,
.model-item-modern:hover .v-icon {
  color: white !important;
}

.model-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 18px;
  height: 18px;
}


.model-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.model-name {
  font-weight: 500;
  font-size: 14px;
}

/* Character counter modern styling */
.character-counter-modern {
  position: absolute;
  bottom: 8px;
  right: 80px;
}

.counter-chip {
  opacity: 0.8;
  transition: all 0.3s ease;
}

.counter-chip:hover {
  opacity: 1;
}

/* Action buttons modern styling */
.chatbox-actions-left {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
}

.chatbox-actions-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 8px;
}

.action-btn-modern {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease !important;
}

.action-btn-modern:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.action-btn-modern:disabled {
  opacity: 0.4 !important;
  transform: none !important;
}

.attachment-btn {
  background: linear-gradient(135deg, #667eea, #764ba2) !important;
}

.clear-btn {
  background: linear-gradient(135deg, #f093fb, #f5576c) !important;
}

.send-btn-modern {
  width: 48px !important;
  height: 48px !important;
  transition: all 0.3s ease !important;
}

.send-btn-modern:hover {
  transform: translateY(-2px) scale(1.05);
}

.stop-btn-modern {
  width: 48px !important;
  height: 48px !important;
  transition: all 0.3s ease !important;
}

.stop-btn-modern:hover {
  transform: translateY(-2px) scale(1.05);
}

/* Attachment preview modern styling */
.attachment-preview-modern {
  align-self: flex-start;
}

.attachment-image-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.attachment-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.attachment-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.attachment-close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px !important;
  height: 24px !important;
  background: rgba(0, 0, 0, 0.6) !important;
}

/* File preview modern styling */
.file-preview-modern {
  align-self: flex-start;
  width: 100%;
  max-width: 320px;
}

.file-info-wrapper {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 12px;
  backdrop-filter: blur(10px);
  gap: 12px;
}

.file-icon-wrapper {
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-type-icon {
  width: 32px;
  height: 32px;
  transition: all 0.3s ease;
}

.file-progress-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.file-details {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 14px;
  font-weight: 500;
  color: white;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-progress-bar {
  border-radius: 2px;
}

.file-close-btn {
  width: 24px !important;
  height: 24px !important;
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

/* Attachment menu modern styling */
.attachment-menu-card {
  border-radius: 16px !important;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.attachment-menu-item {
  transition: all 0.2s ease;
  margin-bottom: 4px;
}

.attachment-menu-item:hover {
  background: linear-gradient(135deg,
      var(--v-primary-base),
      var(--v-secondary-base)) !important;
  color: white !important;
  transform: translateX(4px);
}

.attachment-menu-item:hover .attachment-item-title,
.attachment-menu-item:hover .v-icon {
  color: white !important;
}

.attachment-item-title {
  font-size: 14px;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 768px) {

  .chatbox-actions-left,
  .chatbox-actions-right {
    gap: 4px;
  }

  .send-btn-modern,
  .stop-btn-modern {
    width: 40px !important;
    height: 40px !important;
  }

  .file-info-wrapper {
    padding: 8px;
  }

  .character-counter-modern {
    right: 60px;
  }
}

/* Animation for smooth transitions */
@keyframes slideInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.chatbox-modern-wrapper {
  animation: slideInUp 0.5s ease-out;
}

.new-input-bar {
  margin-top: auto;
  display: flex;
  flex-direction: column !important;
  justify-content: flex-end;
  background-color: #b69143;
  border-radius: 24px;
  padding: 10px 12px;
  margin: 8px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  gap: 12px;
  transition: height 0.2s ease-out;
  width: 100%;
  height: auto;
  max-height: 300px !important;
}

.input-bar-preview-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* ระยะห่างระหว่าง previews ถ้ามีหลายอัน */
}

/* Styles for individual previews to look like chips */
.attachment-preview-modern,
.file-preview-modern {
  background-color: #f0f2f5;
  /* สีพื้นหลังอ่อนๆ สำหรับ preview chip */
  border-radius: 12px;
  padding: 8px 12px;
  display: flex;
  /* For internal alignment */
  align-items: center;
  position: relative;
  /* For progress bar positioning in file preview */
  overflow: hidden;
  /* Ensure progress bar stays within rounded corners */
}

.attachment-image-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.attachment-image {
  max-height: 40px;
  /* จำฝัดขนาดรูปภาพ preview */
  max-width: 100px;
  border-radius: 4px;
  object-fit: cover;
}

.attachment-close-btn-light {
  background-color: rgba(0, 0, 0, 0.1) !important;
  color: #5f6368 !important;
}

.attachment-close-btn-light .v-icon {
  color: #5f6368 !important;
}

.file-info-wrapper-light {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
}

.file-type-icon-light {
  width: 32px;
  /* ขนาดไอคอนไฟล์ */
  height: 32px;
  object-fit: contain;
}

.file-details-light {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
  /* Prevent long filenames from breaking layout */
}

.file-name-light {
  font-size: 0.875rem;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-type-description {
  font-size: 0.75rem;
  color: #666;
}

.file-close-btn-light {
  color: #5f6368 !important;
  background-color: transparent !important;
}

.file-close-btn-light .v-icon {
  color: #5f6368 !important;
}

.file-progress-bar-light {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-radius: 0 0 12px 12px !important;
  /* Match parent's bottom radius */
}

.attachment-progress,
.file-progress-overlay-light {
  color: #007bff !important;
  /* สีของ progress spinner */
}

.input-actions-left,
.input-actions-right {
  display: flex;
  align-items: center;
  align-self: flex-end;
  gap: 9px;
  flex-shrink: 0;
}

.chatbox-redesigned :deep(.v-field) {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
  font-size: 20px;
  max-height: 100px !important;
  overflow-y: auto !important;
}

.chatbox-redesigned :deep(.v-field__outline) {
  border: none !important;
  opacity: 0 !important;
}

.chatbox-redesigned :deep(.v-field__overlay) {
  background-color: transparent !important;
  opacity: 0 !important;
}

.chatbox-redesigned :deep(.v-field__field) {
  border: none !important;
  background-color: transparent !important;
}

/* Remove all focus states */
.chatbox-redesigned :deep(.v-field--focused) {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.chatbox-redesigned :deep(.v-field--focused .v-field__outline) {
  border: none !important;
  opacity: 0 !important;
}

/* Remove any default input control styling */
.chatbox-redesigned :deep(.v-input__control) {
  min-height: auto !important;
  background-color: transparent !important;
}

.chatbox-redesigned :deep(.v-input__slot) {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}

.input-bar-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.input-actions-left,
.input-actions-right {
  display: flex;
  align-items: center;
  gap: 2px;
  /* ลด gap ระหว่างปุ่ม action */
}

.action-btn-flat {
  color: #5f6368 !important;
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 38px;
  /* ขนาดปุ่มขั้นต่ำ */
  height: 38px;
  padding: 0 8px;
  /* Padding สำหรับปุ่มที่มีข้อความ */
}

.action-btn-flat.tools-btn .v-icon {
  /* สำหรับปุ่ม Tools ที่มี icon และ text */
  margin-right: 4px;
}

.action-btn-flat:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
  /* สีพื้นหลังเมื่อ hover */
}

.action-btn-flat .v-icon {
  font-size: 20px;
}

.send-btn-redesigned.v-btn--fab.v-btn--size-small {
  height: 38px !important;
  width: 38px !important;
  min-width: 38px !important;
}

.send-btn-redesigned.v-btn--fab .v-icon {
  font-size: 20px;
}

/* Main ChatGPT-style container */
.chatgpt-container {
  /*display: flex;
  flex-direction: column;
  min-height: calc(100vh - var(--app-bar-height, 64px));
  height: calc(100vh - var(--app-bar-height, 64px));
  background-color: white;
  position: relative;*/

  display: flex;
  flex-direction: column;
  height: 100vh;
}

/* 1. ส่วนบนสุด (Fixed Top Div) */
.custom-fixed-top-area {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  width: 100%;
  background-color: white;
  height: 56px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  z-index: 10;
  /*box-shadow: 0 15px 8px -5px rgba(255, 255, 255, 1);*/
}

/* 2. ส่วนฝลาง (Scrollable Middle Content) */
.main-scrollable-content-area {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
  position: relative;
  background-color: white;
}

/* Messages container (scrollable area) */
.messages-container {
  /*flex: 1 0 auto;*/
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  /* min-height: 0;*/
}

.messages-wrapper {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 100%;
}

.messages-scroll-area {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 16px;
  scroll-behavior: smooth;
}

.messages-content {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
}

/* Welcome screen styling */
.welcome-screen {
  /* flex: 1 1 auto; */
  display: flex;
  flex-direction: column;
  background-color: white;
  height: 70vh;
  justify-content: center;
}

.welcome-content {
  text-align: center;
  margin-bottom: 40px;
}

.welcome-title {
  font-size: 2rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.welcome-subtitle {
  font-size: 1.125rem;
  color: #6b7280;
  font-weight: 400;
}


/* Product recommendations section */
.product-recommendations-section {
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  padding: 16px;
  margin: 0 16px;
  border-radius: 12px 12px 0 0;
  max-width: 100%;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.product-card {
  background: white;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  max-width: 100%;
  height: 100%;
}

.product-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.product-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}


.product-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 8px;
}

.container-product-image {
  width: 100%;
  height: 120px;
}

.no-product-image {
  width: 100%;
  height: 100%;
  /* height: 120px; */
  object-fit: fill;
  border-radius: 6px;
  margin-bottom: 8px;
  border-radius: 20px;
  background-color: #e5e7eb;
}

.product-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-description {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 640px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .product-image {
    height: 100px;
  }
}

@media (max-width: 400px) {
  .product-grid {
    grid-template-columns: 1fr;
  }
}

.product-price {
  font-weight: 600;
  color: #111827;
  margin-top: auto;
}

.recommendations-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

/* Fixed bottom input container */
.fixed-input-container {
  flex-shrink: 0;
  position: sticky;
  bottom: 0;
  width: 100%;
  background-color: white;
  padding: 0 16px;
  padding-bottom: 10px;
  z-index: 100;
  border-top: 0px solid #e0e0e0;
  box-shadow: 0 -24px 15px -5px rgba(255, 255, 255, 1);
}

.input-wrapper-chatgpt {
  width: 70%;
  margin: 0 auto;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  margin-bottom: 20px;
  position: relative;
  /* padding-bottom: 40px; */
  /* ลบหรือคอมเมนต์บรรทัดนี้ออฝ ถ้ามีอยู่ */
}

.input-wrapper-chatgpt:focus-within {
  border-color: #0000007c;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* File preview container */
.file-preview-container {
  padding: 12px 16px 8px;
  border-bottom: 1px solid #e2e2e2;
  position: relative;
  margin-bottom: 12px;
  border-radius: 0px;
  background: transparent;
  box-shadow: none;
}

.file-preview-container:hover {
  transform: translateY(0px);
  box-shadow: none;
}

.image-preview-wrapper,
.file-preview-wrapper {
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 4px;
}

.image-preview-card {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.preview-close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.6) !important;
  color: white !important;
  z-index: 3;
}

.file-preview-card {
  display: flex;
  align-items: center;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 12px;
  max-width: 300px;
  position: relative;
  overflow: hidden;
}

.file-preview-content {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 12px;
}

.file-icon-section {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-type-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.file-loading-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.file-info-section {
  flex: 1;
  min-width: 0;
}

.file-name-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  margin-bottom: 4px;
}

.file-upload-progress {
  border-radius: 2px;
  max-width: 80%;
}

/* Main input row */
.input-row-container {
  display: flex;
  align-items: flex-end;
  padding: 0px 12px;
  gap: 8px;
  min-height: 45px;
}

.input-actions-left,
.input-actions-right {
  display: flex;
  align-items: center;
  gap: 4px;
}

.input-action-btn {
  color: #6b7280 !important;
  transition: all 0.2s ease;
}

.input-action-btn:hover {
  color: #374151 !important;
  background-color: #f3f4f6 !important;
}

/* Textarea container */
.textarea-container-chatgpt {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  align-self: flex-start;
  min-height: unset !important;
}

.chatgpt-textarea {
  background: transparent !important;
}

.chatgpt-textarea :deep(.v-input__control) {
  width: 100%;
  min-height: unset !important;
}

.chatgpt-textarea :deep(.v-field__field) {
  min-height: unset !important;
}

.chatgpt-textarea :deep(.v-field) {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  min-height: unset !important;
}

.chatgpt-textarea :deep(.v-field__input) {
  -webkit-mask-image: none !important;
}

.chatgpt-textarea :deep(.v-field__outline) {
  display: none !important;
}

.chatgpt-textarea :deep(.v-field__overlay) {
  display: none !important;
}

.chatgpt-textarea :deep(textarea) {
  font-size: 16px !important;
  line-height: 1.4 !important;
  color: #374151 !important;
  border: none !important;
  outline: none !important;
  background: transparent !important;
  resize: none !important;
  overflow: hidden !important;
  overflow-y: auto !important;
  height: auto !important;
}

.chatgpt-textarea :deep(textarea::-webkit-scrollbar) {
  width: 5px !important;
}

.chatgpt-textarea :deep(textarea::-webkit-scrollbar-thumb) {
  background-color: #b4c7d6 !important;
  border-radius: 3px !important;
}

.chatgpt-textarea :deep(textarea::-webkit-scrollbar-track) {
  background-color: transparent !important;
}

.chatgpt-textarea :deep(textarea::placeholder) {
  color: #000000 !important;
  font-size: 16px !important;
}

/* Send button */
.send-button-chatgpt {
  background-color: #374151 !important;
  color: white !important;
  transition: all 0.2s ease !important;
  border-radius: 50% !important;
}

.send-button-chatgpt:hover {
  background-color: #1f2937 !important;
  transform: scale(1.05);
}

.send-button-chatgpt:disabled {
  background-color: #d1d5db !important;
  color: #9ca3af !important;
  transform: none !important;
}
/* Stop button - inherit from send button */
.stop-button-variant {
  background-color: #dc3545 !important; /* สีแดงสำหรับ stop */
  color: white !important;
  transition: all 0.2s ease !important;
  border-radius: 50% !important;
}

.stop-button-variant:hover {
  background-color: #c82333 !important; /* สีแดงเข้มเมื่อ hover */
  transform: scale(1.05);
}

.stop-button-variant:disabled {
  background-color: #d1d5db !important;
  color: #9ca3af !important;
  transform: none !important;
}

/* Send button (existing style) */
.send-button-chatgpt {
  background-color: #374151 !important;
  color: white !important;
  transition: all 0.2s ease !important;
  border-radius: 50% !important;
}

.send-button-chatgpt:hover {
  background-color: #1f2937 !important;
  transform: scale(1.05);
}

/* Skip button - inherit from send button */
.skip-button-variant {
  background-color: #6c757d !important; /* สีเทาสำหรับ skip */
  color: white !important;
  transition: all 0.2s ease !important;
  border-radius: 50% !important;
}

.skip-button-variant:hover {
  background-color: #5a6268 !important; /* สีเทาเข้มเมื่อ hover */
  transform: scale(1.05);
}

.skip-button-variant:disabled {
  background-color: #d1d5db !important;
  color: #9ca3af !important;
  transform: none !important;
}

/* Attachment and model menus */
.attachment-menu,
.model-selection-menu {
  border-radius: 16px !important;
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden;
}

.attachment-list,
.model-list {
  padding: 8px !important;
}

.attachment-list-item,
.model-list-item {
  border-radius: 8px !important;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

.attachment-list-item:hover,
.model-list-item:hover {
  background-color: #f3f4f6 !important;
}

.attachment-item-text,
.model-name-text {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.model-avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.model-expand-item {
  border-top: 1px solid #e5e7eb;
  margin-top: 8px;
  padding-top: 8px;
}

/* AI disclaimer */
.footer-chatbox-section {
  display: flex;
  text-align: center;
  justify-content: space-between;
  padding: 8px 16px;
  font-size: 12px;
  color: #6b7280;
  /* position: absolute; */
  /* bottom: 0px; */
  /* margin-bottom: -30px; */
  /* left: 50%; */
  /* transform: translateX(-50%); */
  /* width: auto;
  white-space: nowrap; */
}

.limit-input-text {
  font-size: 12px;
  color: #9ca3af;
  position: absolute;
  left: 40px;
  transform: translateX(-50%);
  margin-bottom: -22px;
  bottom: 0;
}

.disclaimer-text {
  font-size: 12px;
  color: #9ca3af;
  position: absolute;
  left: 50%;
  width: 300px;
  transform: translateX(-50%);
  margin-bottom: -22px;
  bottom: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .input-wrapper-chatgpt {
    width: 100%;
    border-radius: 20px;
  }

  .fixed-input-container {
    padding: 16px 8px 12px;
  }

  .input-row-container {
    padding: 8px 12px;
    gap: 8px;
  }

  .input-actions-left,
  .input-actions-right {
    gap: 2px;
  }

  .send-button-chatgpt {
    width: 28px !important;
    height: 28px !important;
  }

  .chatgpt-textarea :deep(textarea) {
    font-size: 16px !important;
  }
}

@media (max-width: 480px) {
  .welcome-title {
    font-size: 1.5rem;
  }

  .welcome-subtitle {
    font-size: 1rem;
  }
  .product-grid {
    grid-template-columns: 1fr;
  }

  .disclaimer-text {
    font-size: 10px;
    width: 160px;
    bottom: -6px;
    line-height: 1;
  }
}

.modern-dialog :deep(.v-overlay__content) {
  margin: 24px;
}

.upload-dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
}

.dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #60aaff 100%);
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
}

.dialog-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.05"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  pointer-events: none;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.header-content {
  flex: 1;
  color: white;
  z-index: 1;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: white;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.9;
  margin: 0;
  font-weight: 400;
  color: white;
}

.dialog-content {
  padding: 32px 24px !important;
}

.form-group {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.language-selector :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.language-selector :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.language-selector :deep(.v-field--focused) {
  box-shadow: 0 0 0 3px rgba(103, 126, 234, 0.1), 0 4px 12px rgba(0, 0, 0, 0.12);
}

.language-selector :deep(.v-field__outline) {
  border-color: #e5e7eb;
}

.language-selector :deep(.v-field--focused .v-field__outline) {
  border-color: #667eea;
  border-width: 2px;
}

.dialog-actions {
  padding: 16px 24px 24px !important;
  gap: 12px;
}

.lang-action-btn {
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  padding: 12px 20px !important;
  min-width: 100px;
  transition: all 0.3s ease !important;
}

.secondary-btn {
  border-color: #d1d5db !important;
  color: #6b7280 !important;
}

.secondary-btn:hover {
  background-color: #f9fafb !important;
  border-color: #9ca3af !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.primary-btn {
  background: linear-gradient(135deg, #667eea 0%, #60aaff 100%) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(103, 126, 234, 0.3) !important;
}

.primary-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(103, 126, 234, 0.4) !important;
}

.primary-btn:active {
  transform: translateY(0);
}

/* Animation for dialog entrance */
.modern-dialog :deep(.v-dialog-transition-enter-active),
.modern-dialog :deep(.v-dialog-transition-leave-active) {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.modern-dialog :deep(.v-dialog-transition-enter-from) {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}

.modern-dialog :deep(.v-dialog-transition-leave-to) {
  opacity: 0;
  transform: scale(0.9) translateY(-20px);
}

/* Responsive design */
@media (max-width: 600px) {
  .modern-dialog :deep(.v-overlay__content) {
    margin: 16px;
  }

  .dialog-header {
    padding: 20px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .dialog-content {
    padding: 24px 20px !important;
  }

  .dialog-actions {
    flex-direction: column;
    gap: 8px;
  }

  .lang-action-btn {
    width: 100%;
  }
}

.scroll-bottom-btn {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: -50px;
  right: 50%;
  z-index: 10;
  transform: translateX(50%);
  border-radius: 20px;
  width: 40px !important;
  height: 40px !important;
  background-color: rgba(255, 255, 255, 0.967) !important;
  border: 1px solid rgba(0, 0, 0, 0.369);
  box-shadow: none;
  transition: box-shadow 0.3s ease;
}

.scroll-bottom-btn:hover {
  box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.3);
}

.model-card-container {
  position: relative;
  width: auto;
  min-width: 250px;
  border-radius: 8px;
  box-shadow: 0 6px 9px rgba(0,0,0,0.3) !important;
}

.model-list-container {
  scrollbar-width: thin;
}

.model-list-container::-webkit-scrollbar {
  width: 3px;
}

.model-list-container::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.15);
  border-radius: 1.5px;
}

.model-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 4px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.model-item:hover {
  background-color: rgba(0,0,0,0.02) !important;
}

.model-item-active {
  background-color: rgba(0, 0, 0, 0.05);
}
.model-avatar-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.model-item.minimal {
  transition: all 0.15s ease-in-out;
  border-radius: 6px !important;
  margin: 2px 4px !important;
}

.model-item.minimal:hover {
  background-color: rgba(0,0,0,0.03) !important;
}

.model-content {
  flex-grow: 1;
}

.model-title {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.model-action {
  display: flex;
  align-items: center;
  justify-content: center;
}

.divider-light {
  border-color: rgba(0,0,0,1) !important;
}

.model-view-toggle .v-input--selection-controls__input {
  margin-right: 0px;
}

.model-view-toggle .v-label {
  font-size: 12px !important;
  color: rgba(0,0,0,0.6) !important;
}
.modern-model-search :deep(.v-field) {
  padding: 0 !important;
  margin: 0 !important;
  height: 32px !important; /* เล็ฝลง */
  min-height: 32px !important;
  border-radius: 8px !important; /* โค้งมนน้อยลง */
  background: #f8f9fa !important;
  border: 1px solid #e9ecef !important;
  box-shadow: none !important;
  width: 100% !important; /* เต็มความฝว้าง */
}
.modern-model-search :deep(.v-field__field) {
  display: flex !important;
  align-items: center !important;
  height: 32px !important;
  padding: 0 8px !important; /* padding เล็ฝลง */
}
.modern-model-search :deep(.v-field .v-icon) {
  color: rgb(163, 163, 163) !important;
}
.modern-model-search :deep(.v-field--focused) {
  border-color: var(--v-primary-base, #007bff) !important;
  background: #fff !important;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1) !important;
}
.modern-model-search :deep(input::placeholder) {
  font-size: 13px !important;
  color: #adb5bd !important;
}

.modern-model-search :deep(.v-field--focused .v-icon) {
  color: var(--v-primary-base, #007bff) !important;
}
.modern-model-search :deep(.v-field__input) {
  display: flex !important;
  align-items: center !important;
  font-size: 13px !important; /* ฟอนต์เล็ฝลง */
  color: #495057 !important;
  height: 32px !important;
  padding: 0 !important;
  min-height: 32px !important;
}
.modern-model-search :deep(.v-field .v-field__input) {
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
}
.modern-model-search :deep(.v-field__outline) {
  display: none !important;
}

.modern-model-search :deep(.v-field__overlay) {
  display: none !important;
}
.modern-model-search :deep(.v-field--focused .v-field--variant-filled .v-field__overlay) {
  background-color: transparent !important;
}
.modern-model-search :deep(.v-icon) {
  margin-left: 10px !important;
  font-size: 16px !important;
  color: #6c757d !important;
  margin-right: 4px !important;
}
.custom-card-actions {
  height: 30px !important;
  display: flex;
  align-items: center;
  padding: 4px 0px !important;
}

.model-view-toggle {
  transform: scale(0.8) !important; /* ลดขนาด checkbox */
  margin-left: -13px !important;
  margin-right: 4px !important;
}

.model-view-toggle :deep(.v-input--selection-controls__input) {
  margin-right: 2px !important;
}

.model-view-toggle :deep(.v-label) {
  font-size: 11px !important; /* ลดขนาดฟอนต์ */
  color: rgba(0,0,0,0.6) !important;
}

.model-view-toggle :deep(.v-icon) {
  font-size: 16px !important; /* ลดขนาด icon checkbox */
}

/* ปุ่ม Close เล็ฝลง */
.model-close-btn {
  font-size: 11px !important;
  min-width: 40px !important;
  padding-bottom: 5px;
  margin-right: 5px;
  background-color: transparent !important;
}

.frameloader {
  width: 160px;
  aspect-ratio: 1;
  border-radius: 8px;
  background:
    linear-gradient(to bottom right,#0000 calc(50% - 40px),#fffdf5a1 50%,#0000 calc(50% + 40px)) 
    bottom right/calc(200% + 80px) calc(200% + 80px) 
    rgba(0, 0, 0, 0.068);
  animation: l8 2s infinite ;
}
@keyframes l8 {
    100% {background-position: top left}
}

.imgloader {
  width: 84px;
  height: 84px;
  position: relative;
  background: #fff2c8;
  border-radius: 4px;
  overflow: hidden;
  z-index: 5;
}
.imgloader:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 50px;
  height: 50px;
  transform: rotate(45deg) translate(30%, 40%);
  background: #ffd971;
  box-shadow: 32px -34px 0 5px #ffae00;
  animation: slide 2s infinite ease-in-out alternate;
}
.imgloader:after {
  content: "";
  position: absolute;
  left: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffa600;
  transform: rotate(0deg);
  transform-origin: 35px 145px;
  animation: rotate 2s infinite ease-in-out;
}
@keyframes slide {
  0% , 100%{ bottom: -55px}
  25% , 75%{ bottom: -2px}
  20% , 80%{ bottom: 2px}
}
@keyframes rotate {
  0% { transform: rotate(-15deg)}
  25% , 75%{ transform: rotate(0deg)}
  100% {  transform: rotate(35deg)}
}

.botloader {
    width: 30px;
    height: 30px;
    background: linear-gradient(45deg, #ffddb0, #f19d00, #ffa621);
    border-radius: 50%;
    position: relative;
    box-shadow: 0 0 20px 3px rgba(255, 172, 47, 0.5) inset,
      0 3px 2px rgba(255, 159, 124, 0.3),
      0 0 6px rgba(255, 252, 248, 0.6);
    overflow: hidden;
  }
  .botloader:before,
  .botloader:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 45%;
    top: 0;
    background: linear-gradient(45deg, rgba(255, 219, 152, 0.8), rgba(255, 175, 100, 0.6));
    animation: wave 5s linear infinite;
  }
  .botloader:before {
    border-radius: 30%;
    background: linear-gradient(45deg, rgba(255, 154, 22, 0.6), rgba(255, 190, 133, 0.4));
    animation: wave 5s linear infinite;
  }
  @keyframes wave {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
.botringloader {
  width: 50px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: 
    radial-gradient(farthest-side,#ffa516 94%,#0000) top/4px 4px no-repeat,
    conic-gradient(#0000 30%,#ffa516);
  -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 4px),#000 0);
  animation: l13 1s infinite linear;
}
@keyframes l13{ 
  100%{transform: rotate(1turn)}
}
@keyframes smoothRotate {
  0%, 100% {
    transform: rotate(325deg);
  }
  50% {
    transform: rotate(250deg);
  }
}
.rotating-element {
  animation: smoothRotate 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.model-label-fade-in {
  opacity: 0;
  animation: fadeInUp 0.2s ease-out forwards;
  animation-delay: 1.2s;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.product-default-image {
  width: 100%;
  height: 250px;
  object-fit: contain; 
}

.product-default-image-recommendation {
  width: 100%;
  height: 120px;
  object-fit: contain;  
}

.product-card-header {
    height: 100%;
    width: 100%;
    border-radius: 20px !important;
}

.product-card-actions {
  padding: 12px 20px !important;
}

.product-btn-actions {
  border-radius: 15px !important;
}

.product-btn-actions:hover {
  transform: scale(1.05);
}
</style>
